/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
!(function (t, e, s, i, o, n, r) {
  "use strict";
  function a(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      const e = t.querySelector("label"),
        s = t.querySelector("input, textarea");
      e &&
        s &&
        (s.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        s.value && s.value.length && e.classList.add("label--float"));
    });
  }
  !(function () {
    const t = { NODE_ENV: "production" };
    try {
      if (process)
        return (
          (process.env = Object.assign({}, process.env)),
          void Object.assign(process.env, t)
        );
    } catch (t) {}
    globalThis.process = { env: t };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let l = p();
  function c() {
    const t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = m('[data-section-type*="footer"]')),
      (t.headerHeight = m("[data-header-height]")),
      (t.stickyHeaderHeight = document.querySelector("[data-header-sticky]")
        ? t.headerHeight
        : 0),
      (t.collectionNavHeight = m("[data-collection-nav]")),
      (t.logoHeight = (function () {
        const t = m("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function h() {
    document.addEventListener("theme:resize", u), d();
  }
  function d() {
    const {
      windowHeight: t,
      headerHeight: e,
      logoHeight: s,
      footerHeight: i,
      collectionNavHeight: o,
    } = c();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function u() {
    const {
        windowHeight: t,
        headerHeight: e,
        logoHeight: s,
        footerHeight: i,
        collectionNavHeight: o,
      } = c(),
      n = p();
    (n !== l || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (l = n)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${o}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${i}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - s / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - i + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function p() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function m(t) {
    const e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let v = !1,
    g = !1;
  function f() {
    setTimeout(() => {
      if (v) return;
      if (!g) return void f();
      const t = document.querySelectorAll('img[loading="lazy"]');
      t.length && t.forEach((t) => {}), (v = !0);
    }, 3e3);
  }
  function y(t, e) {
    let s;
    return function () {
      if (t) {
        const i = () => t.apply(this, arguments);
        clearTimeout(s), (s = setTimeout(i, e));
      }
    };
  }
  function b() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function w() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  }
  function E() {
    return b() >= window.theme.sizes.small;
  }
  function S() {
    return b() < window.theme.sizes.small;
  }
  let L = b(),
    k = w();
  let A = window.pageYOffset,
    T = null,
    C = null,
    q = null,
    x = null,
    P = 0;
  function H(e) {
    setTimeout(() => {
      P && clearTimeout(P),
        t.disablePageScroll(e.detail, {
          allowTouchMove: (t) => "TEXTAREA" === t.tagName,
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function M(t) {
    const e = t.detail;
    e ? (P = setTimeout(I, e)) : I();
  }
  function I() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  const B = (t, e = "", s) => {
    const i = s || document.createElement("div");
    return (
      i.classList.add(e), t.parentNode.insertBefore(i, t), i.appendChild(t)
    );
  };
  function F(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      B(t, "rte__table-wrapper");
    });
    t.querySelectorAll(
      '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
    ).forEach((t) => {
      B(t, "rte__video-wrapper");
    });
  }
  function D(t) {
    const e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          const e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          const s = e.getAttribute("aria-controls"),
            i = document.querySelector(`#${s}`),
            o = () => {
              i.classList.remove("expanding"),
                i.removeEventListener("transitionend", o);
            },
            n = () => {
              i.classList.add("expanding"),
                i.removeEventListener("transitionstart", n);
            };
          i.addEventListener("transitionstart", n),
            i.addEventListener("transitionend", o),
            i.classList.toggle("expanded");
        });
      });
  }
  const O = "is-loading",
    $ = "img.is-loading";
  function _(t, e) {
    e = e || {};
    var s = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = s),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function i(o) {
        o.target.removeEventListener(o.type, i),
          (t.tabIndex = s),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function R(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          (s = window.getComputedStyle(e)),
          "none" === s.display || "hidden" === s.visibility)
        );
        var e, s;
      });
  }
  var N = {};
  function z() {
    document.removeEventListener("focusin", N.focusin),
      document.removeEventListener("focusout", N.focusout),
      document.removeEventListener("keydown", N.keydown);
  }
  var U = Object.freeze({
    __proto__: null,
    forceFocus: _,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        s = document.getElementById(e.slice(1));
      if (s && t.ignore && s.matches(t.ignore)) return !1;
      e && s && _(s, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if ("#" === e.hash || "" === e.hash) return !1;
            if (t.ignore && e.matches(t.ignore)) return !1;
            if (((s = e.hash.substr(1)), null === document.getElementById(s)))
              return !1;
            var s,
              i = document.querySelector(e.hash);
            return (
              !!i &&
              (e.addEventListener("click", function () {
                _(i, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: R,
    trapFocus: function (t, e) {
      e = e || {};
      var s = R(t),
        i = e.elementToFocus || t,
        o = s[0],
        n = s[s.length - 1];
      z(),
        (N.focusin = function (e) {
          t !== e.target &&
            !t.contains(e.target) &&
            o &&
            o === e.target &&
            o.focus(),
            (e.target !== t && e.target !== n && e.target !== o) ||
              document.addEventListener("keydown", N.keydown);
        }),
        (N.focusout = function () {
          document.removeEventListener("keydown", N.keydown);
        }),
        (N.keydown = function (e) {
          "Tab" === e.code &&
            (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
            (e.target !== t && e.target !== o) ||
              !e.shiftKey ||
              (e.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", N.focusout),
        document.addEventListener("focusin", N.focusin),
        _(i, e);
    },
    removeTrapFocus: z,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw new TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var s,
          i,
          o,
          n = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          r = e.prefix || "a11y",
          a = {
            newWindow: r + "-new-window-message",
            external: r + "-external-message",
            newWindowExternal: r + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            i = (function (t) {
              return t.hostname !== window.location.hostname;
            })(t),
            o = "_blank" === e,
            n = null === s || -1 === s.indexOf("noopener");
          if (o && n) {
            var r = null === s ? "noopener" : s + " noopener";
            t.setAttribute("rel", r);
          }
          i && o
            ? t.setAttribute("aria-describedby", a.newWindowExternal)
            : i
            ? t.setAttribute("aria-describedby", a.external)
            : o && t.setAttribute("aria-describedby", a.newWindow);
        }),
          (s = n),
          (i = document.createElement("ul")),
          (o = Object.keys(s).reduce(function (t, e) {
            return t + "<li id=" + a[e] + ">" + s[e] + "</li>";
          }, "")),
          i.setAttribute("hidden", !0),
          (i.innerHTML = o),
          document.body.appendChild(i);
      }
    },
  });
  const W = 'input[type="search"]',
    V = '[aria-selected="true"] a',
    j = 'button[type="reset"]',
    X = "hidden";
  let J = class extends HTMLElement {
    toggleResetButton() {
      const t = this.resetButton.classList.contains(X);
      this.input.value.length > 0 && t
        ? this.resetButton.classList.remove(X)
        : 0 !== this.input.value.length ||
          t ||
          this.resetButton.classList.add(X);
    }
    onChange() {
      this.toggleResetButton();
    }
    shouldResetForm() {
      return !document.querySelector(V);
    }
    onFormReset(t) {
      t.preventDefault(),
        this.shouldResetForm() &&
          ((this.input.value = ""),
          this.toggleResetButton(),
          t.target.querySelector(W).focus());
    }
    constructor() {
      super(),
        (this.input = this.querySelector(W)),
        (this.resetButton = this.querySelector(j)),
        this.input &&
          (this.input.form.addEventListener(
            "reset",
            this.onFormReset.bind(this)
          ),
          this.input.addEventListener(
            "input",
            y((t) => {
              this.onChange(t);
            }, 300).bind(this)
          ));
    }
  };
  customElements.define("header-search-form", J);
  const Q = '[role="option"]',
    G = '[aria-selected="true"]',
    Y = "[data-popular-searches]",
    K = "predictive-search",
    Z = "[data-predictive-search-results]",
    tt = "[data-predictive-search-status]",
    et = 'input[type="search"]',
    st = "[data-popdown]",
    it = "[data-predictive-search-live-region-count-value]",
    ot = "[data-search-results-groups-wrapper]",
    nt = "[data-predictive-search-search-for-text]",
    rt = "#shopify-section-predictive-search",
    at = '[aria-selected="true"] a',
    lt = '[aria-selected="true"] a, button[aria-selected="true"]';
  let ct = class extends J {
    connectedCallback() {
      this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("focusout", this.onFocusOut.bind(this)),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onChange() {
      super.onChange();
      const t = this.getQuery();
      var e;
      (this.searchTerm && t.startsWith(this.searchTerm)) ||
        null === (e = this.querySelector(ot)) ||
        void 0 === e ||
        e.remove();
      this.updateSearchForTerm(this.searchTerm, t),
        (this.searchTerm = t),
        this.searchTerm.length
          ? this.getSearchResults(this.searchTerm)
          : this.reset();
    }
    onFormSubmit(t) {
      (this.getQuery().length && !this.querySelector(at)) || t.preventDefault();
    }
    onFormReset(t) {
      super.onFormReset(t),
        super.shouldResetForm() &&
          ((this.searchTerm = ""),
          this.abortController.abort(),
          (this.abortController = new AbortController()),
          this.closeResults(!0));
    }
    shouldResetForm() {
      return !document.querySelector(at);
    }
    onFocus() {
      const t = this.getQuery();
      t.length &&
        (this.searchTerm !== t
          ? this.onChange()
          : "true" === this.getAttribute("results")
          ? this.open()
          : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
      setTimeout(() => {
        this.contains(document.activeElement) || this.close();
      });
    }
    onKeyup(t) {
      switch (
        (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
      }
    }
    onKeydown(t) {
      ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
    }
    updateSearchForTerm(t, e) {
      const s = this.querySelector(nt),
        i = null == s ? void 0 : s.innerText;
      if (i) {
        var o;
        if (
          (null === (o = i.match(new RegExp(t, "g"))) || void 0 === o
            ? void 0
            : o.length) > 1
        )
          return;
        const n = i.replace(t, e);
        s.innerText = n;
      }
    }
    switchOption(t) {
      if (!this.getAttribute("open")) return;
      const e = "up" === t,
        s = this.querySelector(G),
        i = Array.from(this.querySelectorAll(Q)).filter(
          (t) => null !== t.offsetParent
        );
      let o = 0;
      if (e && !s) return;
      let n = -1,
        r = 0;
      for (; -1 === n && r <= i.length; ) i[r] === s && (n = r), r++;
      if (
        ((this.statusElement.textContent = ""),
        !e && s
          ? (o = n === i.length - 1 ? 0 : n + 1)
          : e && (o = 0 === n ? i.length - 1 : n - 1),
        o === n)
      )
        return;
      const a = i[o];
      a.setAttribute("aria-selected", !0),
        s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", a.id);
    }
    selectOption() {
      const t = this.querySelector(lt);
      t && t.click();
    }
    getSearchResults(t) {
      const e = t.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState(),
        this.cachedResults[e]
          ? this.renderSearchResults(this.cachedResults[e])
          : fetch(
              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                t
              )}&section_id=predictive-search`,
              { signal: this.abortController.signal }
            )
              .then((t) => {
                if (!t.ok) {
                  var e = new Error(t.status);
                  throw (this.close(), e);
                }
                return t.text();
              })
              .then((t) => {
                const s = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(rt).innerHTML;
                this.allPredictiveSearchInstances.forEach((t) => {
                  t.cachedResults[e] = s;
                }),
                  this.renderSearchResults(s);
              })
              .catch((t) => {
                if (20 !== (null == t ? void 0 : t.code))
                  throw (this.close(), t);
              });
    }
    setLiveRegionLoadingState() {
      (this.statusElement = this.statusElement || this.querySelector(tt)),
        (this.loadingText =
          this.loadingText || this.getAttribute("data-loading-text")),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute("loading", !0);
    }
    setLiveRegionText(t) {
      this.statusElement.setAttribute("aria-hidden", "false"),
        (this.statusElement.textContent = t),
        setTimeout(() => {
          this.statusElement.setAttribute("aria-hidden", "true");
        }, 1e3);
    }
    renderSearchResults(t) {
      (this.predictiveSearchResults.innerHTML = t),
        this.setAttribute("results", !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute("loading"),
        this.setLiveRegionText(this.querySelector(it).textContent);
    }
    open() {
      this.setAttribute("open", !0),
        this.input.setAttribute("aria-expanded", !0),
        (this.isOpen = !0);
    }
    close(t = !1) {
      this.closeResults(t), (this.isOpen = !1);
    }
    closeResults(t = !1) {
      var e;
      t && ((this.input.value = ""), this.removeAttribute("results"));
      const s = this.querySelector(G);
      s && s.setAttribute("aria-selected", !1),
        this.input.setAttribute("aria-activedescendant", ""),
        this.removeAttribute("loading"),
        this.removeAttribute("open"),
        this.input.setAttribute("aria-expanded", !1),
        (this.resultsMaxHeight = !1),
        null === (e = this.predictiveSearchResults) ||
          void 0 === e ||
          e.removeAttribute("style");
    }
    reset() {
      (this.predictiveSearchResults.innerHTML = ""),
        (this.input.val = ""),
        this.a11y.removeTrapFocus(),
        this.popularSearches &&
          (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
          this.a11y.trapFocus(this.searchPopdown, {
            elementToFocus: this.input,
          }));
    }
    constructor() {
      var t;
      super(),
        (this.a11y = U),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(K)),
        (this.cachedResults = {}),
        (this.input = this.querySelector(et)),
        (this.isOpen = !1),
        (this.predictiveSearchResults = this.querySelector(Z)),
        (this.searchPopdown = this.closest(st)),
        (this.popularSearches =
          null === (t = this.searchPopdown) || void 0 === t
            ? void 0
            : t.querySelector(Y)),
        (this.searchTerm = "");
    }
  };
  const ht = "[data-popout-list]",
    dt = "[data-popout-toggle]",
    ut = "[data-popout-toggle-text]",
    pt = "[data-popout-input]",
    mt = "[data-popout-option]",
    vt = "[data-product-image]",
    gt = "[data-product-grid-item]",
    ft = "popout-list--visible",
    yt = "is-visible",
    bt = "is-active",
    wt = "select-popout--top",
    Et = "aria-expanded",
    St = "aria-current",
    Lt = "data-value",
    kt = "data-popout-toggle-text",
    At = "submit";
  let Tt = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector(ht)),
          (this.popoutToggle = this.querySelector(dt)),
          (this.popoutToggleText = this.querySelector(ut)),
          (this.popoutInput = this.querySelector(pt)),
          (this.popoutOptions = this.querySelectorAll(mt)),
          (this.productGrid = this.popoutList.closest(gt)),
          (this.fireSubmitEvent = this.hasAttribute(At)),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        const e = "true" === t.currentTarget.getAttribute(Et);
        if (this.productGrid) {
          const t = this.productGrid.querySelector(vt);
          t && t.classList.toggle(yt, !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGrid.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(Et, !e),
          this.popoutList.classList.toggle(ft),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        const e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(ft) && !e && this._hideList();
      }
      toggleListPosition() {
        const t = "true" === this.querySelector(dt).getAttribute(Et),
          e = window.innerHeight,
          s = this.popoutList.getBoundingClientRect().bottom,
          i = () => {
            this.classList.remove(wt),
              this.popoutList.removeEventListener("transitionend", i);
          };
        t
          ? e < s && this.classList.add(wt)
          : this.popoutList.addEventListener("transitionend", i);
      }
      popupListMaxWidth() {
        this.popoutList.style.setProperty("--max-width", "100vw"),
          requestAnimationFrame(() => {
            this.popoutList.style.setProperty(
              "--max-width",
              `${parseInt(
                document.body.clientWidth -
                  this.popoutList.getBoundingClientRect().left
              )}px`
            );
          });
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(mt).attributes.href.value) {
          t.preventDefault();
          let e = "";
          if (
            (t.currentTarget.getAttribute(Lt) &&
              (e = t.currentTarget.getAttribute(Lt)),
            (this.popoutInput.value = e),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            const s = t.currentTarget.parentElement,
              i = this.popoutList.querySelector(`.${bt}`),
              o = this.popoutList.querySelector(`[${St}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              i && (i.classList.remove(bt), s.classList.add(bt)),
              "quantity" != this.popoutInput.name ||
                s.nextSibling ||
                this.classList.add(bt),
              o &&
                o.hasAttribute(`${St}`) &&
                (o.removeAttribute(`${St}`),
                t.currentTarget.setAttribute(`${St}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.textContent = e),
                this.popoutToggleText.hasAttribute(kt) &&
                  "" !== this.popoutToggleText.getAttribute(kt) &&
                  this.popoutToggleText.setAttribute(kt, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        const e = this.contains(t.target);
        this.popoutList.classList.contains(ft) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        const t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(ft),
          this.popoutToggle.setAttribute(Et, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    Ct = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", { bubbles: !0 })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        const e = this.input.value,
          s =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === s.name && this.input.stepUp(),
          "decrease" === s.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent),
          "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
      }
      constructor() {
        super();
      }
    };
  const qt = "[data-aos]:not(.aos-animate)",
    xt = "[data-aos-anchor]",
    Pt = "aos-animate",
    Ht = { attributes: !1, childList: !0, subtree: !0 },
    Mt = (t) => {
      for (const e of t)
        if ("childList" === e.type) {
          const t = e.target,
            s = t.querySelectorAll(qt),
            i = t.querySelectorAll(xt);
          s.length &&
            s.forEach((t) => {
              It.observe(t);
            }),
            i.length && Ft(i);
        }
    },
    It = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(Pt), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    Bt = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio > 0.1) {
            const s = t.target.querySelectorAll(qt);
            s.length &&
              s.forEach((t) => {
                t.classList.add(Pt);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function Ft(t) {
    let e = [];
    t.length &&
      t.forEach((t) => {
        const s = t.dataset.aosAnchor;
        if (s && -1 === e.indexOf(s)) {
          const t = document.querySelector(s);
          t && (Bt.observe(t), e.push(s));
        }
      });
  }
  let Dt = class extends HTMLElement {
    connectedCallback() {
      this.closest(".shopify-section").addEventListener(
        "mouseover",
        () => {
          this.classList.remove("hidden");
        },
        { once: !0 }
      );
    }
    constructor() {
      super();
    }
  };
  const Ot = "[data-deferred-media-button]",
    $t = "video, model-viewer, iframe",
    _t = '[data-host="youtube"]',
    Rt = '[data-host="vimeo"]',
    Nt = "[data-product-grid-item]",
    zt = ".shopify-section",
    Ut = "template",
    Wt = "video",
    Vt = "product-model",
    jt = "hidden",
    Xt = "loaded",
    Jt = "autoplay";
  let Qt = class extends HTMLElement {
    connectedCallback() {
      this.productGridItem &&
        (this.section.addEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.addEventListener("mouseenter", this.mouseEnterEvent),
        this.addEventListener("mouseleave", this.mouseLeaveEvent));
    }
    disconnectedCallback() {
      this.productGridItem &&
        (this.section.removeEventListener("mouseover", this.mouseOverEvent, {
          once: !0,
        }),
        this.removeEventListener("mouseenter", this.mouseEnterEvent),
        this.removeEventListener("mouseleave", this.mouseLeaveEvent));
    }
    mouseOverActions() {
      this.classList.remove(jt);
    }
    mouseEnterActions() {
      (this.hovered = !0),
        this.videoActions(),
        this.getAttribute(Xt) || this.loadContent();
    }
    mouseLeaveActions() {
      (this.hovered = !1), this.videoActions();
    }
    videoActions() {
      if (this.getAttribute(Xt)) {
        const t = this.querySelector(_t),
          e = this.querySelector(Rt),
          s = t || e,
          i = this.querySelector(Wt);
        if (s) {
          let t = this.hovered ? "playVideo" : "pauseVideo",
            i = `{"event":"command","func":"${t}","args":""}`;
          e &&
            ((t = this.hovered ? "play" : "pause"), (i = `{"method":"${t}"}`)),
            s.contentWindow.postMessage(i, "*"),
            s.addEventListener("load", (t) => {
              this.videoActions();
            });
        } else i && (this.hovered ? i.play() : i.pause());
      }
    }
    loadContent(t = !0) {
      if ((this.pauseAllMedia(), !this.getAttribute(Xt))) {
        const e = document.createElement("div"),
          s = this.querySelector(Ut).content.firstElementChild.cloneNode(!0);
        e.appendChild(s), this.setAttribute(Xt, !0);
        const i = this.appendChild(e.querySelector($t));
        t && i.focus(),
          "VIDEO" == i.nodeName && i.getAttribute(Jt) && i.play(),
          this.productGridItem && this.videoActions();
      }
    }
    pauseAllMedia() {
      document.querySelectorAll(_t).forEach((t) => {
        t.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          "*"
        );
      }),
        document.querySelectorAll(Rt).forEach((t) => {
          t.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll(Wt).forEach((t) => t.pause()),
        document.querySelectorAll(Vt).forEach((t) => {
          t.modelViewerUI && t.modelViewerUI.pause();
        });
    }
    constructor() {
      super();
      const t = this.querySelector(Ot);
      null == t || t.addEventListener("click", this.loadContent.bind(this)),
        (this.section = this.closest(zt)),
        (this.productGridItem = this.closest(Nt)),
        (this.hovered = !1),
        (this.mouseOverEvent = () => this.mouseOverActions()),
        (this.mouseEnterEvent = () => this.mouseEnterActions()),
        (this.mouseLeaveEvent = () => this.mouseLeaveActions());
    }
  };
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      (!(function () {
        const t = document.querySelectorAll(qt);
        t.length &&
          t.forEach((t) => {
            It.observe(t);
          });
      })(),
      (function () {
        const t = document.querySelectorAll(xt);
        t.length && Ft(t);
      })(),
      new MutationObserver(Mt).observe(document.body, Ht)),
    window.addEventListener(
      "resize",
      y(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          L !== b() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (L = b())),
          k !== w() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (k = w()));
      }, 50)
    ),
    (function () {
      let t;
      window.addEventListener(
        "scroll",
        function () {
          t && window.cancelAnimationFrame(t),
            (t = window.requestAnimationFrame(function () {
              !(function () {
                const t = window.pageYOffset;
                t > A
                  ? ((C = !0), (T = !1))
                  : t < A
                  ? ((C = !1), (T = !0))
                  : ((T = null), (C = null)),
                  (A = t),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll", {
                      detail: { up: T, down: C, position: t },
                      bubbles: !1,
                    })
                  ),
                  T &&
                    !q &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:up", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  C &&
                    !x &&
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:down", {
                        detail: { position: t },
                        bubbles: !1,
                      })
                    ),
                  (x = C),
                  (q = T);
              })();
            }));
        },
        { passive: !0 }
      ),
        window.addEventListener("theme:scroll:lock", H),
        window.addEventListener("theme:scroll:unlock", M);
    })(),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    d(),
    document.addEventListener(
      "load",
      (t) => {
        "IMG" == t.target.tagName &&
          t.target.classList.contains(O) &&
          (t.target.classList.remove(O),
          t.target.parentNode.classList.remove(O));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      h(),
        D(document),
        a(document),
        F(document),
        document.querySelectorAll($).forEach((t) => {
          t.complete &&
            (t.classList.remove(O), t.parentNode.classList.remove(O));
        }),
        document.body.classList.add("is-loaded"),
        window.fastNetworkAndCPU &&
          ((document.onreadystatechange = () => {
            "complete" === document.readyState && ((g = !0), f());
          }),
          requestIdleCallback(f)),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      const e = t.target;
      a(e), F(e), D(document), h();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", Tt),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", Ct),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", ct),
    customElements.get("deferred-image") ||
      customElements.define("deferred-image", Dt),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", Qt);
  const Gt = (t, e = !1, s = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = s));
  };
  Shopify.Products = (function () {
    const t = {
      howManyToShow: 4,
      howManyToStoreInMemory: 10,
      wrapperId: "recently-viewed-products",
      section: null,
      onComplete: null,
    };
    let e = [],
      s = null,
      i = null;
    const o = new Date(),
      n = new Date();
    n.setTime(o.getTime() + 7776e6);
    const r = {
        configuration: {
          expires: n.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          const e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          const e = this.read(),
            s = e.indexOf(t);
          -1 !== s && (e.splice(s, 1), this.write(e));
        },
      },
      a = (e, s, o, n) => {
        s.length && e < t.howManyToShow
          ? fetch(
              `${window.theme.routes.root}products/${s[0]}?section_id=api-product-grid-item`
            )
              .then((t) => t.text())
              .then((t) => {
                const i = 150 * e,
                  r = 100 * e + 800,
                  l = 50 * e + 800,
                  c = o.id ? `#${o.id}` : "",
                  h = document.createElement("div");
                let d = t.includes("||itemIndex||")
                  ? t.replaceAll("||itemIndex||", e)
                  : t;
                (d = d.includes("||itemAosDelay||")
                  ? d.replaceAll("||itemAosDelay||", i)
                  : d),
                  (d = d.includes("||itemAosImageDuration||")
                    ? d.replaceAll("||itemAosImageDuration||", r)
                    : d),
                  (d = d.includes("||itemAosTextDuration||")
                    ? d.replaceAll("||itemAosTextDuration||", l)
                    : d),
                  (d = d.includes("||itemAnimationAnchor||")
                    ? d.replaceAll("||itemAnimationAnchor||", c)
                    : d),
                  (h.innerHTML = d),
                  (o.innerHTML +=
                    h.querySelector("[data-api-content]").innerHTML),
                  s.shift(),
                  e++,
                  a(e, s, o, n);
              })
              .catch(() => {
                r.remove(s[0]), s.shift(), a(e, s, o, n);
              })
          : ((e, s) => {
              Gt(e, !0);
              const o = r.read().length;
              if (
                Shopify.recentlyViewed &&
                i &&
                o &&
                o < i &&
                e.children.length
              ) {
                let t = [],
                  s = [],
                  i = 0;
                for (const e in Shopify.recentlyViewed) {
                  i += 1;
                  const o = Shopify.recentlyViewed[e].split(" "),
                    n = parseInt(e.split("_")[1]);
                  (t = [...t, ...o]),
                    (r.read().length === n ||
                      (i === Object.keys(Shopify.recentlyViewed).length &&
                        !s.length)) &&
                      (s = [...s, ...o]);
                }
                for (let i = 0; i < e.children.length; i++) {
                  const o = e.children[i];
                  t.length && o.classList.remove(...t),
                    s.length && o.classList.add(...s);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, s);
                } catch (t) {
                  console.log(t);
                }
            })(o, n);
      };
    return {
      showRecentlyViewed: function (o) {
        const n = o || {};
        Object.assign(t, n),
          (e = r.read()),
          (s = document.querySelector(`#${t.wrapperId}`)),
          (i = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && s && a(0, e, s, t.section);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        r.destroy();
      },
      recordRecentlyViewed: function (e) {
        const s = e || {};
        Object.assign(t, s);
        let i = r.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let e = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (e = t.handle);
          const s = i.indexOf(e);
          -1 === s
            ? (i.unshift(e), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(s, 1), i.unshift(e)),
            r.write(i);
        }
      },
      hasProducts: r.read().length > 0,
    };
  })();
  const Yt = (t, e = [], s = !1) => {
      const i = Object.keys(t)
        .map((i) => {
          let o = t[i];
          if (
            "[object Object]" === Object.prototype.toString.call(o) ||
            Array.isArray(o)
          )
            return (
              Array.isArray(t) ? e.push("") : e.push(i),
              Yt(o, e, Array.isArray(o))
            );
          {
            let t = i;
            if (e.length > 0) {
              t = (s ? e : [...e, i]).reduce(
                (t, e) => ("" === t ? e : `${t}[${e}]`),
                ""
              );
            }
            return s ? `${t}[]=${o}` : `${t}=${o}`;
          }
        })
        .join("&");
      return e.pop(), i;
    },
    Kt = (t) => {
      t && (t.style.display = "none");
    },
    Zt = (t, e, s = null) => {
      (t.style.opacity = 0), (t.style.display = e || "block");
      let i = !0;
      !(function e() {
        let o = parseFloat(t.style.opacity);
        (o += 0.1) > 1 || ((t.style.opacity = o), requestAnimationFrame(e)),
          1 === parseInt(o) && i && "function" == typeof s && ((i = !1), s());
      })();
    };
  function te(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  te.prototype = Error.prototype;
  const ee = "[data-template-no-shipping]",
    se = ".get-rates",
    ie = "#address_container",
    oe = "#address_country",
    ne = "#address_province",
    re = "#address_zip",
    ae = "#wrapper-response",
    le = "#shipping-calculator-response-template",
    ce = "data-template-no-shipping",
    he = "data-default",
    de = "error",
    ue = "center",
    pe = "success",
    me = "disabled",
    ve = "get-rates--trigger",
    ge = "Error : country is not supported.",
    fe = "We do not ship to this destination.",
    ye = "Error : ";
  let be = class extends HTMLElement {
    connectedCallback() {
      const t = document.querySelector("html");
      let s = "en";
      if (
        (t.hasAttribute("lang") &&
          "" !== t.getAttribute("lang") &&
          (s = t.getAttribute("lang")),
        this.fieldsContainer &&
          e.AddressForm(this.fieldsContainer, s, { shippingCountriesOnly: !0 }),
        this.selectCountry &&
          this.selectCountry.hasAttribute(he) &&
          this.selectProvince &&
          this.selectProvince.hasAttribute(he) &&
          this.selectCountry.addEventListener(
            "change",
            this.onCountryChangeEvent
          ),
        this.getRatesButton &&
          (this.getRatesButton.addEventListener(
            "click",
            this.onButtonClickEvent
          ),
          theme.settings.customerLoggedIn &&
            this.getRatesButton.classList.contains(ve)))
      ) {
        const t = document.querySelector(re);
        t && t.value && this.getRatesButton.dispatchEvent(new Event("click"));
      }
    }
    disconnectedCallback() {
      this.selectCountry &&
        this.selectCountry.hasAttribute(he) &&
        this.selectProvince &&
        this.selectProvince.hasAttribute(he) &&
        this.selectCountry.removeEventListener(
          "change",
          this.onCountryChangeEvent
        ),
        this.getRatesButton &&
          this.getRatesButton.removeEventListener(
            "click",
            this.onButtonClickEvent
          );
    }
    onCountryChange() {
      this.selectCountry.removeAttribute(he),
        this.selectProvince.removeAttribute(he);
    }
    onButtonClick() {
      for (this.disableButtons(); this.wrapper.firstChild; )
        this.wrapper.removeChild(this.wrapper.firstChild);
      Kt(this.wrapper);
      const t = {};
      let e = this.selectCountry.value,
        s = this.selectProvince.value;
      const i = this.selectCountry.getAttribute(he);
      "" === e && i && "" !== i && (e = i);
      const o = this.selectProvince.getAttribute(he);
      "" === s && o && "" !== o && (s = o),
        (t.zip = document.querySelector(re).value || ""),
        (t.country = e || ""),
        (t.province = s || ""),
        this.getCartShippingRatesForDestination(t);
    }
    formatRate(t) {
      return "0.00" === t
        ? window.theme.strings.free
        : s.formatMoney(t, theme.moneyFormat);
    }
    render(t) {
      if (this.template && this.wrapper) {
        this.wrapper.innerHTML = "";
        let e = "",
          s = "",
          i = `${de} ${ue}`,
          o = this.template.innerHTML;
        const n = /[^[\]]+(?=])/g;
        if (t.rates && t.rates.length) {
          let s = n.exec(o)[0];
          t.rates.forEach((t) => {
            let i = s;
            (i = i.replace(/\|\|rateName\|\|/, t.name)),
              (i = i.replace(/\|\|ratePrice\|\|/, this.formatRate(t.price))),
              (e += i);
          });
        }
        if (t.success) {
          i = `${pe} ${ue}`;
          const e = document.createElement("div");
          e.innerHTML = this.template.innerHTML;
          const o = e.querySelector(ee);
          t.rates.length < 1 && o && (s = o.getAttribute(ce));
        } else s = t.errorFeedback;
        (o = o.replace(n, "").replace("[]", "")),
          (o = o.replace(/\|\|ratesList\|\|/g, e)),
          (o = o.replace(/\|\|successClass\|\|/g, i)),
          (o = o.replace(/\|\|ratesText\|\|/g, s)),
          (this.wrapper.innerHTML += o),
          Zt(this.wrapper);
      }
    }
    enableButtons() {
      this.getRatesButton.removeAttribute("disabled"),
        this.getRatesButton.classList.remove(me),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButton);
    }
    disableButtons() {
      this.getRatesButton.setAttribute("disabled", "disabled"),
        this.getRatesButton.classList.add(me),
        (this.getRatesButton.textContent =
          theme.strings.shippingCalcSubmitButtonDisabled);
    }
    getCartShippingRatesForDestination(t) {
      const e = encodeURI(Yt({ shipping_address: t })),
        s = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
      fetch(s)
        .then(this.handleErrors)
        .then((t) => t.text())
        .then((e) => {
          const s = JSON.parse(e).shipping_rates;
          this.onCartShippingRatesUpdate(s, t);
        })
        .catch((t) => {
          this.onError(t.json);
        });
    }
    fullMessagesFromErrors(t) {
      const e = [];
      for (const s in t) for (const i of t[s]) e.push(i);
      return e;
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new te({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    onError(t) {
      this.enableButtons();
      let e = "";
      (e = t.message
        ? t.message + "(" + t.status + "): " + t.description
        : ye + this.fullMessagesFromErrors(t).join("; ")),
        e === ge && (e = fe),
        this.render({ rates: [], errorFeedback: e, success: !1 });
    }
    onCartShippingRatesUpdate(t, e) {
      this.enableButtons();
      let s = "";
      e.zip && (s += e.zip + ", "),
        e.province && (s += e.province + ", "),
        (s += e.country),
        this.render({ rates: t, address: s, success: !0 });
    }
    constructor() {
      super(),
        (this.getRatesButton = this.querySelector(se)),
        (this.fieldsContainer = this.querySelector(ie)),
        (this.selectCountry = this.querySelector(oe)),
        (this.selectProvince = this.querySelector(ne)),
        (this.template = this.querySelector(le)),
        (this.wrapper = this.querySelector(ae)),
        (this.onCountryChangeEvent = () => this.onCountryChange()),
        (this.onButtonClickEvent = () => this.onButtonClick());
    }
  };
  const we = (t, e) => {
      let s, i;
      return function o(...n) {
        const r = Date.now();
        (i = clearTimeout(i)),
          !s || r - s >= e
            ? (t.apply(null, n), (s = r))
            : (i = setTimeout(o.bind(null, ...n), e - (r - s)));
      };
    },
    Ee = "is-animated",
    Se = "is-added",
    Le = "is-disabled",
    ke = "is-hidden",
    Ae = "is-hiding",
    Te = "is-loading",
    Ce = "is-open",
    qe = "is-removed",
    xe = "is-success",
    Pe = "is-visible",
    He = "is-expanded",
    Me = "is-updated",
    Ie = "variant--soldout",
    Be = "variant--unavailable",
    Fe = "[data-api-content]",
    De = "[data-api-line-items]",
    Oe = "[data-api-upsell-items]",
    $e = "[data-api-cart-price]",
    _e = "[data-animation]",
    Re = ".additional-checkout-buttons",
    Ne = "[data-foot-holder]",
    ze = "[data-skip-upsell-product]",
    Ue = "[data-add-to-cart-bar]",
    We = "[data-cart-error-close]",
    Ve = "[data-cart-drawer]",
    je = "[data-cart-drawer-close]",
    Xe = "[data-cart-empty]",
    Je = "[data-cart-errors]",
    Qe = "[data-item-remove]",
    Ge = "[data-cart-page]",
    Ye = "[data-cart-form]",
    Ke = "[data-cart-acceptance-checkbox]",
    Ze = "[data-cart-checkout-buttons]",
    ts = "[data-cart-checkout-button]",
    es = "[data-cart-total]",
    ss = "[data-error-message]",
    is = "[data-close-error]",
    os = "[data-cart-errors-container]",
    ns = "[data-form-wrapper]",
    rs = "[data-free-shipping]",
    as = "[data-progress-graph]",
    ls = "[data-progress-bar]",
    cs = "[data-header-wrapper]",
    hs = "[data-item]",
    ds = "[data-items-holder]",
    us = "[data-left-to-spend]",
    ps = "[data-drawer]",
    ms = "[data-section-id]",
    vs = "[data-cart-price-holder]",
    gs = "[data-quick-add-holder]",
    fs = "[data-quick-add-modal]",
    ys = 'input[name="updates[]"]',
    bs = "[data-upsell-products]",
    ws = "[data-upsell-widget]",
    Es = "[data-terms-error-message]",
    Ss = "data-cart-total",
    Ls = "disabled",
    ks = "data-drawer-underlay",
    As = "data-free-shipping",
    Ts = "data-free-shipping-limit",
    Cs = "data-item",
    qs = "data-item-index",
    xs = "data-item-title",
    Ps = "data-quick-add-holder";
  (window.cart = new (class {
    init() {
      (this.cartPage = document.querySelector(Ge)),
        (this.cartForm = document.querySelector(Ye)),
        (this.cartDrawer = document.querySelector(Ve)),
        (this.cartDrawerClose = document.querySelector(je)),
        (this.cartEmpty = document.querySelector(Xe)),
        (this.cartTermsCheckbox = document.querySelector(Ke)),
        (this.cartCheckoutButtonWrapper = document.querySelector(Ze)),
        (this.cartCheckoutButton = document.querySelector(ts)),
        (this.buttonHolder = document.querySelector(Ne)),
        (this.itemsHolder = document.querySelector(ds)),
        (this.priceHolder = document.querySelector(vs)),
        (this.items = document.querySelectorAll(hs)),
        (this.cartTotal = document.querySelector(es)),
        (this.freeShipping = document.querySelectorAll(rs)),
        (this.cartErrorHolder = document.querySelector(Je)),
        (this.cartCloseErrorMessage = document.querySelector(We)),
        (this.headerWrapper = document.querySelector(cs)),
        (this.accessibility = U),
        (this.navDrawer = document.querySelector(ps)),
        (this.upsellProductsHolder = document.querySelector(bs)),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(this.freeShipping[0].getAttribute(Ts)) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.openCartDrawer = this.openCartDrawer.bind(this)),
          (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
          (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
          (this.openCartDrawerOnProductAdded =
            this.openCartDrawerOnProductAdded.bind(this)),
          (this.animateItems = this.animateItems.bind(this)),
          (this.showAnimatedItems = this.showAnimatedItems.bind(this)),
          (this.formSubmitHandler = we(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.showAnimatedItems(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartDrawerIsOpen = !1),
          (this.cartDrawerEnabled = theme.settings.cartDrawerEnabled),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartToggleEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
          document.addEventListener(
            "theme:quick-add:open",
            this.closeCartDrawer
          ),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:added",
            this.openCartDrawerOnProductAdded
          ));
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(hs)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(Qe).forEach((t) => {
        const e = t.closest(hs);
        t.addEventListener("click", (s) => {
          s.preventDefault(),
            t.classList.contains(Le) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        this.cartCloseErrorMessage &&
          this.cartCloseErrorMessage.addEventListener("click", (t) => {
            t.preventDefault(), this.cartErrorHolder.classList.remove(He);
          });
    }
    cartAddEvent(t) {
      let e = "",
        s = t.detail.button;
      if (s.hasAttribute("disabled")) return;
      const i = s.closest("form");
      i.checkValidity()
        ? ((e = new FormData(i)),
          (null !== i && i.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, s)))
        : i.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      const t = document.querySelector(Ke).checked,
        e = document.querySelector(Es);
      if (t)
        e.classList.remove(He), this.cartCheckoutButton.removeAttribute(Ls);
      else {
        if (document.querySelector(Es).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(Ls, !0),
          e.classList.add(He);
      }
    }
    formErrorsEvents(t) {
      const e = t.querySelector(is);
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(Pe);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          const e = document.createElement("div");
          e.innerHTML = t;
          const s = e.querySelector(Fe);
          this.build(s);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(Te);
      const s = null == e ? void 0 : e.closest(gs);
      this.cartDrawerEnabled &&
        (e && (e.classList.add(Te), (e.disabled = !0)),
        s && s.classList.add(Pe)),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(Te), (e.disabled = !1)))
              );
            this.cartDrawerEnabled
              ? (e &&
                  (e.classList.remove(Te),
                  e.classList.add(Se),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(Te);
      let s = t.quantity;
      null !== e && (s ? e.classList.add(Te) : e.classList.add(qe)),
        this.disableCartButtons();
      const i = this.cart.querySelector(`[${Cs}="${t.id}"]`) || e,
        o = (null == i ? void 0 : i.hasAttribute(qs))
          ? parseInt(i.getAttribute(qs))
          : 0,
        n = (null == i ? void 0 : i.hasAttribute(xs))
          ? i.getAttribute(xs)
          : null;
      if (0 === o) return;
      const r = { line: o, quantity: s };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(r),
      })
        .then((t) => t.text())
        .then((t) => {
          if (JSON.parse(t).errors)
            return (
              (this.cartUpdateFailed = !0),
              this.updateErrorText(n),
              this.toggleErrorMessage(),
              this.resetLineItem(e),
              void this.enableCartButtons()
            );
          this.getCart();
        })
        .catch((t) => {
          console.log(t), this.enableCartButtons();
        });
    }
    resetLineItem(t) {
      const e = t.querySelector(ys),
        s = e.getAttribute("value");
      (e.value = s), t.classList.remove(Te);
    }
    disableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${Qe}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(Le), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(Ls, !0);
          });
    }
    enableCartButtons() {
      const t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${Qe}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(Le), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(Ls);
          }),
        this.cart.classList.remove(Te);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector(ss).innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(He, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new te({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      var s;
      if ((this.cartDrawerEnabled && this.closeCartDrawer(), null !== e)) {
        const s = e.closest(ms) || e.closest(gs) || e.closest(fs);
        let i = null == s ? void 0 : s.querySelector(os);
        const o = e.closest(gs);
        o && o.querySelector(os) && (i = o.querySelector(os)),
          i &&
            ((i.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            i.classList.add(Pe),
            this.formErrorsEvents(i)),
          e.dispatchEvent(
            new CustomEvent("theme:product:add-error", {
              detail: { response: t, button: e },
              bubbles: !0,
            })
          );
      }
      const i = null == e ? void 0 : e.closest(gs);
      i &&
        i.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: i,
            },
          })
        ),
        null === (s = this.cart) || void 0 === s || s.classList.remove(Te);
    }
    productAddCallback(t) {
      let e = [],
        s = null;
      const i = "theme:product:add-error" == t.type,
        o = t.detail.button,
        n = document.querySelector(Ue);
      e.push(o),
        (s = o.closest(gs)),
        n && e.push(n),
        e.forEach((t) => {
          t.classList.remove(Te), i || t.classList.add(Se);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, s;
            t.classList.remove(Se);
            (null === (e = t.closest(ns)) || void 0 === e
              ? void 0
              : e.classList.contains(Ie)) ||
              (null === (s = t.closest(ns)) || void 0 === s
                ? void 0
                : s.classList.contains(Be)) ||
              (t.disabled = !1);
          }),
            null == s || s.classList.remove(Pe);
        }, 1e3);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen ? this.showAnimatedItems() : this.openCartDrawer();
    }
    openCartDrawer() {
      this.cartDrawer &&
        ((this.cartDrawerIsOpen = !0),
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:cart:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        this.cartDrawer.classList.add(Ce),
        this.observeAdditionalCheckoutButtons(),
        setTimeout(this.showAnimatedItems),
        this.accessibility.trapFocus(this.cartDrawer, {
          elementToFocus: this.cartDrawer.querySelector(je),
        }));
    }
    closeCartDrawer() {
      this.cartDrawer &&
        this.cartDrawer.classList.contains(Ce) &&
        ((this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart:close", { bubbles: !0 })
        ),
        this.resetAnimatedItems(),
        this.itemsHolder.classList.remove(Me),
        this.cartEmpty.classList.remove(Me),
        this.cartErrorHolder.classList.remove(He),
        this.cartDrawer.querySelectorAll(_e).forEach((t) => {
          const e = () => {
            t.classList.remove(Ae), t.removeEventListener("animationend", e);
          };
          t.classList.add(Ae), t.addEventListener("animationend", e);
        }),
        this.cartDrawer.classList.remove(Ce),
        this.accessibility.removeTrapFocus(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    cartToggleEvents() {
      this.cartDrawer &&
        (this.cartDrawerClose.addEventListener("click", (t) => {
          t.preventDefault(), this.closeCartDrawer();
        }),
        this.cartDrawer.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        }));
    }
    onBodyClick(t) {
      t.target.hasAttribute(ks) && this.closeCartDrawer();
    }
    toggleClassesOnContainers() {
      const t = this.hasItemsInCart();
      this.cartEmpty.classList.toggle(ke, t),
        this.buttonHolder.classList.toggle(ke, !t),
        this.itemsHolder.classList.toggle(ke, !t);
    }
    build(t) {
      const e = t.querySelector(De),
        i = t.querySelector(Oe),
        o = Boolean(null === e && null === i),
        n = t.querySelector($e),
        r = t.querySelector(es);
      this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML),
        o
          ? ((this.itemsHolder.innerHTML = t),
            (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            (this.upsellProductsHolder.innerHTML = i.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          e && e.querySelectorAll(hs).length
            ? e.querySelectorAll(hs).length
            : 0),
        (this.subtotal =
          r && r.hasAttribute(Ss) ? parseInt(r.getAttribute(Ss)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : s.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.cart.classList.remove(Te),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawerIsOpen && this.itemsHolder.classList.add(Me),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(_e).forEach((t) => {
            t.classList.remove(Ee);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        ),
        this.cartDrawer || this.showAnimatedItems();
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(ys)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          const s =
            e.hasAttribute(As) && "true" === e.getAttribute(As) && t >= 0;
          e.classList.toggle(xe, s && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(rs)),
        !this.freeShipping.length)
      )
        return;
      const t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        i = this.circumference - ((e / 100) * this.circumference) / 2,
        o = s.formatMoney(
          this.freeShippingLimit - this.subtotal,
          theme.moneyFormat
        );
      this.freeShipping.forEach((t) => {
        const s = t.querySelector(ls),
          n = t.querySelector(as),
          r = t.querySelector(us);
        r && (r.innerHTML = o.replace(".00", "")),
          s && (s.value = e),
          n && n.style.setProperty("--stroke-dashoffset", `${i}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(ze);
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            const s = t.closest(gs).getAttribute(Ps);
            this.skipUpsellProductsArray.includes(s) ||
              this.skipUpsellProductsArray.push(s),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(s),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      const t = window.sessionStorage.getItem("skip_upsell_products");
      if (!t) return;
      t.split(",").forEach((t) => {
        this.skipUpsellProductsArray.includes(t) ||
          this.skipUpsellProductsArray.push(t),
          this.removeUpsellProduct(t);
      });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      const e = this.upsellProductsHolder.querySelector(`[${Ps}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      const t = this.upsellProductsHolder.querySelectorAll(gs),
        e = this.upsellProductsHolder.closest(ws);
      e && e.classList.toggle(ke, !t.length);
    }
    observeAdditionalCheckoutButtons() {
      const t = this.cartDrawer.querySelector(Re);
      if (t) {
        const e = new MutationObserver(() => {
          this.accessibility.trapFocus(this.cartDrawer, {
            elementToFocus: this.cartDrawer.querySelector(je),
          }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(_e).forEach((t) => {
        t.classList.remove(Ee), t.classList.remove(Ae);
      });
    }
    showAnimatedItems() {
      requestAnimationFrame(this.animateItems);
    }
    animateItems() {
      this.cart.querySelectorAll(_e).forEach((t) => {
        t.classList.add(Ee);
      });
    }
    constructor() {
      window.location.pathname.endsWith("/password") || this.init();
    }
  })()),
    customElements.get("shipping-calculator") ||
      customElements.define("shipping-calculator", be);
  const Hs = "is-focused",
    Ms = "[data-skip-content]",
    Is = 'a[href="#"]';
  window.accessibility = new (class {
    init() {
      (this.a11y = U),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector(Ms)),
        (this.linkesWithOnlyHash = document.querySelectorAll(Is)),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(Hs);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(Hs);
        });
    }
    constructor() {
      this.init();
    }
  })();
  const Bs = 'input[type="search"]';
  customElements.define(
    "main-search",
    class extends J {
      setupEventListeners() {
        let t = [];
        this.allSearchInputs.forEach((e) => t.push(e.form)),
          this.input.addEventListener("focus", this.onInputFocus.bind(this)),
          t.length < 2 ||
            (t.forEach((t) =>
              t.addEventListener("reset", this.onFormReset.bind(this))
            ),
            this.allSearchInputs.forEach((t) =>
              t.addEventListener("input", this.onInput.bind(this))
            ));
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() && this.keepInSync("", this.input);
      }
      onInput(t) {
        const e = t.target;
        this.keepInSync(e.value, e);
      }
      onInputFocus() {
        E() || this.scrollIntoView({ behavior: "smooth" });
      }
      keepInSync(t, e) {
        this.allSearchInputs.forEach((s) => {
          s !== e && (s.value = t);
        });
      }
      constructor() {
        super(),
          (this.allSearchInputs = document.querySelectorAll(Bs)),
          this.setupEventListeners();
      }
    }
  );
  const Fs = "details",
    Ds = "[data-popdown]",
    Os = "[data-popdown-close]",
    $s = "[data-popdown-toggle]",
    _s = 'input:not([type="hidden"])',
    Rs = "data-popdown-underlay";
  let Ns = class extends HTMLElement {
    connectedCallback() {
      this.popdownContainer.addEventListener(
        "keyup",
        (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
      ),
        this.popdownClose.addEventListener("click", this.close.bind(this)),
        this.popdownToggle.addEventListener(
          "click",
          this.onPopdownToggleClick.bind(this)
        ),
        this.popdownToggle.setAttribute("role", "button"),
        this.popdown.addEventListener("transitionend", (t) => {
          "visibility" == t.propertyName &&
            this.popdownContainer.hasAttribute("open") &&
            "false" == this.popdownContainer.getAttribute("open") &&
            this.popdownContainer.removeAttribute("open");
        });
    }
    onPopdownToggleClick(t) {
      t.preventDefault(),
        t.target.closest(Fs).hasAttribute("open") ? this.close() : this.open(t);
    }
    onBodyClick(t) {
      (this.contains(t.target) && !t.target.hasAttribute(Rs)) || this.close();
    }
    open(t) {
      (this.onBodyClickEvent =
        this.onBodyClickEvent || this.onBodyClick.bind(this)),
        t.target.closest(Fs).setAttribute("open", ""),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          t.target.closest(Fs).setAttribute("open", "true"),
            this.a11y.trapFocus(this.popdown, {
              elementToFocus: this.popdown.querySelector(_s),
            });
        });
    }
    close() {
      this.a11y.removeTrapFocus(),
        this.popdownContainer.setAttribute("open", "false"),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    constructor() {
      super(),
        (this.popdown = this.querySelector(Ds)),
        (this.popdownContainer = this.querySelector(Fs)),
        (this.popdownToggle = this.querySelector($s)),
        (this.popdownClose = this.querySelector(Os)),
        (this.a11y = U);
    }
  };
  customElements.define("header-search-popdown", Ns);
  const zs = "[data-collapsible]",
    Us = "[data-collapsible-trigger]",
    Ws = "[data-collapsible-body]",
    Vs = "[data-collapsible-content]",
    js = "open",
    Xs = "single";
  let Js = class extends HTMLElement {
    connectedCallback() {
      this.collapsibles.forEach((t) => {
        const e = t.querySelector(Us),
          s = t.querySelector(Ws);
        e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
          s.addEventListener("transitionend", (e) => {
            e.target === s &&
              ("true" == t.getAttribute(js) && this.setBodyHeight(s, "auto"),
              "false" == t.getAttribute(js) &&
                (t.removeAttribute(js), this.setBodyHeight(s, "")));
          });
      });
    }
    open(t) {
      if ("true" == t.getAttribute("open")) return;
      const e = t.querySelector(Ws),
        s = t.querySelector(Vs);
      t.setAttribute("open", !0), this.setBodyHeight(e, s.offsetHeight);
    }
    close(t) {
      if (!t.hasAttribute("open")) return;
      const e = t.querySelector(Ws),
        s = t.querySelector(Vs);
      this.setBodyHeight(e, s.offsetHeight),
        t.setAttribute("open", !1),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.setBodyHeight(e, 0);
          });
        });
    }
    setBodyHeight(t, e) {
      t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
    }
    onCollapsibleClick(t) {
      t.preventDefault();
      const e = (
        t.target.matches(Us) ? t.target : t.target.closest(Us)
      ).closest(zs);
      this.single &&
        this.collapsibles.forEach((t) => {
          t.hasAttribute(js) &&
            t != e &&
            requestAnimationFrame(() => {
              this.close(t);
            });
        }),
        e.hasAttribute(js) ? this.close(e) : this.open(e),
        e.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    constructor() {
      super(),
        (this.collapsibles = this.querySelectorAll(zs)),
        (this.single = this.hasAttribute(Xs));
    }
  };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", Js);
  const Qs = ".template-addresses",
    Gs = "#AddressNewForm",
    Ys = ".address-new-toggle",
    Ks = ".address-edit-toggle",
    Zs = ".address-delete",
    ti = "data-form-id",
    ei = "data-confirm-message",
    si = "#EditAddress",
    ii = "AddressCountryNew",
    oi = "AddressProvinceNew",
    ni = "AddressProvinceContainerNew",
    ri = ".address-country-option",
    ai = "AddressCountry",
    li = "AddressProvince",
    ci = "AddressProvinceContainer",
    hi = "hidden";
  const di = document.querySelector(Qs);
  di &&
    new (class {
      init() {
        if (this.addressNewForm) {
          const t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          const s = t.querySelectorAll(Ys);
          s.length &&
            s.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(hi);
              });
            });
          const i = t.querySelectorAll(Ks);
          i.length &&
            i.forEach((e) => {
              e.addEventListener("click", function () {
                const e = this.getAttribute(ti);
                t.querySelector(`${si}_${e}`).classList.toggle(hi);
              });
            });
          const o = t.querySelectorAll(Zs);
          o.length &&
            o.forEach((t) => {
              t.addEventListener("click", function () {
                const t = this.getAttribute(ti),
                  e = this.getAttribute(ei);
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(ii, oi, { hideElement: ni }),
          this.section.querySelectorAll(ri).forEach((t) => {
            const e = t.getAttribute(ti),
              s = `${ai}_${e}`,
              i = `${li}_${e}`,
              o = `${ci}_${e}`;
            new Shopify.CountryProvinceSelector(s, i, { hideElement: o });
          });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector(Gs)),
          this.init();
      }
    })(di);
  const ui = ".customer-logged-in",
    pi = ".account",
    mi = ".account-sidebar--mobile";
  const vi = document.querySelector(ui);
  vi &&
    new (class {
      init() {
        this.section.querySelector(pi) && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(mi) &&
          this.section.querySelector(mi).addEventListener("click", function () {
            const t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(vi);
  const gi = "[data-account-form]",
    fi = "[data-show-reset]",
    yi = "[data-hide-reset]",
    bi = "[data-recover-password]",
    wi = "[data-recover-success]",
    Ei = "[data-login-form]",
    Si = "#recover",
    Li = "is-hidden";
  const ki = document.querySelector(gi);
  ki &&
    new (class {
      init() {
        window.location.hash == Si || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(Li),
          this.recover.classList.remove(Li),
          (window.location.hash = Si),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(Li),
          this.login.classList.remove(Li),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector(fi)),
          (this.hideButton = t.querySelector(yi)),
          (this.recover = t.querySelector(bi)),
          (this.recoverSuccess = t.querySelector(wi)),
          (this.login = t.querySelector(Ei)),
          this.init();
      }
    })(ki),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const Ai = window.Shopify.theme.sections.registered,
    Ti = window.Shopify.theme.sections.instances,
    Ci = "data-section-id",
    qi = "data-section-type";
  let xi = class {
    callFunctions(t, e = null) {
      this.callStack[t].forEach((t) => {
        const s = { id: this.id, type: this.type, container: this.container };
        e ? t.call(s, e) : t.call(s);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(t) {
      this.callFunctions("onSelect", t);
    }
    onDeselect(t) {
      this.callFunctions("onDeselect", t);
    }
    onBlockSelect(t) {
      this.callFunctions("onBlockSelect", t);
    }
    onBlockDeselect(t) {
      this.callFunctions("onBlockDeselect", t);
    }
    onReorder(t) {
      this.callFunctions("onReorder", t);
    }
    constructor(t, e) {
      (this.container = (function (t) {
        if (!(t instanceof Element))
          throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
          );
        if (null === t.getAttribute(Ci))
          throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
              Ci +
              " attribute."
          );
        return t;
      })(t)),
        (this.id = t.getAttribute(Ci)),
        (this.type = e.type),
        (this.callStack = e.getStack());
      try {
        this.onLoad();
      } catch (t) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(t);
      }
    }
  };
  function Pi(t, e) {
    if ("string" != typeof t)
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== Ai[t])
      throw new Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    const s = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw new TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (const [e, s] of Object.entries(t)) {
              const t = this.callStack[e];
              Array.isArray(t) && "function" == typeof s
                ? t.push(s)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(s));
            }
          });
      }
    })(t, e);
    return (Ai[t] = s), Ai;
  }
  function Hi(t, e) {
    (t = Bi(t)),
      void 0 === e && (e = document.querySelectorAll("[" + qi + "]")),
      (e = Fi(e)),
      t.forEach(function (t) {
        const s = Ai[t];
        void 0 !== s &&
          (e = e.filter(function (e) {
            return (
              !(Mi(e).length > 0) &&
              null !== e.getAttribute(qi) &&
              (e.getAttribute(qi) !== t || (Ti.push(new xi(e, s)), !1))
            );
          }));
      });
  }
  function Mi(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var s = t[0];
    if (t instanceof Element || s instanceof Element)
      Fi(t).forEach(function (t) {
        e = e.concat(
          Ti.filter(function (e) {
            return e.container === t;
          })
        );
      });
    else if ("string" == typeof t || "string" == typeof s) {
      Bi(t).forEach(function (t) {
        e = e.concat(
          Ti.filter(function (e) {
            return e.type === t;
          })
        );
      });
    }
    return e;
  }
  function Ii(t) {
    for (var e, s = 0; s < Ti.length; s++)
      if (Ti[s].id === t) {
        e = Ti[s];
        break;
      }
    return e;
  }
  function Bi(t) {
    return (
      "*" === t
        ? (t = Object.keys(Ai))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === xi
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === xi &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function Fi(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ci + '="' + e + '"]');
      null !== s && Hi(s.getAttribute(qi), s);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ci + '="' + e + '"]');
      "object" == typeof Mi(s)[0] &&
        Mi(s).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        s = t.target.querySelector("[" + Ci + '="' + e + '"]');
      "object" == typeof Mi(s)[0] &&
        Mi(s).forEach(function (t) {
          var e = Ti.map(function (t) {
            return t.id;
          }).indexOf(t.id);
          Ti.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = Ii(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = Ii(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = Ii(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = Ii(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  const Di = "data-tooltip",
    Oi = "data-tooltip-stop-mouseenter",
    $i = "tooltip-default",
    _i = "is-visible",
    Ri = "is-hiding";
  let Ni = {},
    zi = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          const t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        const e = document.querySelector(`.${this.class}`);
        if (e && ((t && !this.tooltip.hasAttribute(Oi)) || !t)) {
          const t = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).textContent = this.label;
          const i = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            n = o.top,
            r = o.width,
            a = n + o.height + window.scrollY;
          let l = o.left - i / 2 + r / 2;
          const c = l + i - b();
          c > 0 && (l -= c),
            l < 0 && (l = 0),
            (t.style.left = `${o.left + r / 2}px`),
            e.style.setProperty("--tooltip-top", `${a}px`),
            (s.style.transform = `translateX(${l}px)`),
            e.classList.remove(Ri),
            e.classList.add(_i),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, s = !1) {
        const i = document.querySelector(`.${this.class}`),
          o = i.classList.contains(_i);
        i &&
          ((e && !this.tooltip.hasAttribute(Oi)) || !e) &&
          (o &&
            (s || t.detail.hideTransition) &&
            (i.classList.add(Ri),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              i.classList.remove(Ri);
            }, this.transitionSpeed))),
          i.classList.remove(_i),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(Di) &&
            ((this.label = this.tooltip.getAttribute(Di)),
            (this.class = e.class || $i),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => we(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    };
  const Ui = {
    onLoad() {
      Ni[this.id] = [];
      this.container.querySelectorAll(`[${Di}]`).forEach((t) => {
        Ni[this.id].push(new zi(t));
      });
    },
    onUnload: function () {
      Ni[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  var Wi = {};
  const Vi = {
    onLoad() {
      Wi[this.id] = [];
      this.container
        .querySelectorAll("[data-parallax-wrapper]")
        .forEach((t) => {
          const e = t.querySelector("[data-parallax-img]");
          Wi[this.id].push(new i(e, { center: !0, round: !0, frame: t }));
        }),
        window.addEventListener("load", () => {
          Wi[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      Wi[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  Pi("article", [Ui, Vi]);
  const ji = "[data-aos]",
    Xi = ".collection-item__image",
    Ji = "[data-column-image]",
    Qi = ".flickity-button.next",
    Gi = ".flickity-button.previous",
    Yi = "a:not(.btn)",
    Ki = ".product-item__image",
    Zi = "[data-slide]",
    to = "data-slide",
    eo = "[data-slider]",
    so = "[data-slider-thumb]",
    io = {
      arrowPositionMiddle: "data-arrow-position-middle",
      equalizeHeight: "data-equalize-height",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    oo = "aos-animate",
    no = "desktop",
    ro = "is-focused",
    ao = "flickity-resize",
    lo = "flickity-resizing",
    co = "flickity-enabled",
    ho = "is-initialized",
    uo = "is-loading",
    po = "is-selected",
    mo = "mobile",
    vo = "single-slide",
    go = "js-slider--initialized",
    fo = {};
  let yo = class {
    init() {
      this.slideshow.classList.add(uo);
      let t = Zi;
      const e = E(),
        s = `${Zi}:not(.${mo})`,
        i = `${Zi}:not(.${no})`;
      (this.slideshow.querySelectorAll(i).length ||
        this.slideshow.querySelectorAll(s).length) &&
        (t = e ? s : i),
        this.slideshow.querySelectorAll(t).length <= 1 &&
          (this.slideshow.classList.add(vo),
          this.slideshow.classList.remove(uo)),
        (this.sliderOptions = {
          cellSelector: t,
          contain: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          ...this.customOptions,
          on: {
            ready: () => {
              requestAnimationFrame(() => {
                this.slideshow.classList.add(ho),
                  this.slideshow.classList.remove(uo),
                  this.slideshow.parentNode.dispatchEvent(
                    new CustomEvent("theme:slider:loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
              }),
                this.slideActions(),
                this.sliderOptions.prevNextButtons && this.positionArrows();
            },
            change: (t) => {
              const e = this.slideshowSlides[t];
              if (!e || this.sliderOptions.groupCells) return;
              const s = e.querySelectorAll(ji);
              s.length &&
                s.forEach((t) => {
                  t.classList.remove(oo),
                    requestAnimationFrame(() => {
                      setTimeout(() => {
                        t.classList.add(oo);
                      }, 0);
                    });
                });
            },
            resize: () => {
              this.sliderOptions.prevNextButtons && this.positionArrows();
            },
          },
        }),
        this.sliderOptions.fade &&
          (this.flkty = new n(this.slideshow, this.sliderOptions)),
        this.sliderOptions.fade ||
          (this.flkty = new o(this.slideshow, this.sliderOptions)),
        this.isHeightEqualized && this.equalizeHeight(),
        this.flkty.on("change", () => this.slideActions(!0)),
        this.sliderThumbs.length &&
          this.sliderThumbs.forEach((t) => {
            t.addEventListener("click", (e) => {
              e.preventDefault();
              const s = [...t.parentElement.children].indexOf(t);
              this.flkty.select(s);
            });
          }),
        (this.flkty && this.flkty.isActive) ||
          this.slideshow.classList.remove(uo);
    }
    resetSlider() {
      this.slideshow &&
        (this.flkty && this.flkty.isActive
          ? this.flkty.select(0, !1, !0)
          : this.slideshow.scrollTo({ left: 0, behavior: "auto" }));
    }
    slideActions(t = !1) {
      const e = this.slideshow.querySelector(`.${po}`),
        s = e.getAttribute(io.slideTextColor),
        i = e.querySelector(Yi),
        o = this.slideshow.querySelectorAll(`${Zi} a, ${Zi} button`);
      if (
        (document.body.classList.contains(ro) &&
          i &&
          this.sliderOptions.groupCells &&
          t &&
          i.focus(),
        o.length &&
          o.forEach((t) => {
            const e = t.closest(Zi);
            if (e) {
              const s = e.classList.contains(po) ? 0 : -1;
              t.setAttribute("tabindex", s);
            }
          }),
        "rgba(0,0,0,0)" !== s &&
          "" !== s &&
          this.slideshow.style.setProperty("--text", s),
        this.sliderThumbs.length &&
          this.sliderThumbs.length === this.slideshowSlides.length &&
          e.hasAttribute(io.slideIndex))
      ) {
        const t = parseInt(e.getAttribute(io.slideIndex)),
          s = this.container.querySelector(`${so}.${po}`);
        s && s.classList.remove(po), this.sliderThumbs[t].classList.add(po);
      }
    }
    positionArrows() {
      if (
        this.slideshow.hasAttribute(io.arrowPositionMiddle) &&
        this.sliderOptions.prevNextButtons
      ) {
        const t =
          this.slideshow.querySelector(Xi) ||
          this.slideshow.querySelector(Ki) ||
          this.slideshow.querySelector(Ji);
        if (!t) return;
        (this.slideshow.querySelector(Gi).style.top =
          t.clientHeight / 2 + "px"),
          (this.slideshow.querySelector(Qi).style.top =
            t.clientHeight / 2 + "px");
      }
    }
    equalizeHeight() {
      (o.prototype._createResizeClass = function () {
        requestAnimationFrame(() => {
          this.element.classList.add(ao);
        });
      }),
        this.flkty._createResizeClass();
      const t = o.prototype.resize;
      o.prototype.resize = function () {
        this.element.classList.remove(ao),
          this.element.classList.add(lo),
          t.call(this),
          requestAnimationFrame(() => {
            this.element.classList.remove(lo), this.element.classList.add(ao);
          });
      };
    }
    onUnload() {
      this.slideshow &&
        this.flkty &&
        ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
    }
    onBlockSelect(t) {
      if (!this.slideshow) return;
      const e = this.slideshow.querySelector(`[${to}="${t.detail.blockId}"]`);
      if (!e) return;
      let s = parseInt(e.getAttribute(io.slideIndex));
      this.multipleSlides && !this.slideshow.classList.contains(go) && (s = 0),
        this.slideshow.classList.add(po),
        this.flkty &&
          this.slideshow.classList.contains(co) &&
          (this.flkty.selectCell(s), this.flkty.stopPlayer());
    }
    onBlockDeselect() {
      this.slideshow &&
        (this.slideshow.classList.remove(po),
        this.flkty &&
          this.sliderOptions.hasOwnProperty("autoPlay") &&
          this.sliderOptions.autoPlay &&
          this.flkty.playPlayer());
    }
    constructor(t, e = null) {
      (this.container = t),
        (this.slideshow = e || this.container.querySelector(eo)),
        this.slideshow &&
          ((this.slideshowSlides = this.slideshow.querySelectorAll(Zi)),
          this.slideshowSlides.length <= 1 ||
            ((this.sliderThumbs = this.container.querySelectorAll(so)),
            (this.multipleSlides = this.slideshow.hasAttribute(
              io.slidesLargeDesktop
            )),
            (this.isHeightEqualized =
              "true" === this.slideshow.getAttribute(io.equalizeHeight)),
            this.slideshow.hasAttribute(io.sliderOptions) &&
              (this.customOptions = JSON.parse(
                decodeURIComponent(
                  this.slideshow.getAttribute(io.sliderOptions)
                )
              )),
            (this.flkty = null),
            this.init()));
    }
  };
  const bo = {
    onLoad() {
      fo[this.id] = [];
      this.container.querySelectorAll(eo).forEach((t) => {
        fo[this.id].push(new yo(this.container, t));
      });
    },
    onUnload() {
      fo[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
    onBlockSelect(t) {
      fo[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      fo[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
  };
  Pi("blog-section", [bo]), Pi("hero", Vi), Pi("double", bo);
  const wo = (t) => {
    let { stickyHeaderHeight: e } = c();
    window.scrollTo({
      top: t + window.scrollY - e,
      left: 0,
      behavior: "smooth",
    });
  };
  let Eo = class {
    write() {
      ((-1 !== document.cookie.indexOf("; ") &&
        !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
        -1 === document.cookie.indexOf("; ")) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (
        -1 !== document.cookie.indexOf("; ") &&
        document.cookie.split("; ").find((t) => t.startsWith(this.name))
      ) {
        return document.cookie
          .split("; ")
          .find((t) => t.startsWith(this.name))
          .split("=")[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
    }
    constructor(t, e, s = 7) {
      const i = new Date(),
        o = new Date();
      o.setTime(i.getTime() + 864e5 * s),
        (this.configuration = {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        }),
        (this.name = t),
        (this.value = e);
    }
  };
  const So = "[data-newsletter-form]",
    Lo = "[data-newsletter-heading]",
    ko = "[data-newsletter]",
    Ao = "has-success",
    To = "has-error",
    Co = "hidden",
    qo = "data-cookie-name",
    xo = {};
  const Po = {
    onLoad() {
      xo[this.id] = [];
      this.container.querySelectorAll(So).forEach((t) => {
        xo[this.id].push(
          new (class {
            init() {
              this.newsletter.addEventListener("submit", this.newsletterSubmit),
                this.showMessage();
            }
            newsletterSubmitEvent(t) {
              this.stopSubmit &&
                (t.preventDefault(),
                t.stopImmediatePropagation(),
                this.removeStorage(),
                this.writeStorage(),
                (this.stopSubmit = !1),
                this.newsletter.submit());
            }
            checkForChallengePage() {
              this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
              void 0 !== this.sessionStorage &&
                this.sessionStorage.setItem(
                  "newsletter_form_id",
                  this.newsletter.id
                );
            }
            readStorage() {
              this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
              this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
              if ((this.readStorage(), this.newsletter.id === this.formID)) {
                const t = document.getElementById(this.formID),
                  e = t.parentElement.querySelector(Lo),
                  s =
                    -1 !==
                    window.location.search.indexOf("?customer_posted=true"),
                  i =
                    -1 !== window.location.search.indexOf("accepts_marketing");
                s
                  ? (t.classList.remove(To),
                    t.classList.add(Ao),
                    e && (e.classList.add(Co), t.classList.remove(Co)),
                    this.popup && this.cookie.write())
                  : i &&
                    (t.classList.remove(Ao),
                    t.classList.add(To),
                    e && (e.classList.add(Co), t.classList.remove(Co))),
                  (s || i) &&
                    window.addEventListener("load", () => {
                      this.scrollToForm(t);
                    });
              }
            }
            scrollToForm(t) {
              const e = t.getBoundingClientRect();
              (e.top >= 0 &&
                e.left >= 0 &&
                e.bottom <= w() &&
                e.right <= b()) ||
                setTimeout(() => {
                  wo(t.getBoundingClientRect().top);
                }, 500);
            }
            unload() {
              this.newsletter.removeEventListener(
                "submit",
                this.newsletterSubmit
              );
            }
            constructor(t) {
              (this.sessionStorage = window.sessionStorage),
                (this.newsletter = t),
                (this.popup = this.newsletter.closest(ko)),
                this.popup &&
                  (this.cookie = new Eo(
                    this.popup.getAttribute(qo),
                    "user_has_closed",
                    null
                  )),
                (this.stopSubmit = !0),
                (this.isChallengePage = !1),
                (this.formID = null),
                this.checkForChallengePage(),
                (this.newsletterSubmit = (t) => this.newsletterSubmitEvent(t)),
                this.isChallengePage || this.init();
            }
          })(t)
        );
      });
    },
    onUnload() {
      xo[this.id].forEach((t) => {
        "function" == typeof t.unload && t.unload();
      });
    },
  };
  Pi("footer", [Vi, Po]);
  const Ho = "[data-section-type]",
    Mo = "[data-collection-sidebar]",
    Io = "[data-collection-sidebar-slide-out]",
    Bo = "[data-collection-filters-form]",
    Fo = "input",
    Do = "select",
    Oo = "label",
    $o = "textarea",
    _o = "[data-field-price-min]",
    Ro = "[data-field-price-max]",
    No = "data-field-price-min",
    zo = "data-field-price-max",
    Uo = "[data-se-min-value]",
    Wo = "[data-se-max-value]",
    Vo = "data-se-min-value",
    jo = "data-se-max-value",
    Xo = "data-se-min",
    Jo = "data-se-max",
    Qo = "[data-products-grid]",
    Go = "[data-filter-update-url]",
    Yo = "[data-active-filters]",
    Ko = "data-active-filters-count",
    Zo = "data-sort-enabled",
    tn = "[data-collection-nav]",
    en = "[data-show-more]",
    sn = "[data-link-hidden]",
    on = "hidden",
    nn = "is-loading",
    rn = "is-focused";
  let an = class extends HTMLElement {
    connectedCallback() {
      this.form &&
        (this.sidebar.addEventListener("input", this.updatePriceEvent),
        this.sidebar.addEventListener(
          "theme:range:update",
          this.updateRangeEvent
        )),
        this.sidebar &&
          this.sidebar.addEventListener("click", this.filterUpdateFromUrlEvent),
        this.productsContainer &&
          this.productsContainer.addEventListener(
            "click",
            this.filterUpdateFromUrlEvent
          ),
        this.sort &&
          this.container.addEventListener(
            "theme:filter:sort-update",
            this.submitFormEvent
          ),
        (this.sidebar || this.sort) &&
          window.addEventListener("popstate", this.submitFormEvent),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.addEventListener("click", this.showMoreEvent);
          });
    }
    showMore(t) {
      t.preventDefault(),
        t.target.parentElement.classList.add(on),
        t.target.parentElement.previousElementSibling
          .querySelectorAll(sn)
          .forEach((t, e) => {
            t.classList.remove(on);
            const s = t.querySelector(Fo);
            0 === e &&
              document.body.classList.contains(rn) &&
              s &&
              (this.collectionSidebarSlideOut || S()
                ? (this.accessibility.removeTrapFocus(),
                  this.accessibility.trapFocus(this.sidebar, {
                    elementToFocus: s,
                  }))
                : s.focus());
          });
    }
    updatePrice(t) {
      const e = t.type,
        s = t.target;
      if (
        (e === Fo || e === Do || e === Oo || e === $o) &&
        this.form &&
        "function" == typeof this.form.submit
      ) {
        const e = this.form.querySelector(_o),
          i = this.form.querySelector(Ro);
        e &&
          i &&
          (s.hasAttribute(No) && !i.value
            ? (i.value = i.placeholder)
            : s.hasAttribute(zo) && !e.value && (e.value = e.placeholder)),
          this.submitForm(t);
      }
    }
    filterUpdateFromUrl(t) {
      const e = t.target;
      if (e.matches(Go) || (e.closest(Go) && e)) {
        t.preventDefault();
        const s = e.matches(Go) ? e : e.closest(Go);
        this.submitForm(t, s.getAttribute("href"));
      }
    }
    submitForm(t, e = "") {
      this.sort = this.container.querySelector(`[${Zo}]`);
      const s = this.sort ? this.sort.getAttribute(Zo) : "";
      if (!t || (t && "popstate" !== t.type))
        if ("" === e) {
          let e = new window.URL(window.location.href).searchParams;
          const i = e,
            o = Object.fromEntries(i),
            n = e.toString();
          if (n.includes("filter.") || n.includes("page="))
            for (const t in o)
              (t.includes("filter.") || "page" === t) && e.delete(t);
          if (this.form) {
            const t = new FormData(this.form),
              s = new URLSearchParams(t),
              i = this.form.querySelector(Uo),
              o = this.form.querySelector(Wo),
              n = i && i.hasAttribute(Xo) ? i.getAttribute(Xo) : "",
              r = o && o.hasAttribute(Jo) ? o.getAttribute(Jo) : "";
            let a = 0;
            for (let [t, i] of s.entries())
              t.includes("filter.") &&
                i &&
                (e.append(t, i),
                ((i === n && "filter.v.price.gte" === t) ||
                  (i === r && "filter.v.price.lte" === t)) &&
                  (a += 1));
            2 === a &&
              (e.delete("filter.v.price.gte"), e.delete("filter.v.price.lte"));
          }
          if (s || (t && t.detail && t.detail.href)) {
            const i = s || t.detail.href;
            e.set("sort_by", i);
          }
          const r = e.toString(),
            a = r ? `?${r}` : location.pathname;
          window.history.pushState(null, "", a);
        } else window.history.pushState(null, "", e);
      else
        this.sort &&
          this.sort.dispatchEvent(
            new CustomEvent("theme:filter:sort", { bubbles: !1 })
          );
      this.productsContainer &&
        (this.productsContainer.classList.add(nn),
        fetch(`${window.location.pathname}${window.location.search}`)
          .then((t) => t.text())
          .then((t) => {
            if (
              ((this.productsContainer.innerHTML = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(Qo).innerHTML),
              this.sidebar)
            ) {
              this.sidebar.innerHTML = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(Mo).innerHTML;
              const e = this.sidebar.querySelector(`[${Ko}]`),
                s = this.container.querySelectorAll(Yo);
              if (e && s.length) {
                const t = parseInt(e.getAttribute(Ko));
                s.forEach((e) => {
                  (e.textContent = t), e.classList.toggle(on, t < 1);
                });
              }
              this.sidebar.dispatchEvent(
                new CustomEvent("theme:filter:update", { bubbles: !0 })
              );
            }
            this.collectionNav &&
              wo(
                this.productsContainer.getBoundingClientRect().top -
                  this.collectionNav.offsetHeight
              ),
              setTimeout(() => {
                this.productsContainer.classList.remove(nn);
              }, 500);
          })
          .catch((t) => {
            console.log(t);
          }));
    }
    updateRange(t) {
      if (this.form && "function" == typeof this.form.submit) {
        const e = this.form.querySelector(Uo),
          s = this.form.querySelector(Wo),
          i = this.form.querySelector(_o),
          o = this.form.querySelector(Ro);
        if (e && s && i && o && e.hasAttribute(Vo) && s.hasAttribute(jo)) {
          const n = parseInt(i.placeholder),
            r = parseInt(o.placeholder),
            a = parseInt(e.getAttribute(Vo)),
            l = parseInt(s.getAttribute(jo));
          (n === a && r === l) ||
            ((i.value = a), (o.value = l), this.submitForm(t));
        }
      }
    }
    disconnectedCallback() {
      this.form &&
        (this.sidebar.removeEventListener("input", this.updatePriceEvent),
        this.sidebar.removeEventListener(
          "theme:range:update",
          this.updateRangeEvent
        )),
        this.sidebar &&
          this.sidebar.removeEventListener(
            "click",
            this.filterUpdateFromUrlEvent
          ),
        this.productsContainer &&
          this.productsContainer.removeEventListener(
            "click",
            this.filterUpdateFromUrlEvent
          ),
        this.sort &&
          this.container.removeEventListener(
            "theme:filter:sort-update",
            this.submitFormEvent
          ),
        (this.sidebar || this.sort) &&
          window.removeEventListener("popstate", this.submitFormEvent),
        this.showMoreOptions.length &&
          this.showMoreOptions.forEach((t) => {
            t.removeEventListener("click", this.showMoreEvent);
          });
    }
    constructor() {
      super(),
        (this.container = this.closest(Ho)),
        (this.sidebar = this.container.querySelector(Mo)),
        (this.collectionSidebarSlideOut = this.container.querySelector(Io)),
        (this.sort = this.container.querySelector(`[${Zo}]`)),
        (this.productsContainer = this.container.querySelector(Qo)),
        (this.collectionNav = this.container.querySelector(tn)),
        (this.form = this.querySelector(Bo)),
        (this.showMoreOptions = this.querySelectorAll(en)),
        (this.accessibility = U),
        (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t)),
        (this.submitFormEvent = (t) => this.submitForm(t)),
        (this.updatePriceEvent = y((t) => this.updatePrice(t), 500)),
        (this.updateRangeEvent = (t) => this.updateRange(t)),
        (this.showMoreEvent = (t) => this.showMore(t));
    }
  };
  const ln = "[data-collection-sidebar]",
    cn = "[data-range-left]",
    hn = "[data-range-right]",
    dn = "[data-range-line]",
    un = "[data-range-holder]",
    pn = "data-se-min",
    mn = "data-se-max",
    vn = "data-se-min-value",
    gn = "data-se-max-value",
    fn = "data-se-step",
    yn = "data-range-filter-update",
    bn = "[data-field-price-min]",
    wn = "[data-field-price-max]",
    En = "is-initialized";
  let Sn = class extends HTMLElement {
    connectedCallback() {
      let t = this.min;
      this.hasAttribute(vn) && (t = parseFloat(this.getAttribute(vn)));
      let e = this.max;
      this.hasAttribute(gn) && (e = parseFloat(this.getAttribute(gn))),
        t < this.min && (t = this.min),
        e > this.max && (e = this.max),
        t > e && (t = e),
        this.getAttribute(fn) &&
          (this.step = Math.abs(parseFloat(this.getAttribute(fn)))),
        this.reset(),
        (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(t),
        this.setMaxValue(e),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.classList.add(En);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0);
    }
    setMinValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(vn, t);
    }
    setMaxValue(t) {
      const e = (t - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          e *
            (this.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.setAttribute(gn, t);
    }
    onStart(t) {
      let e = t;
      t.touches && (e = t.touches[0]),
        t.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : t.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = e.pageX - this.x),
        (this.selectedTouch = t.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(t) {
      let e = t;
      if (
        (t.touches && (e = t.touches[0]),
        (this.x = e.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.getAttribute("on-change"))
      ) {
        new Function("min, max", this.getAttribute("on-change"))(
          this.getAttribute(vn),
          this.getAttribute(gn)
        );
      }
      this.onChange(this.getAttribute(vn), this.getAttribute(gn));
    }
    onStop() {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent),
        document.removeEventListener("touchend", this.onStopEvent),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(this.getAttribute(vn), this.getAttribute(gn));
    }
    onChange(t, e) {
      const s = this.closest(un);
      if (s) {
        const i = s.querySelector(bn),
          o = s.querySelector(wn);
        i && o && ((i.value = t), (o.value = e));
      }
    }
    onChanged(t, e) {
      this.hasAttribute(yn) &&
        this.dispatchEvent(
          new CustomEvent("theme:range:update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const t =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let e = this.lineSpan.offsetLeft / this.initialValue,
        s = e + t;
      if (
        ((e = e * (this.max - this.min) + this.min),
        (s = s * (this.max - this.min) + this.min),
        0 !== this.step)
      ) {
        let t = Math.floor(e / this.step);
        (e = this.step * t),
          (t = Math.floor(s / this.step)),
          (s = this.step * t);
      }
      this.selectedTouch === this.touchLeft && this.setAttribute(vn, e),
        this.selectedTouch === this.touchRight && this.setAttribute(gn, s);
    }
    onSidebarTransitionEnd(t) {
      t.target == this.sidebar &&
        "min-width" == t.propertyName &&
        (this.sidebar.removeEventListener(
          "transitionend",
          this.sidebarTransitionEvent
        ),
        this.connectedCallback());
    }
    disconnectedCallback() {
      this.sidebar.removeEventListener(
        "transitionend",
        this.sidebarTransitionEvent
      ),
        this.resizeEvent &&
          document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
    constructor() {
      super(),
        (this.sidebar = this.closest(ln)),
        (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
        (this.resizeEvent = () => {
          this.connectedCallback(),
            this.sidebar.addEventListener(
              "transitionend",
              this.sidebarTransitionEvent
            );
        }),
        (this.onMoveEvent = (t) => this.onMove(t)),
        (this.onStopEvent = (t) => this.onStop(t)),
        (this.onStartEvent = (t) => this.onStart(t)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.querySelector(cn)),
        (this.touchRight = this.querySelector(hn)),
        (this.lineSpan = this.querySelector(dn)),
        (this.min = parseFloat(this.getAttribute(pn))),
        (this.max = parseFloat(this.getAttribute(mn))),
        (this.step = 0),
        (this.normalizeFact = 26),
        document.addEventListener("theme:resize:width", this.resizeEvent);
    }
  };
  const Ln = "data-sort-enabled",
    kn = "[data-sort-link]",
    An = "data-value",
    Tn = "[data-popout-toggle]",
    Cn = "[data-sort-button-text]",
    qn = "[data-collection-sidebar]",
    xn = "[data-collection-sidebar-slide-out]",
    Pn = "[data-collection-sidebar-close]",
    Hn = "[data-aria-toggle]",
    Mn = "[data-collection-nav]",
    In = "drawer--animated",
    Bn = "expanded",
    Fn = "no-mobile-animation",
    Dn = "is-active",
    On = "is-focused";
  let $n = {};
  Pi("collection", [
    bo,
    Vi,
    {
      onLoad() {
        $n[this.id] = new (class {
          init() {
            this.sort && this.initSort(),
              null !== this.groupTagsButton &&
                (document.addEventListener(
                  "theme:resize:width",
                  this.sidebarResizeEvent
                ),
                this.groupTagsButton.addEventListener(
                  "click",
                  this.groupTagsButtonClickEvent
                ),
                this.collectionSidebar &&
                  setTimeout(() => {
                    this.collectionSidebar.classList.remove(Fn);
                  }, 1e3),
                new MutationObserver((t) => {
                  for (const e of t)
                    "attributes" === e.type &&
                      "true" == e.target.getAttribute("aria-expanded") &&
                      this.showSidebarCallback();
                }).observe(this.groupTagsButton, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                })),
              this.collectionSidebarCloseButtons.length &&
                this.collectionSidebarCloseButtons.forEach((t) => {
                  t.addEventListener("click", this.collectionSidebarCloseEvent);
                }),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(Bn) ||
                      this.collectionSidebar.classList.remove(In);
                  }
                ),
                this.toggleSidebarSlider(),
                this.collectionSidebar.addEventListener(
                  "theme:filter:update",
                  () => {
                    const t = this.container.querySelectorAll(Pn);
                    t.length &&
                      t.forEach((t) => {
                        t.addEventListener(
                          "click",
                          this.collectionSidebarCloseEvent
                        );
                      });
                  }
                ));
          }
          sortActions(t, e = !0) {
            const s = t ? t.getAttribute(An) : "";
            this.sort.setAttribute(Ln, s);
            const i = this.sort.querySelector(Cn),
              o = this.sort.querySelector(`.${Dn}`);
            if (i) {
              const e = t ? t.textContent.trim() : "";
              i.textContent = e;
            }
            o && o.classList.remove(Dn),
              this.sort.classList.toggle(Dn, t),
              t &&
                (t.parentElement.classList.add(Dn),
                e &&
                  t.dispatchEvent(
                    new CustomEvent("theme:filter:sort-update", {
                      bubbles: !0,
                      detail: { href: s },
                    })
                  ));
          }
          onSortButtonClick(t) {
            t.preventDefault(),
              this.sortButton &&
                this.sortButton.dispatchEvent(new Event("click")),
              this.sortActions(t.currentTarget);
          }
          onSortCheck(t) {
            let e = null;
            if (window.location.search.includes("sort_by")) {
              const t = new window.URL(window.location.href).searchParams;
              for (const [s, i] of t.entries()) {
                const t = this.sort.querySelector(`[${An}="${i}"]`);
                if (s.includes("sort_by") && t) {
                  e = t;
                  break;
                }
              }
            }
            this.sortActions(e, !1);
          }
          initSort() {
            this.sortLinks.forEach((t) => {
              t.addEventListener("click", this.onSortButtonClickEvent);
            }),
              this.sort.addEventListener(
                "theme:filter:sort",
                this.onSortCheckEvent
              ),
              this.sortButton &&
                this.sortButton.addEventListener("click", () => {
                  const t = this.collectionSidebar.classList.contains(Bn);
                  S() && t && this.hideSidebar();
                });
          }
          showSidebarCallback() {
            const t = this.container.querySelector(xn),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              s = S();
            this.collectionSidebar.classList.add(In),
              null === t &&
                !s &&
                e &&
                (this.accessibility.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                )),
              (s || null !== t) &&
                (t &&
                  this.accessibility.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector(Pn),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
          }
          hideSidebar() {
            const t = this.container.querySelector(xn),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(Bn),
              t && this.accessibility.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }
          toggleSidebarSlider() {
            S()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(Bn) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains(On) &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebarCloseButtons.length &&
                this.collectionSidebarCloseButtons.forEach((t) => {
                  t.removeEventListener(
                    "click",
                    this.collectionSidebarCloseEvent
                  );
                }),
              this.sort &&
                (this.sortLinks.forEach((t) => {
                  t.removeEventListener("click", this.onSortButtonClickEvent);
                }),
                this.sort.removeEventListener(
                  "theme:filter:sort",
                  this.onSortCheckEvent
                ));
          }
          constructor(t) {
            (this.container = t.container),
              (this.sort = this.container.querySelector(`[${Ln}]`)),
              (this.sortButton = this.container.querySelector(Tn)),
              (this.sortLinks = this.container.querySelectorAll(kn)),
              (this.collectionSidebar = this.container.querySelector(qn)),
              (this.collectionSidebarCloseButtons =
                this.container.querySelectorAll(Pn)),
              (this.groupTagsButton = this.container.querySelector(Hn)),
              (this.collectionNav = this.container.querySelector(Mn)),
              (this.accessibility = U),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
              (this.onSortCheckEvent = (t) => this.onSortCheck(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              this.init();
          }
        })(this);
      },
      onUnload() {
        $n[this.id].onUnload();
      },
    },
    Ui,
  ]),
    customElements.get("collection-filters-form") ||
      customElements.define("collection-filters-form", an),
    customElements.get("range-slider") ||
      customElements.define("range-slider", Sn);
  const _n = "[data-ticker-scale]",
    Rn = "[data-ticker-text]",
    Nn = "data-clone",
    zn = "autoplay",
    Un = "speed",
    Wn = "ticker--animated",
    Vn = "ticker--unloaded",
    jn = "ticker__comparitor",
    Xn = 1.63,
    Jn = 100;
  let Qn = class extends HTMLElement {
    connectedCallback() {
      this.checkWidth(),
        this.addEventListener("theme:ticker:refresh", this.checkWidthEvent),
        document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }
    checkWidth() {
      const t = 2 * window.getComputedStyle(this).paddingLeft.replace("px", "");
      if (this.clientWidth - t < this.comparitor.clientWidth || this.autoplay) {
        if ((this.text.classList.add(Wn), 1 === this.scale.childElementCount)) {
          if (
            ((this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(Nn, ""),
            this.scale.appendChild(this.clone),
            this.autoplay)
          )
            for (let t = 0; t < 10; t++) {
              const t = this.text.cloneNode(!0);
              t.setAttribute(Nn, ""), this.scale.appendChild(t);
            }
          const t = ((this.text.clientWidth / Jn) * Number(this.speed)).toFixed(
            2
          );
          this.scale.style.setProperty("--animation-time", `${t}s`);
        }
      } else {
        this.text.classList.add(Wn);
        let t = this.scale.querySelector(`[${Nn}]`);
        t && this.scale.removeChild(t), this.text.classList.remove(Wn);
      }
    }
    constructor() {
      super(),
        (this.autoplay = this.hasAttribute(zn)),
        (this.scale = this.querySelector(_n)),
        (this.text = this.querySelector(Rn)),
        (this.speed = this.hasAttribute(Un) ? this.getAttribute(Un) : Xn),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(jn),
        this.appendChild(this.comparitor),
        this.scale.classList.remove(Vn),
        (this.checkWidthEvent = this.checkWidth.bind(this));
    }
  };
  const Gn = { slide: "[data-slide]", slider: "[data-slider]" },
    Yn = "data-target-referrer";
  let Kn = class extends HTMLElement {
    connectedCallback() {
      this.removeAnnouncement(),
        this.slider && this.initSliders(),
        this.addEventListener("theme:block:select", (t) => {
          this.onBlockSelect(t);
        }),
        this.addEventListener("theme:block:deselect", (t) => {
          this.onBlockDeselect(t);
        }),
        document.dispatchEvent(
          new CustomEvent("theme:announcement:init", { bubbles: !0 })
        );
    }
    removeAnnouncement() {
      for (let t = 0; t < this.slides.length; t++) {
        const e = this.slides[t];
        e.hasAttribute(Yn) &&
          (-1 !== this.locationPath.indexOf(e.getAttribute(Yn)) ||
            window.Shopify.designMode ||
            e.parentNode.removeChild(e));
      }
    }
    initSliders() {
      this.initSlider(),
        document.addEventListener("theme:resize:width", this.initSliderEvent),
        this.addEventListener("theme:slider:loaded", () => {
          var t;
          null === (t = this.querySelectorAll(Gn.tickerBar)) ||
            void 0 === t ||
            t.forEach((t) => {
              t.dispatchEvent(new CustomEvent("theme:ticker:refresh"));
            });
        });
    }
    initSlider() {
      const t = E(),
        e = !t;
      var s, i;
      ((t && this.enableSlider) || (e && !this.enableSlider)) &&
        (null === (s = this.slider.flkty) || void 0 === s || s.destroy(),
        t && this.enableSlider
          ? (this.enableSlider = !1)
          : e && !this.enableSlider && (this.enableSlider = !0),
        (this.slider = new yo(this, this.querySelector(Gn.slider))),
        null === (i = this.slider.flkty) || void 0 === i || i.reposition());
    }
    onBlockSelect(t) {
      this.slider && this.slider.onBlockSelect(t);
    }
    onBlockDeselect(t) {
      this.slider ? this.slider.onBlockDeselect(t) : this.toggleTicker(t, !1);
    }
    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.initSliderEvent),
        document.removeEventListener(
          "theme:resize:width",
          this.tickerResizeEvent
        );
    }
    constructor() {
      super(),
        (this.locationPath = location.href),
        (this.slides = this.querySelectorAll(Gn.slide)),
        (this.slider = this.querySelector(Gn.slider)),
        (this.enableSlider = E()),
        (this.initSliderEvent = (t) => this.initSlider(t));
    }
  };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", Kn),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Qn);
  const Zn = "body",
    tr = "[data-drawer]",
    er = "[data-drawer-inner]",
    sr = "[data-drawer-underlay]",
    ir = "[data-stagger-animation]",
    or = "[data-header-wrapper]",
    nr = "data-drawer-toggle",
    rr = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    ar = "drawer--animated",
    lr = "is-open",
    cr = "is-focused";
  let hr = {};
  const dr = {
      onLoad() {
        hr[this.id] = [];
        this.container.querySelectorAll(tr).forEach((t) => {
          hr[this.id].push(
            new (class {
              connectToggle() {
                this.buttons.forEach((t) => {
                  t.addEventListener("click", () => {
                    this.drawer.dispatchEvent(
                      new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
                    );
                  });
                });
              }
              connectDrawer() {
                this.drawer.addEventListener("theme:drawer:toggle", () => {
                  this.drawer.classList.contains(lr)
                    ? this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:close", { bubbles: !0 })
                      )
                    : this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:open", { bubbles: !0 })
                      );
                }),
                  this.drawerInner &&
                    this.drawerInner.addEventListener("transitionend", (t) => {
                      t.target == this.drawerInner &&
                        (this.drawer.classList.contains(lr) ||
                          (this.drawer.classList.remove(ar),
                          document.dispatchEvent(
                            new CustomEvent("theme:sliderule:close", {
                              bubbles: !1,
                            })
                          )));
                    }),
                  document.addEventListener("theme:cart:open", this.hideDrawer),
                  document.addEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.addEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              watchFocus(t) {
                !this.wrapper.contains(t.target) &&
                  this.body.classList.contains(cr) &&
                  this.hideDrawer();
              }
              closers() {
                this.wrapper.addEventListener(
                  "keyup",
                  function (t) {
                    "Escape" === t.code &&
                      (this.hideDrawer(), this.buttons[0].focus());
                  }.bind(this)
                ),
                  this.underlay.addEventListener("click", () => {
                    this.hideDrawer();
                  });
              }
              showDrawer() {
                this.drawerInner &&
                  this.drawerInner.querySelector(this.btnSelector) &&
                  (this.accessibility.removeTrapFocus(),
                  this.drawerInner.addEventListener("transitionend", (t) => {
                    t.target == this.drawerInner &&
                      this.drawer.classList.contains(lr) &&
                      this.accessibility.trapFocus(this.drawerInner, {
                        elementToFocus: this.drawerInner.querySelector(
                          this.btnSelector
                        ),
                      });
                  })),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !0);
                  }),
                  this.drawer.classList.add(lr),
                  this.drawer.classList.add(ar),
                  this.drawer.querySelector(rr).focus(),
                  document.addEventListener("focusin", this.initWatchFocus),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                  );
              }
              hideDrawer() {
                this.drawer.classList.contains(lr) &&
                  (this.accessibility.removeTrapFocus(),
                  this.body.classList.contains(cr) &&
                    this.buttons.length &&
                    this.buttons[0].focus(),
                  this.buttons.forEach((t) => {
                    t.setAttribute("aria-expanded", !1);
                  }),
                  this.drawer.classList.remove(lr),
                  document.removeEventListener("focusin", this.initWatchFocus),
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                  ));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:cart:open",
                  this.hideDrawer
                ),
                  document.removeEventListener(
                    "theme:drawer:close",
                    this.hideDrawer
                  ),
                  document.removeEventListener(
                    "theme:drawer:open",
                    this.showDrawer
                  );
              }
              constructor(t) {
                (this.drawer = t),
                  (this.drawerWrapper = this.drawer.closest(tr)),
                  (this.drawerInner = this.drawer.querySelector(er)),
                  (this.underlay = this.drawer.querySelector(sr)),
                  (this.wrapper = this.drawer.closest(or)),
                  (this.key = this.drawer.dataset.drawer),
                  (this.btnSelector = `[${nr}='${this.key}']`),
                  (this.buttons = document.querySelectorAll(this.btnSelector)),
                  (this.staggers = this.drawer.querySelectorAll(ir)),
                  (this.body = document.querySelector(Zn)),
                  (this.accessibility = U),
                  (this.initWatchFocus = (t) => this.watchFocus(t)),
                  (this.showDrawer = this.showDrawer.bind(this)),
                  (this.hideDrawer = this.hideDrawer.bind(this)),
                  this.connectToggle(),
                  this.connectDrawer(),
                  this.closers();
              }
            })(t)
          );
        });
      },
      onUnload() {
        hr[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    ur = ".page-header",
    pr = "js__header__stuck",
    mr = "has-header-sticky",
    vr = "shopify-section-group-header-group",
    gr = "data-header-sticky",
    fr = "data-scroll-locked";
  let yr = {};
  const br = {
      onLoad() {
        yr = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains(vr) &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(ur)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(pr), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute(fr) ||
              (this.cls.remove(pr), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute(gr)),
              document.body.classList.toggle(mr, this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(ur)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof yr.unload && yr.unload();
      },
    },
    wr = "data-hover-disclosure-toggle",
    Er = "[data-hover-disclosure]",
    Sr = "[data-top-link]",
    Lr = "[data-header-wrapper]",
    kr = "[data-stagger]",
    Ar = "[data-stagger-first]",
    Tr = "[data-stagger-second]",
    Cr = "is-visible",
    qr = "meganav--visible",
    xr = "meganav--is-transitioning";
  let Pr = {},
    Hr = {};
  const Mr = {
      onLoad() {
        (Pr[this.id] = []),
          (Hr = this.container.querySelectorAll(Er)),
          Hr.forEach((t) => {
            Pr[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(xr),
                    this.grandparent
                      ? this.wrapper.classList.add(qr)
                      : this.wrapper.classList.remove(qr),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(Cr),
                    this.disclosure.classList.add(Cr),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(xr);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(Cr),
                    this.trigger.classList.remove(Cr),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(qr, xr);
                }
                staggerChildAnimations() {
                  this.disclosure.querySelectorAll(kr).forEach((t, e) => {
                    t.style.transitionDelay = 50 * e + 10 + "ms";
                  }),
                    this.disclosure.querySelectorAll(Ar).forEach((t, e) => {
                      const s = 100 * e;
                      (t.style.transitionDelay = `${s}ms`),
                        t.parentElement.querySelectorAll(Tr).forEach((t, e) => {
                          const i = 20 * (e + 1);
                          t.style.transitionDelay = `${s + i}ms`;
                        });
                    });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(Cr) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest(Lr)),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[${wr}='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector(Sr)),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        Pr[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        Pr[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    Ir = "data-cart-count";
  const Br = {
      onLoad() {
        new (class {
          listen() {
            document.addEventListener("theme:cart:change", (t) => {
              (this.cartCount = t.detail.cartCount), this.update();
            });
          }
          update() {
            null !== this.cartCount &&
              this.counts.forEach((t) => {
                t.setAttribute(Ir, this.cartCount),
                  (t.innerHTML =
                    this.cartCount < 10 ? `${this.cartCount}` : "9+");
              });
          }
          constructor(t) {
            (this.section = t),
              (this.counts = this.section.querySelectorAll(`[${Ir}]`)),
              (this.cartCount = null),
              this.listen();
          }
        })(this.container);
      },
    },
    Fr = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    Dr = "is-visible",
    Or = "is-hiding",
    $r = "is-hidden",
    _r = "is-focused",
    Rr = "is-scrolling";
  let Nr = {};
  const zr = {
      onLoad() {
        Nr[this.id] = [];
        this.container.querySelectorAll(Fr.slideruleWrappper).forEach((t) => {
          Nr[this.id].push(
            new (class {
              clickEvents() {
                this.trigger.addEventListener("click", () => {
                  (this.cachedButton = this.trigger), this.showSliderule();
                }),
                  this.exit.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.hideSliderule();
                    });
                  });
              }
              keyboardEvents() {
                this.sliderule.addEventListener("keyup", (t) => {
                  t.stopPropagation(),
                    "Escape" === t.code && this.hideSliderule();
                });
              }
              trapFocusSliderule(t = !0) {
                const e = t
                  ? this.sliderule.querySelector(this.exitSelector)
                  : this.cachedButton;
                this.accessibility.removeTrapFocus(),
                  e &&
                    this.drawerContent &&
                    this.accessibility.trapFocus(this.drawerContent, {
                      elementToFocus: document.body.classList.contains(_r)
                        ? e
                        : null,
                    });
              }
              hideSliderule(t = !1) {
                const e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(Fr.sliderulePane, e),
                  this.pane.classList.add(Or),
                  this.sliderule.classList.add(Or);
                const s = t
                    ? `[${Fr.dataAnimates}].${$r}`
                    : `[${Fr.dataAnimates}="${e}"]`,
                  i = this.pane.querySelectorAll(s);
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove($r);
                  });
                const o = t
                  ? this.pane.querySelectorAll(`.${Dr}, .${Or}`)
                  : this.children;
                o.forEach((s, i) => {
                  const n = o.length - 1 == i;
                  s.classList.remove(Dr),
                    t &&
                      (s.classList.remove(Or), this.pane.classList.remove(Or));
                  const r = () => {
                    parseInt(this.pane.getAttribute(Fr.sliderulePane)) === e &&
                      this.sliderule.classList.remove(Dr),
                      this.sliderule.classList.remove(Or),
                      this.pane.classList.remove(Or),
                      n &&
                        (this.accessibility.removeTrapFocus(),
                        t || this.trapFocusSliderule(!1)),
                      s.removeEventListener("animationend", r);
                  };
                  window.theme.settings.enableAnimations
                    ? s.addEventListener("animationend", r)
                    : r();
                });
              }
              showSliderule() {
                let t = null;
                const e = this.sliderule.closest(`.${Dr}`);
                let s = this.pane;
                e && (s = e),
                  s.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                  s.classList.add(Rr);
                const i = () => {
                  s.scrollTop <= 0
                    ? (s.classList.remove(Rr), t && cancelAnimationFrame(t))
                    : (t = requestAnimationFrame(i));
                };
                (t = requestAnimationFrame(i)),
                  this.sliderule.classList.add(Dr);
                const o = parseInt(this.pane.dataset.sliderulePane, 10),
                  n = o + 1;
                this.pane.setAttribute(Fr.sliderulePane, n);
                const r = this.pane.querySelectorAll(
                  `[${Fr.dataAnimates}="${o}"]`
                );
                r.length &&
                  r.forEach((t, e) => {
                    const s = r.length - 1 == e;
                    t.classList.add(Or);
                    const i = () => {
                      t.classList.remove(Or),
                        parseInt(this.pane.getAttribute(Fr.sliderulePane)) !==
                          o && t.classList.add($r),
                        s && this.trapFocusSliderule(),
                        t.removeEventListener("animationend", i);
                    };
                    window.theme.settings.enableAnimations
                      ? t.addEventListener("animationend", i)
                      : i();
                  });
              }
              closeSliderule() {
                this.pane &&
                  this.pane.hasAttribute(Fr.sliderulePane) &&
                  parseInt(this.pane.getAttribute(Fr.sliderulePane)) > 0 &&
                  (this.hideSliderule(!0),
                  parseInt(this.pane.getAttribute(Fr.sliderulePane)) > 0 &&
                    this.pane.setAttribute(Fr.sliderulePane, 0));
              }
              onUnload() {
                document.removeEventListener(
                  "theme:sliderule:close",
                  this.closeSliderule
                );
              }
              constructor(t) {
                (this.sliderule = t), (this.key = this.sliderule.id);
                const e = `[${Fr.slideruleOpen}='${this.key}']`;
                (this.exitSelector = `[${Fr.slideruleClose}='${this.key}']`),
                  (this.trigger = document.querySelector(e)),
                  (this.exit = document.querySelectorAll(this.exitSelector)),
                  (this.pane = document.querySelector(`[${Fr.sliderulePane}]`)),
                  (this.children = this.sliderule.querySelectorAll(
                    Fr.children
                  )),
                  (this.drawerContent = document.querySelector(
                    Fr.drawerContent
                  )),
                  (this.cachedButton = null),
                  (this.accessibility = U),
                  this.trigger.setAttribute("aria-haspopup", !0),
                  this.trigger.setAttribute("aria-expanded", !1),
                  this.trigger.setAttribute("aria-controls", this.key),
                  (this.closeSliderule = this.closeSliderule.bind(this)),
                  this.clickEvents(),
                  this.keyboardEvents(),
                  document.addEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
              }
            })(t)
          );
        });
      },
      onUnload() {
        Nr[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    Ur = "[data-takes-space-wrapper]",
    Wr = "[data-child-takes-space]",
    Vr = "[data-header-desktop]",
    jr = '.navlink[href="#"]',
    Xr = "[data-cart-toggle]",
    Jr =
      ".main-content > .shopify-section.section-overlay-header:first-of-type",
    Qr = "js__header__clone",
    Gr = "has-first-section-overlay-header",
    Yr = "js__show__mobile",
    Kr = "has-header-transparent",
    Zr = "data-header-transparent";
  let ta = {};
  Pi("header", [
    {
      onLoad() {
        ta = new (class {
          initTicker(t = !1) {
            this.tickerFrames.forEach((e) => {
              new Qn(e, t);
            }),
              (this.tickerResizeEvent = (t) => this.onTickerResize(t)),
              document.addEventListener(
                "theme:resize:width",
                this.tickerResizeEvent
              );
          }
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            document.body.clientWidth < this.minWidth
              ? this.wrapper.classList.add(Yr)
              : this.wrapper.classList.remove(Yr);
          }
          getMinWidth() {
            const t = this.wrapper.cloneNode(!0);
            t.classList.add(Qr), document.body.appendChild(t);
            const e = t.querySelectorAll(Ur);
            let s = 0,
              i = 0;
            return (
              e.forEach((t) => {
                const e = t.querySelectorAll(Wr);
                let o = 0;
                (o =
                  3 === e.length
                    ? (function (t) {
                        let e = [];
                        return (
                          t.forEach((t) => {
                            t.firstElementChild &&
                              e.push(t.firstElementChild.clientWidth);
                          }),
                          e[0] > e[2] ? (e[2] = e[0]) : (e[0] = e[2]),
                          e.reduce((t, e) => t + e)
                        );
                      })(e)
                    : (function (t) {
                        let e = 0;
                        return (
                          t.forEach((t) => {
                            e += t.clientWidth;
                          }),
                          e
                        );
                      })(e)),
                  o > s && ((s = o), (i = 20 * e.length));
              }),
              document.body.removeChild(t),
              s + i
            );
          }
          cartToggleEvent() {
            const t = this.wrapper.querySelectorAll(Xr);
            t.length &&
              t.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(),
                    document.dispatchEvent(
                      new CustomEvent("theme:cart:toggle", { bubbles: !0 })
                    );
                });
              });
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(Vr)),
              (this.deadLinks = document.querySelectorAll(jr)),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            const e = document.querySelector(Jr);
            document.body.classList.toggle(Kr, this.wrapper.hasAttribute(Zr)),
              document.body.classList.toggle(Gr, e);
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof ta.unload && ta.unload();
      },
    },
    dr,
    zr,
    br,
    Mr,
    Br,
  ]),
    customElements.get("ticker-bar") || customElements.define("ticker-bar", Qn);
  const ea = "[data-block-scroll]",
    sa = "flickity-enabled",
    ia = {};
  const oa = {
      onLoad() {
        ia[this.id] = new (class {
          onBlockSelect(t) {
            const e = this.container.querySelector(ea);
            if (e && !e.classList.contains(sa)) {
              const s = t.srcElement;
              s &&
                e.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        ia[this.id].onBlockSelect(t);
      },
    },
    na = "[data-slider-mobile]",
    ra = "[data-slide]",
    aa = "[data-slider-thumb]",
    la = "[data-slider-container]",
    ca = "[data-popup-container]",
    ha = "[data-popup-close]",
    da = "is-animating",
    ua = "is-open",
    pa = "data-slider-thumb",
    ma = {};
  function va() {
    this.entries = [];
  }
  function ga(t, e) {
    fa(t);
    var s = (function (t, e) {
      fa(t),
        (function (t) {
          if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
          if (0 === t.length) throw new Error(t + " is empty.");
          if (!t[0].hasOwnProperty("name"))
            throw new Error(t[0] + "does not contain name key.");
          if ("string" != typeof t[0].name)
            throw new TypeError(
              "Invalid value type passed for name of option " +
                t[0].name +
                ". Value should be string."
            );
        })(e);
      var s = [];
      return (
        e.forEach(function (e) {
          for (var i = 0; i < t.options.length; i++) {
            if (
              (t.options[i].name || t.options[i]).toLowerCase() ===
              e.name.toLowerCase()
            ) {
              s[i] = e.value;
              break;
            }
          }
        }),
        s
      );
    })(t, e);
    return (function (t, e) {
      return (
        fa(t),
        (function (t) {
          if (Array.isArray(t) && "object" == typeof t[0])
            throw new Error(t + "is not a valid array of options.");
        })(e),
        t.variants.filter(function (t) {
          return e.every(function (e, s) {
            return t.options[s] === e;
          });
        })[0] || null
      );
    })(t, s);
  }
  function fa(t) {
    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw new Error(t + " is empty.");
  }
  Pi("look", [
    {
      onLoad() {
        ma[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(da),
                  t.target.classList.contains(ua)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(da);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(ua), this.scrollUnlock();
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (s) => {
                  s.preventDefault();
                  const i =
                      t.hasAttribute(pa) && "" !== t.getAttribute(pa)
                        ? parseInt(t.getAttribute(pa))
                        : e,
                    o = this.slides[i];
                  if (S()) {
                    const t = parseInt(
                        window.getComputedStyle(this.slider).paddingLeft
                      ),
                      e = o.offsetLeft;
                    this.slider.scrollTo({
                      top: 0,
                      left: e - t,
                      behavior: "auto",
                    }),
                      this.scrollLock(),
                      this.popupContainer.classList.add(da, ua);
                  } else {
                    let { stickyHeaderHeight: t } = c();
                    const e = o.getBoundingClientRect().top,
                      s = o.offsetHeight / 2,
                      i = window.innerHeight,
                      n = i / 2,
                      r = this.container.querySelector(la);
                    let a = e + s - n + window.scrollY;
                    if (r) {
                      const e = r.getBoundingClientRect().top + window.scrollY,
                        s = e + r.offsetHeight;
                      a < e ? (a = e - t) : a + i > s && (a = s - i);
                    }
                    window.scrollTo({ top: a, left: 0, behavior: "smooth" });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(ua);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          scrollLock() {
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            );
          }
          scrollUnlock() {
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(na)),
              (this.slides = this.container.querySelectorAll(ra)),
              (this.thumbs = this.container.querySelectorAll(aa)),
              (this.popupContainer = this.container.querySelector(ca)),
              (this.popupClose = this.container.querySelectorAll(ha)),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    oa,
  ]),
    (va.prototype.add = function (t, e, s) {
      this.entries.push({ element: t, event: e, fn: s }),
        t.addEventListener(e, s);
    }),
    (va.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var ya = '[name="id"]',
    ba = '[name="selling_plan"]',
    wa = '[name^="options"]',
    Ea = '[name="quantity"]',
    Sa = '[name^="properties"]';
  const La = "data-scrollbar",
    ka = "data-scrollbar-slider",
    Aa = "data-scrollbar-slide-fullwidth",
    Ta = "[data-scrollbar-arrow-prev]",
    Ca = "[data-scrollbar-arrow-next]",
    qa = "is-hidden",
    xa = 200;
  let Pa = class {
    init() {
      this.arrowNext &&
        this.arrowPrev &&
        (this.toggleNextArrow(), this.events());
    }
    resize() {
      document.addEventListener("theme:resize", () => {
        this.toggleNextArrow();
      });
    }
    events() {
      this.arrowNext.addEventListener("click", (t) => {
        t.preventDefault(), this.goToNext();
      }),
        this.arrowPrev.addEventListener("click", (t) => {
          t.preventDefault(), this.goToPrev();
        }),
        this.scrollbar.addEventListener("scroll", () => {
          this.togglePrevArrow(), this.toggleNextArrow();
        });
    }
    goToNext() {
      const t =
        (this.scrollbar.hasAttribute(Aa)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2) +
        this.scrollbar.scrollLeft;
      this.move(t), this.arrowPrev.classList.remove(qa), this.toggleNextArrow();
    }
    goToPrev() {
      const t = this.scrollbar.hasAttribute(Aa)
          ? this.scrollbar.getBoundingClientRect().width
          : this.scrollbar.getBoundingClientRect().width / 2,
        e = this.scrollbar.scrollLeft - t;
      this.move(e), this.arrowNext.classList.remove(qa), this.togglePrevArrow();
    }
    toggleNextArrow() {
      setTimeout(() => {
        this.arrowNext.classList.toggle(
          qa,
          Math.round(
            this.scrollbar.scrollLeft +
              this.scrollbar.getBoundingClientRect().width +
              1
          ) >= this.scrollbar.scrollWidth
        );
      }, xa);
    }
    togglePrevArrow() {
      setTimeout(() => {
        this.arrowPrev.classList.toggle(qa, this.scrollbar.scrollLeft <= 0);
      }, xa);
    }
    scrollToVisibleElement() {
      [].forEach.call(this.scrollbar.children, (t) => {
        t.addEventListener("click", (e) => {
          e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
        });
      });
    }
    move(t) {
      this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
    }
    constructor(t) {
      (this.scrollbar = t),
        (this.arrowNext = this.scrollbar.parentNode.querySelector(Ca)),
        (this.arrowPrev = this.scrollbar.parentNode.querySelector(Ta)),
        this.scrollbar.hasAttribute(La) && (this.init(), this.resize()),
        this.scrollbar.hasAttribute(ka) && this.scrollToVisibleElement();
    }
  };
  const Ha = "[data-grid-swatch-form]",
    Ma = "[data-product-grid-item]",
    Ia = "[data-product-information]",
    Ba = "[data-product-image]",
    Fa = "[data-swatch-button]",
    Da = "[data-swatch-link]",
    Oa = "[data-swatch-template]",
    $a = "is-visible",
    _a = "hidden",
    Ra = "no-events",
    Na = "swatch",
    za = "data-swatch-handle",
    Ua = "data-swatch-label",
    Wa = "data-scrollbar",
    Va = "data-swatch-count",
    ja = "data-tooltip",
    Xa = "data-swatch-variant-name",
    Ja = "data-variant-title";
  let Qa = class extends HTMLElement {
      connectedCallback() {
        this.hasAttribute(ja) && new zi(this);
      }
      constructor() {
        super();
      }
    },
    Ga = class extends HTMLElement {
      connectedCallback() {
        (this.handle = this.getAttribute(za)),
          (this.productItem = this.closest(Ma)),
          (this.productInfo = this.closest(Ia)),
          (this.productImage = this.productItem.querySelector(Ba)),
          (this.template = document.querySelector(Oa).innerHTML);
        const t = this.getAttribute(Ua).trim().toLowerCase();
        (function (t) {
          const e = `${window.theme.routes.root}products/${t}.js`;
          return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
              console.error(t);
            });
        })(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === t || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
      init() {
        (this.innerHTML = ""),
          (this.count = 0),
          this.swatches.forEach((t) => {
            let e = null,
              s = !1,
              i = "";
            for (const s of this.product.variants) {
              const o = s.options.includes(t);
              if ((!e && o && (e = s), o && s.featured_media)) {
                (i = s.featured_media.preview_image.src), (e = s);
                break;
              }
            }
            for (const e of this.product.variants) {
              if (e.options.includes(t) && e.available) {
                s = !0;
                break;
              }
            }
            if (e) {
              const r = document.createElement("div");
              r.innerHTML = this.template;
              const a = r.querySelector(Fa),
                l = r.querySelector(Da),
                c = t
                  .trim()
                  .toLowerCase()
                  .replace(/[^\w\s-]/g, "")
                  .replace(/\s+/g, "-")
                  .replace(/-+/g, "-"),
                h = e.title.replaceAll('"', "'");
              (a.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                a.classList.add(`${Na}-${c}`),
                (a.dataset.tooltip = t),
                (a.dataset.swatchVariant = e.id),
                (a.dataset.swatchVariantName = h),
                (a.dataset.swatchImage = i),
                (a.dataset.variant = e.id),
                a.style.setProperty("--swatch", `var(--${c})`),
                (l.href =
                  ((o = this.product.url),
                  (n = e.id),
                  /variant=/.test(o)
                    ? o.replace(/(variant=)[^&]+/, "$1" + n)
                    : /\?/.test(o)
                    ? o.concat("&variant=").concat(n)
                    : o.concat("?variant=").concat(n))),
                (l.innerText = t),
                (l.dataset.swatch = t),
                (l.disabled = !s),
                (this.innerHTML += r.innerHTML),
                this.count++;
            }
            var o, n;
          }),
          (this.swatchCount = this.productInfo.querySelector(`[${Va}]`)),
          (this.swatchElements = this.querySelectorAll(Da)),
          (this.swatchForm = this.productInfo.querySelector(Ha)),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(Va) &&
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productInfo.classList.add(Ra),
                this.swatchForm.classList.add($a);
            }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(Ra),
                  this.swatchForm.classList.remove($a);
              }, 100);
            })),
          this.hasAttribute(Wa) && new Pa(this),
          this.showDeferredImage(),
          this.bindSwatchButtonEvents();
      }
      showDeferredImage() {
        const t = this.productItem.querySelectorAll(`[${Ja}]`);
        t.length &&
          this.productItem.addEventListener(
            "mouseenter",
            () => {
              t.forEach((t) => {
                t.classList.remove(_a);
              });
            },
            { once: !0 }
          );
      }
      bindSwatchButtonEvents() {
        var t;
        null === (t = this.querySelectorAll(Fa)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("mouseenter", this.showVariantImageEvent),
              t.hasAttribute(ja) && new zi(t);
          }),
          this.productItem.addEventListener(
            "mouseleave",
            this.productItemMouseLeaveEvent
          );
      }
      showVariantImage(t) {
        var e;
        const s =
            null === (e = t.target.getAttribute(Xa)) || void 0 === e
              ? void 0
              : e.replaceAll('"', "'"),
          i = this.productImage.querySelectorAll(`[${Ja}]`),
          o = this.productImage.querySelector(`[${Ja}="${s}"]`);
        null == i ||
          i.forEach((t) => {
            t.classList.remove($a);
          }),
          null == o || o.classList.add($a);
      }
      hideVariantImages() {
        var t;
        null === (t = this.productImage.querySelectorAll(`[${Ja}].${$a}`)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.classList.remove($a);
          });
      }
      constructor() {
        super(),
          (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
          (this.showVariantImageEvent = (t) => this.showVariantImage(t));
      }
    };
  const Ya = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-product-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    Ka = "is-visible",
    Za = "is-fade",
    tl = "no-events",
    el = "is-active",
    sl = "data-sibling-cutline",
    il = "data-sibling-image",
    ol = "data-sibling-link",
    nl = "data-sibling-price",
    rl = "data-product-link";
  let al = class extends HTMLElement {
    connectedCallback() {
      (this.product = this.closest(Ya.productGridItem)),
        (this.siblingScrollbar = this.querySelector(Ya.siblingsInnerHolder)),
        (this.siblingCount = this.querySelector(Ya.siblingCount)),
        (this.siblingFieldset = this.querySelector(Ya.siblingFieldset)),
        (this.siblingLinks = this.querySelectorAll(Ya.siblingLink)),
        (this.productInfo = this.closest(Ya.productInfo)),
        (this.productLink = this.closest(Ya.link)),
        (this.hideSwatchesTimer = 0),
        this.initScrollbar(),
        this.siblingCount &&
          this.siblingFieldset &&
          this.productInfo &&
          (this.siblingCount.addEventListener("mouseenter", () =>
            this.showSiblings()
          ),
          this.productInfo.addEventListener("mouseleave", () =>
            this.hideSiblings()
          )),
        this.siblingLinks.length &&
          new (class {
            init() {
              this.cacheDefaultValues(),
                this.product.addEventListener("mouseleave", () =>
                  this.resetProductValues()
                ),
                this.swatches.forEach((t) => {
                  t.addEventListener("mouseenter", (t) => this.showSibling(t));
                }),
                this.productLinks.length &&
                  this.swatches.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.productLinks[0].click();
                    });
                  });
            }
            cacheDefaultValues() {
              (this.productLinkValue = this.productLinks[0].hasAttribute(rl)
                ? this.productLinks[0].getAttribute(rl)
                : ""),
                (this.productPriceValue = this.productPrice.innerHTML),
                this.productCutline &&
                  (this.productCutlineValue = this.productCutline.innerHTML);
            }
            resetProductValues() {
              this.product.classList.remove(el),
                this.productLinkValue &&
                  this.productLinks.forEach((t) => {
                    t.href = this.productLinkValue;
                  }),
                this.productPrice &&
                  (this.productPrice.innerHTML = this.productPriceValue),
                this.productCutline &&
                  this.productCutline &&
                  (this.productCutline.innerHTML = this.productCutlineValue),
                this.hideSiblingImage();
            }
            showSibling(t) {
              const e = t.target,
                s = e.hasAttribute(ol) ? e.getAttribute(ol) : "",
                i = e.hasAttribute(nl) ? e.getAttribute(nl) : "",
                o = e.hasAttribute(sl) ? e.getAttribute(sl) : "",
                n = e.hasAttribute(il) ? e.getAttribute(il) : "";
              s &&
                this.productLinks.forEach((t) => {
                  t.href = s;
                }),
                i && (this.productPrice.innerHTML = i),
                (this.productCutline.innerHTML = o || ""),
                n && this.showSiblingImage(n);
            }
            showSiblingImage(t) {
              if (!this.productImageSibling) return;
              const e = window.devicePixelRatio || 1,
                s = this.productImage.offsetWidth * e,
                i = 180 * Math.ceil(s / 180),
                o = r.getSizedImageUrl(t, `${i}x`),
                n = this.productImageSibling.querySelector(`[src="${o}"]`),
                a = () => {
                  this.productImageSibling.classList.add(Ka),
                    this.productImageSibling
                      .querySelector(`[src="${o}"]`)
                      .classList.add(Za);
                },
                l = () => {
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(Za);
                    }),
                    requestAnimationFrame(a);
                };
              if (n) l();
              else {
                const t = document.createElement("img");
                (t.src = o),
                  this.productCutline &&
                    (t.alt = this.productCutline.innerText),
                  t.addEventListener("load", () => {
                    this.productImageSibling.append(t), l();
                  });
              }
            }
            hideSiblingImage() {
              this.productImageSibling &&
                (this.productImageSibling.classList.remove(Ka),
                this.productImageSibling
                  .querySelectorAll("img")
                  .forEach((t) => {
                    t.classList.remove(Za);
                  }));
            }
            constructor(t, e) {
              (this.swatches = t),
                (this.product = e),
                (this.productLinks = this.product.querySelectorAll(
                  Ya.productLink
                )),
                (this.productCutline = this.product.querySelector(
                  Ya.productCutline
                )),
                (this.productPrice = this.product.querySelector(
                  Ya.productPrice
                )),
                (this.productImage = this.product.querySelector(
                  Ya.productImage
                )),
                (this.productImageSibling = this.product.querySelector(
                  Ya.productImageSibling
                )),
                this.init();
            }
          })(this.siblingLinks, this.product),
        this.querySelectorAll(Ya.tooltip).forEach((t) => {
          new zi(t);
        });
    }
    showSiblings() {
      this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
        this.productLink && this.productLink.classList.add(tl),
        this.siblingFieldset.classList.add(Ka);
    }
    hideSiblings() {
      this.hideSwatchesTimer = setTimeout(() => {
        this.productLink && this.productLink.classList.remove(tl),
          this.siblingFieldset.classList.remove(Ka);
      }, 100);
    }
    initScrollbar() {
      this.siblingScrollbar && new Pa(this.siblingScrollbar);
    }
    constructor() {
      super();
    }
  };
  const ll = "body",
    cl = "[data-related-section]",
    hl = "[data-tabs-holder]",
    dl = "data-tab",
    ul = "data-tab-index",
    pl = "[data-aos]",
    ml = "data-block-id",
    vl = "[data-tab]",
    gl = ".tab-link",
    fl = ".tab-link__recent",
    yl = ".tab-content",
    bl = "[data-scrollbar]",
    wl = "current",
    El = "hidden",
    Sl = "aos-animate",
    Ll = "aos-no-transition",
    kl = "is-focused",
    Al = {};
  const Tl = {
      onLoad() {
        Al[this.id] = [];
        this.container.querySelectorAll(hl).forEach((t) => {
          Al[this.id].push(
            new (class {
              init() {
                const t = this.container.querySelectorAll(vl);
                this.container.addEventListener("theme:tab:check", () =>
                  this.checkRecentTab()
                ),
                  this.container.addEventListener("theme:tab:hide", () =>
                    this.hideRelatedTab()
                  ),
                  t.length &&
                    t.forEach((t) => {
                      const e = parseInt(t.getAttribute(dl)),
                        s = this.container.querySelector(`${yl}-${e}`);
                      t.addEventListener("click", () => {
                        this.tabChange(t, s);
                      }),
                        t.addEventListener("keyup", (e) => {
                          ("Space" !== e.code && "Enter" !== e.code) ||
                            !this.body.classList.contains(kl) ||
                            this.tabChange(t, s);
                        });
                    });
              }
              tabChange(t, e) {
                if (t.classList.contains(wl)) return;
                const s = this.container.querySelector(`${vl}.${wl}`),
                  i = this.container.querySelector(`${yl}.${wl}`);
                null == s || s.classList.remove(wl),
                  null == i || i.classList.remove(wl),
                  t.classList.add(wl),
                  e.classList.add(wl),
                  t.classList.contains(El) && e.classList.add(El),
                  this.accessibility.a11y.removeTrapFocus(),
                  this.container.dispatchEvent(
                    new CustomEvent("theme:tab:change", { bubbles: !0 })
                  ),
                  t.dispatchEvent(
                    new CustomEvent("theme:form:sticky", {
                      bubbles: !0,
                      detail: { element: "tab" },
                    })
                  ),
                  this.animateItems(e);
              }
              animateItems(t, e = !0) {
                const s = t.querySelectorAll(pl);
                s.length &&
                  s.forEach((t) => {
                    t.classList.remove(Sl),
                      e &&
                        (t.classList.add(Ll),
                        requestAnimationFrame(() => {
                          t.classList.remove(Ll), t.classList.add(Sl);
                        }));
                  });
              }
              initNativeScrollbar() {
                this.scrollbarHolder.length &&
                  this.scrollbarHolder.forEach((t) => {
                    new Pa(t);
                  });
              }
              checkRecentTab() {
                const t = this.container.querySelector(fl);
                if (t) {
                  t.classList.remove(El);
                  const e = parseInt(t.getAttribute(dl)),
                    s = this.container.querySelector(`${yl}[${ul}="${e}"]`);
                  s && (s.classList.remove(El), this.animateItems(s, !1)),
                    this.initNativeScrollbar();
                }
              }
              hideRelatedTab() {
                const t = this.container.querySelector(cl);
                if (!t) return;
                const e = t.closest(`${yl}.${wl}`);
                if (!e) return;
                const s = parseInt(e.getAttribute(ul)),
                  i = this.container.querySelectorAll(vl);
                if (i.length > s) {
                  const t = i[s].nextSibling;
                  t &&
                    (i[s].classList.add(El),
                    t.dispatchEvent(new Event("click")),
                    this.initNativeScrollbar());
                }
              }
              onBlockSelect(t) {
                const e = this.container.querySelector(
                  `${gl}[${ml}="${t.detail.blockId}"]`
                );
                e &&
                  (e.dispatchEvent(new Event("click")),
                  e.parentNode.scrollTo({
                    top: 0,
                    left: e.offsetLeft - e.clientWidth,
                    behavior: "smooth",
                  }));
              }
              constructor(t) {
                (this.container = t),
                  (this.body = document.querySelector(ll)),
                  (this.accessibility = window.accessibility),
                  this.container &&
                    ((this.scrollbarHolder =
                      this.container.querySelectorAll(bl)),
                    this.init(),
                    this.initNativeScrollbar());
              }
            })(t)
          );
        });
      },
      onBlockSelect(t) {
        Al[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
    },
    Cl = "data-media-id",
    ql = "data-tall-layout",
    xl = "data-thumb-index",
    Pl = "[data-deferred-media-button]",
    Hl = "model-viewer, video, iframe, button, [href], input, [tabindex]",
    Ml = ".is-active",
    Il = "data-type",
    Bl = "data-slideshow-disabled-mobile",
    Fl = "[data-product-slideshow]",
    Dl = "[data-thumb-item]",
    Ol = "[data-thumb-link]",
    $l = "[data-thumbs-slider]",
    _l = "[data-zoom-wrapper]",
    Rl = "is-active",
    Nl = "is-focused",
    zl = "is-dragging",
    Ul = "is-initialized",
    Wl = "is-selected",
    Vl = "flickity-enabled",
    jl = "media--hidden",
    Xl = "aria-current",
    Jl = "data-options";
  let Ql = {},
    Gl = class {
      init() {
        this.slideshow &&
          (this.tallLayout
            ? this.mobileSliderDisabled ||
              (this.initSliderMobile(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderMobileEvent
              ))
            : this.mobileSliderDisabled
            ? (this.initSliderDesktop(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderDesktopEvent
              ))
            : this.createSlider());
      }
      initSliderMobile() {
        S() ? this.createSlider() : this.destroySlider();
      }
      initSliderDesktop() {
        S() ? this.destroySlider() : this.createSlider();
      }
      destroySlider() {
        this.slideshow.classList.contains(Vl) && this.flkty.destroy();
      }
      createSlider() {
        if (!this.slideshow || (this.mobileSliderDisabled && S())) return;
        const t = {
            autoPlay: !1,
            pageDots: !1,
            wrapAround: !0,
            dragThreshold: 90,
            ...this.customOptions,
          },
          e = this,
          s = this.slideshow.querySelectorAll(`[${Il}]`)[0];
        let i = {
          ...t,
          on: {
            ready: function () {
              const t = this.element;
              t.addEventListener("keyup", (e) => {
                if ("Enter" === e.code) {
                  const e = t.querySelector(`.${Wl} ${_l}`);
                  e &&
                    (e.dispatchEvent(new Event("click", { bubbles: !1 })),
                    (window.accessibility.lastElement = t));
                }
              }),
                requestAnimationFrame(() => {
                  e.slideshow.classList.add(Ul);
                }),
                e.sliderThumbs(this),
                e.accessibilityActions(this);
            },
          },
        };
        if (((this.flkty = new n(this.slideshow, i)), this.flkty.resize(), s)) {
          const t = s.getAttribute(Il);
          ("model" !== t && "video" !== t && "external_video" !== t) ||
            ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
        }
        this.flkty.on("change", function (t) {
          let s = t;
          if (e.thumbSlider) {
            const i = e.thumbSlider.querySelector(Ml),
              o = e.thumbSlider.querySelector(`${Dl} [${xl}="${t}"]`);
            if (i) {
              const t = i.querySelector(`[${xl}]`);
              (s = Array.from(i.parentElement.children).indexOf(i)),
                i.classList.remove(Rl),
                t && t.setAttribute(Xl, !1);
            }
            o && (o.parentElement.classList.add(Rl), o.setAttribute(Xl, !0)),
              e.scrollToThumb();
          }
          const i = this.cells[s].element,
            o = this.selectedElement;
          i.dispatchEvent(new CustomEvent("theme:media:hidden")),
            o.classList.remove(jl);
        }),
          this.flkty.on("settle", function () {
            const t = this.selectedElement,
              s = Array.prototype.filter.call(
                t.parentNode.children,
                function (e) {
                  return e !== t;
                }
              ),
              i = t.getAttribute(Il),
              o = document.body.classList.contains(Nl);
            "model" === i || "video" === i || "external_video" === i
              ? ((e.flkty.options.draggable = !1), e.flkty.updateDraggable())
              : ((e.flkty.options.draggable = !0), e.flkty.updateDraggable()),
              o && t.dispatchEvent(new Event("focus")),
              s.length &&
                s.forEach((t) => {
                  t.classList.add(jl);
                }),
              t.dispatchEvent(new CustomEvent("theme:media:visible"));
            const n = t.querySelector("deferred-media");
            n &&
              !0 !== n.getAttribute("loaded") &&
              t
                .querySelector(Pl)
                .dispatchEvent(new Event("click", { bubbles: !1 })),
              e.accessibilityActions(this);
          }),
          this.flkty.on("dragStart", (t, e) => {
            t.target.classList.add(zl);
          }),
          this.flkty.on("dragEnd", (t, e) => {
            const s = this.flkty.element.querySelector(`.${zl}`);
            s && s.classList.remove(zl);
          });
      }
      accessibilityActions(t) {
        const e = t.slides;
        e.length &&
          e.forEach((t) => {
            const e = t.cells[0].element,
              s = e.querySelectorAll(Hl);
            e.classList.contains(Wl)
              ? e.removeAttribute("tabindex")
              : e.setAttribute("tabindex", "-1"),
              s.length &&
                s.forEach((t) => {
                  e.classList.contains(Wl)
                    ? t.removeAttribute("tabindex")
                    : t.setAttribute("tabindex", "-1");
                });
          });
      }
      scrollToThumb() {
        const t = this.thumbSlider;
        if (t) {
          const e = t.querySelector(Ml);
          if (!e) return;
          const s = t.scrollTop,
            i = t.scrollLeft,
            o = t.offsetWidth,
            n = t.offsetHeight,
            r = s + n,
            a = i + o,
            l = e.offsetTop,
            c = e.offsetLeft,
            h = e.offsetWidth,
            d = e.offsetHeight,
            u = s > l,
            p = i > c,
            m = c + h > a,
            v = l + d > r || u,
            g = m || p,
            f = S();
          if (v || g) {
            let e = l - n + d,
              s = c - o + h;
            u && (e = l),
              m &&
                f &&
                (s += parseInt(window.getComputedStyle(t).paddingRight)),
              p &&
                ((s = c),
                f && (s -= parseInt(window.getComputedStyle(t).paddingLeft))),
              t.scrollTo({ top: e, left: s, behavior: "smooth" });
          }
        }
      }
      sliderThumbs(t) {
        this.thumbLinks.length &&
          this.thumbLinks.forEach((e) => {
            e.addEventListener("click", (t) => {
              t.preventDefault();
              const s = e.hasAttribute(xl) ? parseInt(e.getAttribute(xl)) : 0;
              this.flkty.select(s);
            }),
              e.addEventListener("keyup", (s) => {
                if ("Enter" === s.code) {
                  const s = e.getAttribute(Cl),
                    i = t.element
                      .querySelector(`[${Cl}="${s}"]`)
                      .querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
                  i &&
                    (i.dispatchEvent(new Event("focus")),
                    i.dispatchEvent(new Event("select")));
                }
              });
          });
      }
      onUnload() {
        this.tallLayout
          ? this.mobileSliderDisabled ||
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderMobileEvent
            )
          : this.mobileSliderDisabled &&
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderDesktopEvent
            );
      }
      constructor(t, e = null) {
        (this.container = e || t.container),
          (this.tallLayout = "true" === this.container.getAttribute(ql)),
          (this.slideshow = this.container.querySelector(Fl)),
          (this.thumbSlider = this.container.querySelector($l)),
          (this.thumbLinks = this.container.querySelectorAll(Ol)),
          (this.mobileSliderDisabled =
            "true" === this.container.getAttribute(Bl)),
          (this.initSliderMobileEvent = () => this.initSliderMobile()),
          (this.initSliderDesktopEvent = () => this.initSliderDesktop()),
          this.slideshow &&
            this.slideshow.hasAttribute(Jl) &&
            (this.customOptions = JSON.parse(
              decodeURIComponent(this.slideshow.getAttribute(Jl))
            )),
          (this.flkty = null),
          this.init();
      }
    };
  const Yl = {
      onLoad() {
        Ql[this.id] = new Gl(this);
      },
      onUnload(t) {
        Ql[this.id].onUnload(t);
      },
    },
    Kl = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
      focused: "is-focused",
    },
    Zl = 3e3,
    tc = "[data-animation]",
    ec = "[data-api-content]",
    sc = "[data-quick-add-btn]",
    ic = "[data-add-to-cart]",
    oc = "[data-cart-drawer]",
    nc = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    rc = "[data-message-error]",
    ac = "[data-quick-add-modal-handle]",
    lc = "[data-product-upsell-ajax]",
    cc = "[data-quick-add-modal-close]",
    hc = "data-product-grid-item",
    dc = "[data-product-information]",
    uc = "[data-quick-add-holder]",
    pc = "[data-quick-add-modal]",
    mc = "[data-quick-add-modal-template]",
    vc = "closing",
    gc = "data-product-id",
    fc = "data-quick-add-modal-handle",
    yc = "data-sibling-swapper",
    bc = "data-quick-add-holder";
  let wc = class extends HTMLElement {
    connectedCallback() {
      this.modalButton &&
        this.modalButton.addEventListener("click", this.modalButtonClickEvent),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                })
              );
          }),
        this.quickAddHolder &&
          (this.quickAddHolder.addEventListener(
            "animationend",
            this.quickAddLoadingToggle
          ),
          this.errorHandler());
    }
    modalButtonClickEvent(t) {
      t.preventDefault();
      const e = this.modalButton.hasAttribute(yc),
        s = this.modalButton.classList.contains(Kl.siblingLinkCurrent);
      s ||
        (this.modalButton.classList.add(Kl.loading),
        (this.modalButton.disabled = !0),
        e &&
          !s &&
          ((this.currentModal = t.target.closest(pc)),
          this.currentModal.classList.add(Kl.loading)),
        this.renderModal());
    }
    modalCreate(t) {
      const e = document.querySelector(`${pc}[${gc}="${this.productId}"]`);
      if (e) (this.modal = e), this.modalOpen();
      else {
        const e = this.quickAddHolder.querySelector(mc);
        if (!e) return;
        const s = document.createElement("div");
        (s.innerHTML = e.innerHTML),
          document.body.appendChild(s.querySelector(pc)),
          e.remove(),
          (this.modal = document.querySelector(
            `${pc}[${gc}="${this.productId}"]`
          )),
          (this.modal.querySelector(lc).innerHTML = new DOMParser()
            .parseFromString(t, "text/html")
            .querySelector(ec).innerHTML),
          this.modalCreatedCallback();
      }
    }
    modalOpen() {
      "function" == typeof this.modal.show && this.modal.show(),
        this.modal.setAttribute("open", !0),
        this.modal.removeAttribute("inert"),
        this.currentModal &&
          this.currentModal.dispatchEvent(
            new CustomEvent("theme:modal:close", { bubbles: !1 })
          );
      (
        this.modal.querySelector("[autofocus]") || this.modal.querySelector(nc)
      ).focus(),
        this.quickAddHolder.classList.add(Kl.disabled),
        this.modalButton &&
          (this.modalButton.classList.remove(Kl.loading),
          (this.modalButton.disabled = !1)),
        requestAnimationFrame(() => {
          this.modal.querySelectorAll(tc).forEach((t) => {
            t.classList.add(Kl.animated);
          });
        }),
        document.dispatchEvent(
          new CustomEvent("theme:quick-add:open", { bubbles: !0 })
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        document.addEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded,
          { once: !0 }
        );
    }
    modalClose() {
      if (this.isAnimating) return;
      if (!this.modal.hasAttribute(vc))
        return this.modal.setAttribute(vc, ""), void (this.isAnimating = !0);
      "function" == typeof this.modal.close
        ? this.modal.close()
        : this.modal.removeAttribute("open"),
        this.modal.removeAttribute(vc),
        this.modal.setAttribute("inert", ""),
        this.modal.classList.remove(Kl.loading),
        this.modalButton && (this.modalButton.disabled = !1),
        this.quickAddHolder &&
          this.quickAddHolder.classList.contains(Kl.disabled) &&
          this.quickAddHolder.classList.remove(Kl.disabled),
        this.resetAnimatedItems();
      const t = this.cartDrawer && this.cartDrawer.classList.contains(Kl.open),
        e = document.querySelector("dialog[open]");
      t ||
        e ||
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        document.removeEventListener(
          "theme:product:added",
          this.modalCloseOnProductAdded
        );
    }
    modalEvents() {
      var t;
      null === (t = this.modal.querySelector(cc)) ||
        void 0 === t ||
        t.addEventListener("click", (t) => {
          t.preventDefault(), this.modalClose();
        }),
        this.modal.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.modalClose();
        }),
        this.modal.addEventListener("keydown", (t) => {
          "Escape" == t.code && (t.preventDefault(), this.modalClose());
        }),
        this.modal.addEventListener("theme:modal:close", () => {
          this.modalClose();
        }),
        this.modal.addEventListener("animationend", (t) => {
          t.target === this.modal &&
            ((this.isAnimating = !1),
            this.modal.hasAttribute(vc) &&
              (this.modalClose(),
              document.body.classList.contains(Kl.focused) &&
                this.buttonQuickAdd &&
                (this.buttonQuickAdd.addEventListener(
                  "transitionend",
                  () => {
                    this.buttonQuickAdd.focus(),
                      this.buttonQuickAdd.classList.remove(Kl.visible);
                  },
                  { once: !0 }
                ),
                this.buttonQuickAdd.classList.add(Kl.visible))));
        });
    }
    modalCloseOnProductAdded() {
      this.resetQuickAddButtons(),
        this.modal && this.modal.hasAttribute("open") && this.modalClose();
    }
    quickAddLoadingToggle(t) {
      t.target == this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Kl.disabled);
    }
    errorHandler() {
      this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
        const e = t.detail.holder,
          s = e.closest(`[${hc}]`);
        if (!s) return;
        const i = e.querySelector(rc),
          o = s.classList.contains(Kl.overlayText),
          n = s.querySelector(dc),
          r = e.querySelector(ic);
        r &&
          (r.classList.remove(Kl.added, Kl.loading), e.classList.add(Kl.error)),
          i && (i.innerText = t.detail.description),
          o && n.classList.add(Kl.hidden),
          setTimeout(() => {
            this.resetQuickAddButtons(), o && n.classList.remove(Kl.hidden);
          }, Zl);
      });
    }
    resetQuickAddButtons() {
      this.quickAddHolder &&
        this.quickAddHolder.classList.remove(Kl.visible, Kl.error),
        this.buttonQuickAdd &&
          (this.buttonQuickAdd.classList.remove(Kl.added),
          (this.buttonQuickAdd.disabled = !1));
    }
    renderModal() {
      this.modal
        ? this.modalOpen()
        : window
            .fetch(
              `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
            )
            .then(this.upsellErrorsHandler)
            .then((t) => t.text())
            .then((t) => {
              this.modalCreate(t);
            });
    }
    modalCreatedCallback() {
      this.modalEvents(),
        this.modalOpen(),
        new Gl(null, this.modal),
        F(this.modal);
    }
    upsellErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new te({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    resetAnimatedItems() {
      var t;
      null === (t = this.modal) ||
        void 0 === t ||
        t.querySelectorAll(tc).forEach((t) => {
          t.classList.remove(Kl.animated);
        });
    }
    constructor() {
      var t;
      (super(),
      (this.container = this),
      (this.quickAddHolder = this.container.querySelector(uc)),
      this.quickAddHolder) &&
        ((this.modal = null),
        (this.currentModal = null),
        (this.productId = this.quickAddHolder.getAttribute(bc)),
        (this.modalButton = this.quickAddHolder.querySelector(ac)),
        (this.handle =
          null === (t = this.modalButton) || void 0 === t
            ? void 0
            : t.getAttribute(fc)),
        (this.cartDrawer = document.querySelector(oc)),
        (this.buttonQuickAdd = this.quickAddHolder.querySelector(sc)),
        (this.buttonATC = this.quickAddHolder.querySelector(ic)),
        (this.button = this.modalButton || this.buttonATC),
        (this.modalClose = this.modalClose.bind(this)),
        (this.modalCloseOnProductAdded =
          this.modalCloseOnProductAdded.bind(this)),
        (this.isAnimating = !1),
        (this.modalButtonClickEvent = this.modalButtonClickEvent.bind(this)),
        (this.quickAddLoadingToggle = this.quickAddLoadingToggle.bind(this)));
    }
  };
  Pi("product-grid", [bo, Tl]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", wc),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Qa),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", Ga),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", al);
  const Ec = (t, e) => {
      const {
        el: s,
        elStyle: i,
        elHeight: o,
        rowsLimit: n,
        rowsWrapped: r,
        options: a,
      } = t;
      let l = t.buffer,
        c = l;
      if (r === n + 1) return { ...t };
      const h = l;
      let d = r,
        u = o;
      return (
        (s.innerHTML = c =
          l.length
            ? `${l}${a.delimiter}${e}${a.replaceStr}`
            : `${e}${a.replaceStr}`),
        parseFloat(i.height) > parseFloat(o) &&
        (d++, (u = i.height), d === n + 1)
          ? ((s.innerHTML = c =
              "." === h[h.length - 1] && "..." === a.replaceStr
                ? `${h}..`
                : `${h}${a.replaceStr}`),
            { ...t, elHeight: u, rowsWrapped: d })
          : ((s.innerHTML = c = h.length ? `${h}${a.delimiter}${e}` : `${e}`),
            { ...t, buffer: c, elHeight: u, rowsWrapped: d })
      );
    },
    Sc = "complementary-products",
    Lc = "quick-add-product",
    kc = "is-loaded",
    Ac = "data-url";
  let Tc = class extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(
        ((t, e) => {
          t[0].isIntersecting &&
            (e.unobserve(this),
            this.hasAttribute(Ac) &&
              "" !== this.getAttribute(Ac) &&
              fetch(this.getAttribute(Ac))
                .then((t) => t.text())
                .then((t) => {
                  const e = document.createElement("div");
                  e.innerHTML = t;
                  const s = e.querySelector(Sc);
                  s &&
                    s.innerHTML.trim().length &&
                    (this.innerHTML = s.innerHTML),
                    e.querySelector(`${Sc} ${Lc}`) && this.classList.add(kc);
                })
                .catch((t) => {
                  console.error(t);
                }));
        }).bind(this),
        { rootMargin: "0px 0px 400px 0px" }
      ).observe(this);
    }
    constructor() {
      super();
    }
  };
  const Cc = 'input:not([type="checkbox"]):not([type="hidden"]), textarea',
    qc = 'input[type="email"]',
    xc = 'input[type="checkbox"]',
    Pc = "[data-form-wrapper]";
  let Hc = class extends HTMLElement {
    connectedCallback() {
      this.fieldCheckbox &&
        (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
        this.form &&
          this.form.addEventListener("theme:product:add", () => {
            (this.fieldCheckbox.checked = !1),
              this.fieldCheckbox.dispatchEvent(new Event("change"));
          }));
    }
    clearInputValues() {
      this.fields.length &&
        this.fields.forEach((t) => {
          t.value = "";
        });
    }
    onChange(t) {
      (this.fieldEmail.required = Boolean(t.target.checked)),
        t.target.checked || this.clearInputValues();
    }
    disconnectedCallback() {
      this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
    }
    constructor() {
      super(),
        (this.fieldCheckbox = this.querySelector(xc)),
        (this.fieldEmail = this.querySelector(qc)),
        (this.fields = this.querySelectorAll(Cc)),
        (this.form = this.closest(Pc)),
        (this.onChangeEvent = (t) => this.onChange(t));
    }
  };
  const Mc = "[data-product-slideshow]",
    Ic = "data-sticky-enabled",
    Bc = ".product__page",
    Fc = "[data-form-wrapper]",
    Dc = "[data-header-sticky]",
    Oc = "is-sticky";
  window.theme.variables = { productPageSticky: !1 };
  const $c = {};
  const _c = {
      onLoad() {
        $c[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener("theme:form:sticky", (t) => {
                this.removeAnimationFrame(),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  ));
              }),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.initSticky();
          }
          stickyScrollCheck() {
            const t = this.container.querySelector(`${Bc} ${Fc}`);
            if (t)
              if (E()) {
                const e = this.container.querySelector(Fc),
                  s = this.container.querySelector(Mc);
                if (!e || !s) return;
                e.offsetHeight < s.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    t.classList.add(Oc))
                  : ((theme.variables.productPageSticky = !1),
                    t.classList.remove(Oc));
              } else
                (theme.variables.productPageSticky = !1),
                  t.classList.remove(Oc);
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrame();
            const e = Boolean(t && t.detail),
              s = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              i = this.formWrapper.offsetHeight,
              o = window.innerHeight - i - this.defaultTopBottomSpacings,
              n = Math.abs(this.scrollTop - this.scrollLastPosition);
            if (
              (this.scrollDirectionDown
                ? (this.stickyScrollTop -= n)
                : (this.stickyScrollTop += n),
              this.stickyFormLoad)
            ) {
              if (document.querySelector(Dc)) {
                let { headerHeight: t } = c();
                this.stickyDefaultTop = t;
              } else this.stickyDefaultTop = this.defaultTopBottomSpacings;
              this.stickyScrollTop = this.stickyDefaultTop;
            }
            this.stickyScrollTop = Math.min(
              Math.max(this.stickyScrollTop, o),
              this.stickyDefaultTop
            );
            const r = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * r),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (s && this.onChangeCounter <= 10) ||
              (s && this.stickyFormLastHeight !== i) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (s && (this.onChangeCounter += 1),
                  s &&
                    this.stickyFormLastHeight !== i &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.stickyFormLastHeight = i);
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled = "true" === this.container.getAttribute(Ic)),
              (this.formWrapper = this.container.querySelector(Fc)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        $c[this.id].onUnload();
      },
    },
    Rc = "data-section-type",
    Nc = "[data-share-button]",
    zc = "[data-share-message]",
    Uc = "is-visible";
  let Wc = class extends HTMLElement {
    init() {
      navigator.share
        ? this.shareButton.addEventListener("click", () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          })
        : this.shareButton.addEventListener(
            "click",
            this.copyToClipboard.bind(this)
          );
    }
    updateShareLink() {
      "product" == this.container.getAttribute(Rc) &&
        this.container.addEventListener("theme:variant:change", (t) => {
          t.detail.variant &&
            (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
              t.detail.variant.id
            }`);
        });
    }
    copyToClipboard() {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.shareMessage.classList.add(Uc);
        const t = () => {
          this.shareMessage.classList.remove(Uc),
            this.shareMessage.removeEventListener("animationend", t);
        };
        this.shareMessage.addEventListener("animationend", t);
      });
    }
    constructor() {
      super(),
        (this.container = this.closest(`[${Rc}]`)),
        (this.shareButton = this.querySelector(Nc)),
        (this.shareMessage = this.querySelector(zc)),
        (this.urlToShare = this.shareButton.dataset.shareUrl
          ? this.shareButton.dataset.shareUrl
          : document.location.href),
        this.init(),
        this.updateShareLink();
    }
  };
  const Vc = "data-option-position",
    jc = '[name^="options"], [data-popout-option]',
    Xc = '[name^="options"]:checked, [name^="options"][type="hidden"]',
    Jc = "data-value",
    Qc = "[data-popout]",
    Gc = "sold-out",
    Yc = "unavailable",
    Kc = "sale";
  const Zc = "[data-product]",
    th = "[data-product-form]",
    eh = "[data-add-to-cart]",
    sh = "[data-add-to-cart-text]",
    ih = "[data-compare-price]",
    oh = "[data-compare-text]",
    nh = "[data-form-wrapper]",
    rh = "[data-product-select]",
    ah = "[data-price-wrapper]",
    lh = "[data-product-slideshow]",
    ch = "[data-product-json]",
    hh = "[data-product-price]",
    dh = "[data-product-unit-price]",
    uh = "[data-product-base]",
    ph = "[data-product-unit]",
    mh = "[data-product-preorder]",
    vh = "flickity-enabled",
    gh = ".product__slide",
    fh = "[data-subscription-watch-price]",
    yh = "[data-subscription-selectors]",
    bh = "[data-toggles-group]",
    wh = "data-group-toggle",
    Eh = "[data-plan-description]",
    Sh = "[data-section-type]",
    Lh = "[data-quick-add-modal]",
    kh = "[data-price-off]",
    Ah = "[data-price-off-type]",
    Th = "[data-price-off-amount]",
    Ch = "[data-remaining-count]",
    qh = "[data-remaining-max]",
    xh = "[data-remaining-wrapper]",
    Ph = "[data-product-remaining-json]",
    Hh = "[data-option-value]",
    Mh = "[data-option-position]",
    Ih = "[data-product-form-installment]",
    Bh = 'input[name="id"]',
    Fh = "hidden",
    Dh = "variant--soldout",
    Oh = "variant--unavailable",
    $h = "product__price--sale",
    _h = "count-is-low",
    Rh = "count-is-in",
    Nh = "count-is-out",
    zh = "count-is-unavailable",
    Uh = "data-tall-layout",
    Wh = "data-remaining-max",
    Vh = "data-enable-history-state",
    jh = "data-option-position",
    Xh = "data-image-id",
    Jh = "data-quick-add-btn";
  let Qh = class extends HTMLElement {
    connectedCallback() {
      if (
        (this.cartAddEvents(),
        (this.container = this.closest(Sh) || this.closest(Lh)),
        !this.container)
      )
        return;
      if (
        ((this.sectionId = this.container.dataset.sectionId),
        (this.tallLayout = "true" === this.container.getAttribute(Uh)),
        (this.product = this.container.querySelector(Zc)),
        (this.productForm = this.container.querySelector(th)),
        (this.installmentForm = this.container.querySelector(Ih)),
        (this.sellout = null),
        (this.priceOffWrap = this.container.querySelector(kh)),
        (this.priceOffAmount = this.container.querySelector(Th)),
        (this.priceOffType = this.container.querySelector(Ah)),
        (this.planDescription = this.container.querySelector(Eh)),
        (this.remainingWrapper = this.container.querySelector(xh)),
        this.remainingWrapper)
      ) {
        const t = this.container.querySelector(qh);
        t &&
          ((this.remainingMaxInt = parseInt(t.getAttribute(Wh), 10)),
          (this.remainingCount = this.container.querySelector(Ch)),
          (this.remainingJSONWrapper = this.container.querySelector(Ph)),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
          "" !== this.remainingJSONWrapper.innerHTML
            ? (this.remainingJSON = JSON.parse(
                this.remainingJSONWrapper.innerHTML
              ))
            : console.warn("Missing product quantity JSON"));
      }
      (this.enableHistoryState = "true" === this.container.getAttribute(Vh)),
        (this.hasUnitPricing = this.container.querySelector(ph)),
        (this.subSelectors = this.container.querySelector(yh)),
        (this.subPrices = this.container.querySelector(fh)),
        (this.isPreOrder = this.container.querySelector(mh));
      let t = null;
      const e = this.container.querySelector(ch);
      e && (t = e.innerHTML),
        t
          ? ((this.productJSON = JSON.parse(t)),
            this.linkForm(),
            (this.sellout = new (class {
              init() {
                this.update();
              }
              update() {
                this.getCurrentState(),
                  this.optionElements.forEach((t) => {
                    const e = t.closest(`[${Vc}]`);
                    if (!e) return;
                    const s = t.value || t.getAttribute(Jc),
                      i = e.getAttribute(Vc),
                      o = parseInt(i, 10) - 1,
                      n = t.closest(Qc);
                    let r = [...this.selections];
                    r[o] = s;
                    const a = this.productJSON.variants.find((t) => {
                      let e = !0;
                      for (let s = 0; s < r.length; s++)
                        t.options[s] !== r[s] && (e = !1);
                      return e;
                    });
                    t.classList.remove(Gc, Yc),
                      t.parentNode.classList.remove(Kc),
                      n && n.classList.remove(Gc, Yc, Kc),
                      void 0 === a
                        ? (t.classList.add(Yc), n && n.classList.add(Yc))
                        : a &&
                          !1 === a.available &&
                          (t.classList.add(Gc), n && n.classList.add(Gc)),
                      a &&
                        a.compare_at_price > a.price &&
                        theme.settings.variantOnSale &&
                        t.parentNode.classList.add(Kc);
                  });
              }
              getCurrentState() {
                this.selections = [];
                const t = this.container.querySelectorAll(Xc);
                t.length &&
                  t.forEach((t) => {
                    const e = t.value;
                    e && "" !== e && this.selections.push(e);
                  });
              }
              constructor(t, e) {
                (this.container = t),
                  (this.productJSON = e),
                  (this.optionElements = this.container.querySelectorAll(jc)),
                  this.productJSON && this.optionElements.length && this.init();
              }
            })(this.container, this.productJSON)))
          : console.error("Missing product JSON");
    }
    cartAddEvents() {
      (this.buttonATC = this.querySelector(eh)),
        this.buttonATC &&
          this.buttonATC.addEventListener("click", (t) => {
            t.preventDefault(),
              document.dispatchEvent(
                new CustomEvent("theme:cart:add", {
                  detail: { button: this.buttonATC },
                  bubbles: !1,
                })
              );
          });
    }
    destroy() {
      this.productForm.destroy();
    }
    linkForm() {
      (this.productForm = new (class {
        destroy() {
          this._listeners.removeAll();
        }
        options() {
          return this._serializeInputValues(this.optionInputs, function (t) {
            return (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t;
          });
        }
        variant() {
          const t = this.options();
          return t.length ? ga(this.product, t) : this.product.variants[0];
        }
        plan(t) {
          let e = { allocation: null, group: null, detail: null };
          const s = this.element.querySelector(`${ba}:checked`);
          if (!s) return null;
          const i = s.value,
            o = i && "" !== i ? i : null;
          return (
            o &&
              t &&
              (e.allocation = t.selling_plan_allocations.find(function (t) {
                return t.selling_plan_id.toString() === o.toString();
              })),
            e.allocation &&
              (e.group = this.product.selling_plan_groups.find(function (t) {
                return (
                  t.id.toString() ===
                  e.allocation.selling_plan_group_id.toString()
                );
              })),
            e.group &&
              (e.detail = e.group.selling_plans.find(function (t) {
                return t.id.toString() === o.toString();
              })),
            e && e.allocation && e.detail && e.allocation ? e : null
          );
        }
        properties() {
          return this._serializeInputValues(this.propertyInputs, function (t) {
            return (
              (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
            );
          });
        }
        quantity() {
          return this.quantityInputs[0]
            ? Number.parseInt(this.quantityInputs[0].value, 10)
            : 1;
        }
        getFormState() {
          const t = this.variant();
          return {
            options: this.options(),
            variant: t,
            properties: this.properties(),
            quantity: this.quantity(),
            plan: this.plan(t),
          };
        }
        _setIdInputValue(t) {
          t && t.id
            ? (this.variantElement.value = t.id.toString())
            : (this.variantElement.value = ""),
            this.variantElement.dispatchEvent(new Event("change"));
        }
        _onSubmit(t, e) {
          (e.dataset = this.getFormState()),
            t.onFormSubmit && t.onFormSubmit(e);
        }
        _onOptionChange(t) {
          this._setIdInputValue(t.dataset.variant);
        }
        _onFormEvent(t) {
          return void 0 === t
            ? Function.prototype.bind()
            : function (e) {
                (e.dataset = this.getFormState()),
                  this._setIdInputValue(e.dataset.variant),
                  t(e);
              }.bind(this);
        }
        _initInputs(t, e) {
          return Array.prototype.slice
            .call(this.element.querySelectorAll(t))
            .map(
              function (t) {
                return (
                  this._listeners.add(t, "change", this._onFormEvent(e)), t
                );
              }.bind(this)
            );
        }
        _serializeInputValues(t, e) {
          return t.reduce(function (t, s) {
            return (
              (s.checked || ("radio" !== s.type && "checkbox" !== s.type)) &&
                t.push(e({ name: s.name, value: s.value })),
              t
            );
          }, []);
        }
        _validateProductObject(t) {
          if ("object" != typeof t)
            throw new TypeError(t + " is not an object.");
          if (void 0 === t.variants[0].options)
            throw new TypeError(
              "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
            );
          return t;
        }
        constructor(t, e, s) {
          (this.element = t),
            (this.product = this._validateProductObject(e)),
            (this.variantElement = this.element.querySelector(ya)),
            (s = s || {}),
            (this._listeners = new va()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, s)
            ),
            (this.optionInputs = this._initInputs(wa, s.onOptionChange)),
            (this.planInputs = this._initInputs(ba, s.onPlanChange)),
            (this.quantityInputs = this._initInputs(Ea, s.onQuantityChange)),
            (this.propertyInputs = this._initInputs(Sa, s.onPropertyChange));
        }
      })(this.container, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      })),
        this.pushState(this.productForm.getFormState(), !0),
        this.subsToggleListeners();
    }
    onOptionChange(t) {
      this.pushState(t.dataset), this.updateProductImage(t);
    }
    onPlanChange(t) {
      this.subPrices && this.pushState(t.dataset);
    }
    pushState(t, e = !1) {
      var s;
      (this.productState = this.setProductState(t)),
        this.updateAddToCartState(t),
        this.updateProductPrices(t),
        this.updateSaleText(t),
        this.updateSubscriptionText(t),
        this.updateRemaining(t),
        this.updateLegend(t),
        this.fireHookEvent(t),
        null === (s = this.sellout) || void 0 === s || s.update(t),
        this.enableHistoryState && !e && this.updateHistoryState(t);
    }
    updateAddToCartState(t) {
      const e = t.variant;
      let s = theme.strings.addToCart;
      const i = this.container.querySelectorAll(ah),
        o = this.container.querySelectorAll(eh),
        n = this.container.querySelectorAll(sh),
        r = this.container.querySelectorAll(nh);
      if (this.installmentForm && e) {
        const t = this.installmentForm.querySelector(Bh);
        (t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      this.isPreOrder && (s = theme.strings.preOrder),
        i.length &&
          e &&
          i.forEach((t) => {
            t.classList.remove(Fh);
          }),
        o.length &&
          o.forEach((t) => {
            t.hasAttribute(Jh) ||
              (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
          }),
        n.length &&
          n.forEach((t) => {
            e
              ? e.available
                ? (t.innerHTML = s)
                : (t.innerHTML = theme.strings.soldOut)
              : (t.innerHTML = theme.strings.unavailable);
          }),
        r.length &&
          r.forEach((t) => {
            if (e) {
              e.available
                ? t.classList.remove(Dh, Oh)
                : (t.classList.add(Dh), t.classList.remove(Oh));
              const s = t.querySelector(rh);
              s && (s.value = e.id);
              const i = t.querySelector(`${Bh}[form]`);
              i && ((i.value = e.id), i.dispatchEvent(new Event("change")));
            } else t.classList.add(Oh), t.classList.remove(Dh);
          });
    }
    updateHistoryState(t) {
      const e = t.variant,
        s = t.plan,
        i = window.location.href;
      if (e && i.includes("/product")) {
        const t = new window.URL(i),
          o = t.searchParams;
        o.set("variant", e.id),
          s && s.detail && s.detail.id && this.productState.hasPlan
            ? o.set("selling_plan", s.detail.id)
            : o.delete("selling_plan"),
          (t.search = o.toString());
        const n = t.toString();
        window.history.replaceState({ path: n }, "", n);
      }
    }
    updateRemaining(t) {
      var e;
      const s = t.variant;
      if (
        (null === (e = this.remainingWrapper) ||
          void 0 === e ||
          e.classList.remove(Rh, Nh, zh, _h),
        s && this.remainingWrapper && this.remainingJSON)
      ) {
        const t = this.remainingJSON[s.id];
        ("out" === t || t < 1) && this.remainingWrapper.classList.add(Nh),
          ("in" === t || t >= this.remainingMaxInt) &&
            this.remainingWrapper.classList.add(Rh),
          ("low" === t || (t > 0 && t < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.add(_h),
            this.remainingCount && (this.remainingCount.innerHTML = t));
      } else
        !s && this.remainingWrapper && this.remainingWrapper.classList.add(zh);
    }
    getBaseUnit(t) {
      return 1 === t.unit_price_measurement.reference_value
        ? t.unit_price_measurement.reference_unit
        : t.unit_price_measurement.reference_value +
            t.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container.querySelectorAll(bh).forEach((t) => {
        t.addEventListener(
          "change",
          function (t) {
            const e = t.target.value.toString(),
              s = this.container.querySelector(`[${wh}="${e}"]`),
              i = this.container.querySelectorAll(`[${wh}]`);
            if (s) {
              s.classList.remove(Fh);
              const t = s.querySelector('[name="selling_plan"]');
              (t.checked = !0), t.dispatchEvent(new Event("change"));
            }
            i.forEach((t) => {
              if (t !== s) {
                t.classList.add(Fh);
                t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                  (t.checked = !1), t.dispatchEvent(new Event("change"));
                });
              }
            });
          }.bind(this)
        );
      });
    }
    updateSaleText(t) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(t)
        : this.productState.onSale
        ? this.updateSaleTextStandard(t)
        : this.priceOffWrap && this.priceOffWrap.classList.add(Fh);
    }
    updateSaleTextStandard(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.variant,
          s = (e.compare_at_price - e.price) / e.compare_at_price,
          i = Math.floor(100 * s);
        (this.priceOffAmount.innerHTML = `${i}%`),
          this.priceOffWrap.classList.remove(Fh);
      }
    }
    updateSubscriptionText(t) {
      t.plan && this.planDescription
        ? ((this.planDescription.innerHTML = t.plan.detail.description),
          this.planDescription.classList.remove(Fh))
        : this.planDescription && this.planDescription.classList.add(Fh);
    }
    updateSaleTextSubscription(t) {
      if (
        (this.priceOffType &&
          (this.priceOffType.innerHTML =
            window.theme.strings.subscription || "subscripton"),
        this.priceOffAmount && this.priceOffWrap)
      ) {
        const e = t.plan.detail.price_adjustments[0],
          i = e.value;
        e && "percentage" === e.value_type
          ? (this.priceOffAmount.innerHTML = `${i}%`)
          : (this.priceOffAmount.innerHTML = s.formatMoney(
              i,
              theme.moneyFormat
            )),
          this.priceOffWrap.classList.remove(Fh);
      }
    }
    updateProductPrices(t) {
      const e = t.variant,
        i = t.plan;
      this.container.querySelectorAll(ah).forEach((t) => {
        const o = t.querySelector(ih),
          n = t.querySelector(hh),
          r = t.querySelector(oh);
        let a = "",
          l = "";
        this.productState.available &&
          ((a = e.compare_at_price), (l = e.price)),
          this.productState.hasPlan && (l = i.allocation.price),
          this.productState.planSale &&
            ((a = i.allocation.compare_at_price), (l = i.allocation.price)),
          o &&
            (this.productState.onSale || this.productState.planSale
              ? (o.classList.remove(Fh),
                r.classList.remove(Fh),
                n.classList.add($h))
              : (o.classList.add(Fh),
                r.classList.add(Fh),
                n.classList.remove($h)),
            (o.innerHTML = s.formatMoney(a, theme.moneyFormat))),
          (n.innerHTML =
            0 === l
              ? window.theme.strings.free
              : s.formatMoney(l, theme.moneyFormat));
      }),
        this.hasUnitPricing && this.updateProductUnits(t);
    }
    updateProductUnits(t) {
      const e = t.variant,
        i = t.plan;
      let o = null;
      if (
        (e && e.unit_price && (o = e.unit_price),
        i &&
          i.allocation &&
          i.allocation.unit_price &&
          (o = i.allocation.unit_price),
        o)
      ) {
        const t = this.getBaseUnit(e),
          i = s.formatMoney(o, theme.moneyFormat);
        (this.container.querySelector(dh).innerHTML = i),
          (this.container.querySelector(uh).innerHTML = t),
          Gt(this.container.querySelector(ph));
      } else Kt(this.container.querySelector(ph));
    }
    fireHookEvent(t) {
      const e = t.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant: e },
          bubbles: !0,
        })
      );
    }
    setProductState(t) {
      const e = t.variant,
        s = t.plan,
        i = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      return (
        !e || (e.requires_selling_plan && !s)
          ? (i.available = !1)
          : (e.available || (i.soldOut = !0),
            e.compare_at_price > e.price && (i.onSale = !0),
            e.unit_price && (i.showUnitPrice = !0),
            this.product &&
              this.product.requires_selling_plan &&
              (i.requiresPlan = !0),
            s &&
              this.subPrices &&
              ((i.hasPlan = !0),
              s.allocation.per_delivery_price !== s.allocation.price &&
                (i.planPerDelivery = !0),
              e.price > s.allocation.price && (i.planSale = !0))),
        i
      );
    }
    updateProductImage(t) {
      const e = t.dataset.variant;
      if (e && e.featured_media) {
        const t = this.container.querySelector(
            `[${Xh}="${e.featured_media.id}"]`
          ),
          s = null == t ? void 0 : t.closest(gh);
        if (s) {
          const e = Array.from(s.parentElement.children).indexOf(s),
            i = this.container.querySelector(lh),
            o = E();
          if (
            (i && i.classList.contains(vh)
              ? n.data(i).select(e)
              : i &&
                !o &&
                i.scrollTo({ top: 0, left: s.offsetLeft, behavior: "smooth" }),
            o && this.tallLayout)
          ) {
            const s = t.getBoundingClientRect().top;
            if (0 === e && s + window.scrollY > window.pageYOffset) return;
            document.dispatchEvent(
              new CustomEvent("theme:tooltip:close", {
                bubbles: !1,
                detail: { hideTransition: !1 },
              })
            ),
              wo(s);
          }
        }
      }
    }
    updateLegend(t) {
      const e = t.variant;
      if (e) {
        const t = this.container.querySelectorAll(Hh);
        t.length &&
          t.forEach((t) => {
            const s = t.closest(Mh);
            if (s) {
              const i = s.getAttribute(jh),
                o = parseInt(i, 10) - 1,
                n = e.options[o];
              t.innerHTML = n;
            }
          });
      }
    }
    constructor() {
      super();
    }
  };
  const Gh = "dialog",
    Yh = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    Kh = "[data-modal-open]",
    Zh = "[data-modal-close]",
    td = "closing";
  let ed = class extends HTMLElement {
      connectedCallback() {
        (this.modal = this.querySelector(Gh)),
          (this.buttonModalOpen = this.querySelector(Kh)),
          (this.buttonModalClose = this.querySelector(Zh)),
          (this.focusTarget =
            this.modal.querySelector("[autofocus]") ||
            this.modal.querySelector(Yh)),
          (this.isAnimating = !1),
          this.modalEvents();
      }
      modalOpen() {
        var t;
        "function" == typeof this.modal.showModal && this.modal.showModal(),
          this.modal.setAttribute("open", !0),
          this.modal.removeAttribute("inert"),
          null === (t = this.focusTarget) || void 0 === t || t.focus(),
          document.dispatchEvent(
            new CustomEvent("theme:modal:open", { bubbles: !0 })
          );
      }
      modalClose() {
        if (!this.isAnimating) {
          if (!this.modal.hasAttribute(td))
            return (
              this.modal.setAttribute(td, ""), void (this.isAnimating = !0)
            );
          "function" == typeof this.modal.close
            ? this.modal.close()
            : this.modal.removeAttribute("open"),
            this.modal.removeAttribute(td),
            this.modal.setAttribute("inert", "");
        }
      }
      modalEvents() {
        this.buttonModalOpen.addEventListener("click", (t) => {
          t.preventDefault(), this.modalOpen();
        }),
          this.buttonModalClose.addEventListener("click", (t) => {
            t.preventDefault(), this.modalClose();
          }),
          this.modal.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.modalClose();
          }),
          this.modal.addEventListener("keydown", (t) => {
            "Escape" == t.code && (t.preventDefault(), this.modalClose());
          }),
          this.modal.addEventListener("theme:modal:close", () => {
            this.modalClose();
          }),
          this.modal.addEventListener("animationend", (t) => {
            t.target === this.modal &&
              ((this.isAnimating = !1),
              this.modal.hasAttribute(td) && this.modalClose());
          });
      }
      constructor() {
        super();
      }
    },
    sd = class extends Qt {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  const id = "data-store-availability-container",
    od = ".shopify-section",
    nd = "[data-pickup-drawer]",
    rd = "[data-pickup-drawer-open]",
    ad = "[data-pickup-drawer-close]",
    ld = 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
    cd = "[data-section-type]",
    hd = "hidden",
    dd = "closing";
  let ud = class extends HTMLElement {
    connectedCallback() {
      (this.container = this.closest(cd)),
        (this.drawer = null),
        (this.buttonDrawerOpen = null),
        (this.buttonDrawerClose = null),
        (this.a11y = U),
        (this.isAnimating = !1),
        this.container.addEventListener("theme:variant:change", (t) =>
          this.fetchPickupAvailability(t)
        ),
        this.fetchPickupAvailability();
    }
    fetchPickupAvailability(t) {
      if (
        (t && !t.detail.variant) ||
        (t && t.detail.variant && !t.detail.variant.available)
      )
        return void this.classList.add(hd);
      const e =
        t && t.detail.variant ? t.detail.variant.id : this.getAttribute(id);
      e &&
        fetch(
          `${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`
        )
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((t) => {
            const e = new DOMParser()
              .parseFromString(t, "text/html")
              .querySelector(od).innerHTML;
            (this.innerHTML = e),
              (this.drawer = this.querySelector(nd)),
              this.drawer
                ? (this.classList.remove(hd), this.drawerEvents())
                : this.classList.add(hd);
          })
          .catch((t) => {
            console.error(t);
          });
    }
    openDrawer() {
      if (this.drawer) {
        "function" == typeof this.drawer.showModal && this.drawer.showModal(),
          this.drawer.setAttribute("open", !0),
          this.drawer.removeAttribute("inert"),
          this.drawer.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          );
        (
          this.drawer.querySelector("[autofocus]") ||
          this.drawer.querySelector(ld)
        ).focus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          );
      }
    }
    closeDrawer() {
      if (this.isAnimating) return;
      if (!this.drawer.hasAttribute(dd))
        return this.drawer.setAttribute(dd, ""), void (this.isAnimating = !0);
      "function" == typeof this.drawer.close
        ? this.drawer.close()
        : this.drawer.removeAttribute("open"),
        this.drawer.removeAttribute(dd),
        this.drawer.setAttribute("inert", "");
      document.querySelector("dialog[open]") ||
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    drawerEvents() {
      var t, e;
      null === (t = this.querySelector(rd)) ||
        void 0 === t ||
        t.addEventListener("click", () => {
          this.openDrawer(),
            (window.accessibility.lastElement = this.buttonDrawerOpen);
        }),
        null === (e = this.drawer.querySelector(ad)) ||
          void 0 === e ||
          e.addEventListener("click", (t) => {
            t.preventDefault(), this.closeDrawer();
          }),
        this.drawer.addEventListener("click", (t) => {
          "DIALOG" === t.target.nodeName &&
            "click" === t.type &&
            this.closeDrawer();
        }),
        this.drawer.addEventListener("keydown", (t) => {
          "Escape" === t.code && (t.preventDefault(), this.closeDrawer());
        }),
        this.drawer.addEventListener("animationend", (t) => {
          t.target === this.drawer &&
            ((this.isAnimating = !1),
            this.drawer.hasAttribute(dd) && this.closeDrawer());
        });
    }
    handleErrors(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new te({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    constructor() {
      super();
    }
  };
  const pd = {};
  function md(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return pd[t.url]
        ? pd[t.url]
        : (function (t, e) {
            const s = new Promise((s, i) => {
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      s(t);
                    })
                    .catch((t) => {
                      i(t);
                    })
                : (function (t, e, s) {
                    let i = document.getElementsByTagName("head")[0],
                      o = !1,
                      n = document.createElement("script");
                    (n.src = t),
                      (n.onload = n.onreadystatechange =
                        function () {
                          o ||
                          (this.readyState &&
                            "loaded" != this.readyState &&
                            "complete" != this.readyState)
                            ? s()
                            : ((o = !0), e());
                        }),
                      i.appendChild(n);
                  })(
                    t,
                    function () {
                      s();
                    },
                    function () {
                      i();
                    }
                  );
            });
            return (pd[t] = s), s;
          })(t.url, t.type);
    if (t.json)
      return pd[t.json]
        ? Promise.resolve(pd[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((pd[t.json] = e), e));
    if (t.name) {
      const e = "".concat(t.name, t.version);
      return pd[e]
        ? pd[e]
        : (function (t) {
            const e = "".concat(t.name, t.version),
              s = new Promise((e, s) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad: (t) => {
                        !(function (t, e, s) {
                          s ? e(s) : t();
                        })(e, s, t);
                      },
                    },
                  ]);
                } catch (t) {
                  s(t);
                }
              });
            return (pd[e] = s), s;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  const vd = ".pswp",
    gd = ".pswp__custom-close",
    fd = "iframe, video",
    yd = ".pswp__thumbs",
    bd = "is-current",
    wd = "pswp--custom-loader",
    Ed = "pswp--custom-opening",
    Sd = "pswp__loader",
    Ld = "is-focused",
    kd = "data-pswp-option-classes",
    Ad = "aria-current",
    Td = `<div class="${Sd}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
  let Cd = class {
    init() {
      this.pswpElement.classList.add(Ed),
        this.initLoader(),
        md({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((t) => console.error(t));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(wd) &&
        "" !== this.options &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(kd, this.options.mainClass);
        let t = document.createElement("div");
        (t.innerHTML = Td), (t = t.firstChild), this.pswpElement.appendChild(t);
      } else this.pswpElement.setAttribute(kd, "");
    }
    loadPopup() {
      const t = window.themePhotoswipe.PhotoSwipe.default,
        e = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.contains(wd) &&
        this.pswpElement.classList.remove(wd),
        this.pswpElement.classList.remove(Ed),
        (this.popup = new t(this.pswpElement, e, this.items, this.options)),
        this.popup.init(),
        this.thumbsActions(),
        document.body.classList.contains(Ld) &&
          setTimeout(() => {
            this.a11y.trapFocus(this.pswpElement, {
              elementToFocus: this.closeBtn,
            });
          }, 200),
        this.popup.listen("close", () => this.onClose()),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.addEventListener("keyup", this.keyupCloseEvent);
          });
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.children.length &&
        (this.popupThumbsContainer.addEventListener("wheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
          this.stopDisabledScroll(t)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
          this.stopDisabledScroll(t)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(`${yd} > *`)),
        this.popupThumbs.forEach((t, e) => {
          t.addEventListener("click", (s) => {
            s.preventDefault();
            const i = t.parentElement.querySelector(`.${bd}`);
            i.classList.remove(bd),
              i.setAttribute(Ad, !1),
              t.classList.add(bd),
              t.setAttribute(Ad, !0),
              this.popup.goTo(e);
          });
        }),
        this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
        this.popup.listen("beforeChange", () => this.setCurrentThumb()));
    }
    stopDisabledScroll(t) {
      t.stopPropagation();
    }
    keyupClose(t) {
      "Enter" === t.code && this.popup.close();
    }
    onClose() {
      const t = this.pswpElement.querySelector(fd);
      if (
        (t && t.parentNode.removeChild(t),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(kd, "");
      const e = this.pswpElement.querySelector(`.${Sd}`);
      e && this.pswpElement.removeChild(e),
        this.options &&
          this.options.closeElClasses &&
          this.options.closeElClasses.length &&
          this.options.closeElClasses.forEach((t) => {
            const e = this.pswpElement.querySelector(`.pswp__${t}`);
            e && e.removeEventListener("keyup", this.keyupCloseEvent);
          }),
        this.a11y.removeTrapFocus(),
        window.accessibility.lastElement &&
          document.body.classList.contains(Ld) &&
          requestAnimationFrame(() => {
            window.accessibility.lastElement.focus();
          });
    }
    setCurrentThumb() {
      const t = this.pswpElement.querySelector(`${yd} > .${bd}`);
      if (
        (t && (t.classList.remove(bd), t.setAttribute(Ad, !1)),
        !this.popupThumbs)
      )
        return;
      const e = this.popupThumbs[this.popup.getCurrentIndex()];
      e.classList.add(bd), e.setAttribute(Ad, !0), this.scrollThumbs(e);
    }
    scrollThumbs(t) {
      const e =
          this.popupThumbsContainer.scrollLeft +
          this.popupThumbsContainer.offsetWidth,
        s = t.offsetLeft;
      if (e <= s + t.offsetWidth || e > s) {
        const e = parseInt(window.getComputedStyle(t).marginLeft);
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: s - e,
          behavior: "smooth",
        });
      }
    }
    constructor(t, e = "") {
      (this.items = t),
        (this.pswpElement = document.querySelectorAll(vd)[0]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(yd)),
        (this.closeBtn = this.pswpElement.querySelector(gd)),
        (this.keyupCloseEvent = (t) => this.keyupClose(t)),
        (this.a11y = U);
      (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
        this.init();
    }
  };
  const qd = "[data-zoom-wrapper]",
    xd = "data-image-src",
    Pd = "data-image-width",
    Hd = "data-image-height",
    Md = "[data-pswp-thumbs-template]",
    Id = ".pswp__thumbs",
    Bd = "[data-zoom-caption]",
    Fd = "variant--soldout",
    Dd = "variant--unavailable",
    Od = "pswp-zoom-gallery",
    $d = "pswp-zoom-gallery--single",
    _d = "product__title",
    Rd = "product__title pswp__title";
  const Nd = "[data-add-to-cart]",
    zd = "[data-product-json]",
    Ud = "[data-product-form]",
    Wd = "data-section-id",
    Vd = "data-cart-bar",
    jd = "#cart-bar",
    Xd = "data-add-to-cart-bar",
    Jd = "data-cart-bar-scroll",
    Qd = ".product__submit__add",
    Gd = "[data-truncated-holder]",
    Yd = "[data-truncated-button]",
    Kd = "[data-truncated-content]",
    Zd = "data-truncated-content",
    tu = "[data-form-wrapper]",
    eu = "[data-product-variants]",
    su = "[data-slider]",
    iu = "data-slider-index",
    ou = "is-expanded",
    nu = "is-visible",
    ru = "is-loading",
    au = "data-image-zoom-enable",
    lu = {};
  const cu = {
    onLoad() {
      lu[this.id] = new (class {
        scrollEvents(t) {
          this.cartBarExist && this.cartBarScroll();
        }
        resizeEvents(t) {
          this.truncateText();
        }
        truncateText() {
          if (this.truncateElementHolder.classList.contains(nu)) return;
          const t = this.truncateElement.querySelectorAll("style");
          t.length &&
            t.forEach((t) => {
              this.truncateElementHolder.prepend(t);
            });
          const e = this.truncateElement.cloneNode(!0),
            s = this.truncateElement.getAttribute(Zd),
            i = this.truncateElement.nextElementSibling;
          i && i.remove(), this.truncateElement.parentElement.append(e);
          const o = this.truncateElement.nextElementSibling;
          o.classList.add(s),
            o.removeAttribute(Zd),
            Gt(o),
            ((t = "", e = 1, s = {}) => {
              const i = {
                  replaceStr: "...",
                  debounceDelay: 250,
                  delimiter: " ",
                  ...s,
                },
                o =
                  t &&
                  (t instanceof NodeList
                    ? t
                    : 1 === t.nodeType
                    ? [t]
                    : document.querySelectorAll(t));
              for (let t = 0; t < o.length; t++) {
                const s = o[t],
                  n = /<!--[\s\S]*?-->/g,
                  r = s.innerHTML.replace(n, "").split(i.delimiter);
                s.innerHTML = "";
                const a = window.getComputedStyle(s);
                r.reduce(Ec, {
                  el: s,
                  buffer: s.innerHTML,
                  elStyle: a,
                  elHeight: 0,
                  rowsLimit: e,
                  rowsWrapped: 0,
                  options: i,
                });
              }
            })(o, 5, { replaceStr: "", delimiter: " " }),
            Kt(o),
            this.truncateElement.innerHTML !== o.innerHTML
              ? this.truncateElementHolder.classList.add(ou)
              : (o.remove(), this.truncateElementHolder.classList.remove(ou)),
            this.toggleTruncatedContent(this.truncateElementHolder);
        }
        toggleTruncatedContent(t) {
          const e = t.querySelector(Yd);
          e &&
            e.addEventListener("click", (e) => {
              e.preventDefault(), t.classList.remove(ou), t.classList.add(nu);
            });
        }
        initCartBar() {
          (this.cartBarBtn = this.cartBar.querySelector(Qd)),
            this.cartBarBtn &&
              (this.cartBarBtn.addEventListener("click", (t) => {
                t.preventDefault(),
                  t.currentTarget.hasAttribute(Xd)
                    ? (theme.settings.cartDrawerEnabled &&
                        (t.currentTarget.classList.add(ru),
                        t.currentTarget.setAttribute("disabled", "disabled")),
                      this.form
                        .querySelector(Nd)
                        .dispatchEvent(new Event("click", { bubbles: !0 })))
                    : t.currentTarget.hasAttribute(Jd) && this.scrollToTop();
              }),
              this.cartBarBtn.hasAttribute(Xd) &&
                document.addEventListener(
                  "theme:product:add-error",
                  this.scrollToTop
                ));
        }
        scrollToTop() {
          const t = this.container.querySelector(eu),
            e = (E() ? this.container : t || this.form).getBoundingClientRect()
              .top;
          wo(E() ? e : e - 10);
        }
        cartBarScroll() {
          const t = window.pageYOffset,
            e =
              theme.variables.productPageSticky && this.formWrapper
                ? this.formWrapper
                : this.form;
          if (e && this.cartBar) {
            const s = t > e.offsetTop + e.offsetHeight;
            this.cartBar.classList.toggle(nu, s);
          }
        }
        onUnload() {
          document.removeEventListener(
            "theme:product:add-error",
            this.scrollToTop
          ),
            this.truncateElementHolder &&
              this.truncateElement &&
              document.removeEventListener("theme:resize", this.resizeEvent),
            this.cartBarExist &&
              document.removeEventListener("theme:scroll", this.scrollEvent);
        }
        onBlockSelect(t) {
          const e = t.srcElement.closest(su);
          if (e && this.slider.length) {
            const s = e.hasAttribute(iu) ? e.getAttribute(iu) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockSelect(t);
          }
        }
        onBlockDeselect(t) {
          const e = t.srcElement.closest(su);
          if (e && this.slider.length) {
            const s = e.hasAttribute(iu) ? e.getAttribute(iu) : 0;
            if (!this.slider[s]) return;
            this.slider[s].onBlockDeselect(t);
          }
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.id = this.container.getAttribute(Wd)),
            (this.sliders = this.container.querySelectorAll(su)),
            (this.slider = []),
            (this.truncateElementHolder = this.container.querySelector(Gd)),
            (this.truncateElement = this.container.querySelector(Kd)),
            (this.formWrapper = this.container.querySelector(tu)),
            (this.cartBarExist = "true" === this.container.getAttribute(Vd)),
            (this.cartBar = this.container.querySelector(jd)),
            (this.scrollToTop = this.scrollToTop.bind(this)),
            (this.scrollEvent = (t) => this.scrollEvents(t)),
            (this.resizeEvent = (t) => this.resizeEvents(t)),
            (this.unlockTimer = 0),
            (this.accessibility = U),
            this.container.hasAttribute(au) &&
              new (class {
                init() {
                  this.zoomWrappers.length &&
                    this.zoomWrappers.forEach((t, e) => {
                      t.addEventListener("click", (s) => {
                        s.preventDefault(),
                          this.createZoom(e),
                          (window.accessibility.lastElement = t);
                      }),
                        t.addEventListener("keyup", (s) => {
                          "Enter" === s.code &&
                            (s.preventDefault(),
                            this.createZoom(e),
                            (window.accessibility.lastElement = t));
                        });
                    });
                }
                createZoom(t) {
                  const e = this.container.querySelector(Md),
                    s = null == e ? void 0 : e.innerHTML;
                  let i = [],
                    o = 0;
                  this.zoomWrappers.forEach((e) => {
                    const n = e.getAttribute(xd);
                    (o += 1),
                      i.push({
                        src: n,
                        w: parseInt(e.getAttribute(Pd)),
                        h: parseInt(e.getAttribute(Hd)),
                        msrc: n,
                      }),
                      this.zoomWrappers.length === o &&
                        (new Cd(i, {
                          history: !1,
                          focus: !1,
                          index: t,
                          mainClass: 1 === o ? `${Od} ${$d}` : `${Od}`,
                          showHideOpacity: !0,
                          howAnimationDuration: 150,
                          hideAnimationDuration: 250,
                          closeOnScroll: !1,
                          closeOnVerticalDrag: !1,
                          captionEl: !0,
                          closeEl: !0,
                          closeElClasses: ["caption-close", "title"],
                          tapToClose: !1,
                          clickToCloseNonZoomable: !1,
                          maxSpreadZoom: 2,
                          loop: !0,
                          spacing: 0,
                          allowPanToNext: !0,
                          pinchToClose: !1,
                          addCaptionHTMLFn: (t, e, s) => {
                            this.zoomCaption(t, e, s);
                          },
                          getThumbBoundsFn: () => {
                            const e = this.zoomWrappers[t],
                              s =
                                window.pageYOffset ||
                                document.documentElement.scrollTop,
                              i = e.getBoundingClientRect();
                            return { x: i.left, y: i.top + s, w: i.width };
                          },
                        }),
                        this.thumbsContainer &&
                          "" !== s &&
                          (this.thumbsContainer.innerHTML = s));
                  });
                }
                zoomCaption(t, e) {
                  let s = "";
                  const i = e.children[0];
                  return (
                    this.zoomCaptionElem &&
                      ((s = this.zoomCaptionElem.innerHTML),
                      this.zoomCaptionElem.closest(`.${Fd}`)
                        ? i.classList.add(Fd)
                        : i.classList.remove(Fd),
                      this.zoomCaptionElem.closest(`.${Dd}`)
                        ? i.classList.add(Dd)
                        : i.classList.remove(Dd)),
                    (s = s.replaceAll(_d, Rd)),
                    (i.innerHTML = s),
                    !1
                  );
                }
                constructor(t) {
                  (this.container = t.container),
                    (this.zoomWrappers = this.container.querySelectorAll(qd)),
                    (this.thumbsContainer = document.querySelector(Id)),
                    (this.zoomCaptionElem = this.container.querySelector(Bd)),
                    this.init();
                }
              })(this.section),
            this.truncateElementHolder &&
              this.truncateElement &&
              (setTimeout(() => this.truncateText(), 50),
              document.addEventListener("theme:resize", this.resizeEvent));
          const e = this.container.querySelector(zd);
          if ((e && !e.innerHTML) || !e) return;
          const s = JSON.parse(e.innerHTML).handle;
          let i = {};
          s && (i = { handle: s }),
            Shopify.Products.recordRecentlyViewed(i),
            (this.form = this.container.querySelector(Ud)),
            this.sliders.length &&
              this.sliders.forEach((t, e) => {
                t.setAttribute(iu, e),
                  this.slider.push(new yo(this.container, t));
              }),
            this.cartBarExist &&
              (this.initCartBar(),
              document.addEventListener("theme:scroll", this.scrollEvent));
        }
      })(this);
    },
    onUnload(t) {
      lu[this.id].onUnload(t);
    },
    onBlockSelect(t) {
      lu[this.id].onBlockSelect(t);
    },
    onBlockDeselect(t) {
      lu[this.id].onBlockDeselect(t);
    },
  };
  Pi("product", [cu, Ui, Tl, _c, Yl]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", Tc),
    customElements.get("pickup-availability") ||
      customElements.define("pickup-availability", ud),
    customElements.get("product-form") ||
      customElements.define("product-form", Qh),
    customElements.get("product-modal") ||
      customElements.define("product-modal", ed),
    customElements.get("product-model") ||
      customElements.define("product-model", sd),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", al),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", Qa),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", Hc),
    customElements.get("share-button") ||
      customElements.define("share-button", Wc);
  const hu = "[data-api-related-template]",
    du = "[data-related-section]",
    uu = "[data-product-grid-item]",
    pu = "[data-recent-wrapper]",
    mu = "[data-recently-viewed-wrapper]",
    vu = ".product-item",
    gu = "[data-slider]",
    fu = "data-limit",
    yu = "data-minimum",
    bu = "data-product-id",
    wu = "is-hidden",
    Eu = {};
  Pi("related", [
    {
      onLoad() {
        Eu[this.id] = new (class {
          related() {
            const t = this.container.querySelector(du);
            if (!t) return;
            const e = t.getAttribute(bu),
              s = t.getAttribute(fu),
              i = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${s}&product_id=${e}&intent=related`;
            fetch(i)
              .then((t) => t.text())
              .then((e) => {
                const s = document.createElement("div");
                (s.innerHTML = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector(hu).innerHTML),
                  s.querySelector(uu)
                    ? ((t.innerHTML = s.innerHTML),
                      t.querySelectorAll(uu).length > 4 &&
                        t.querySelector(gu) &&
                        new yo(t))
                    : t.dispatchEvent(
                        new CustomEvent("theme:tab:hide", { bubbles: !0 })
                      );
              })
              .catch(function () {
                t.dispatchEvent(
                  new CustomEvent("theme:tab:hide", { bubbles: !0 })
                );
              });
          }
          recent() {
            const t = this.container.querySelector(pu),
              e = t ? parseInt(t.getAttribute(fu)) : 4;
            Shopify.Products.showRecentlyViewed({
              howManyToShow: e,
              wrapperId: `recently-viewed-products-${this.sectionId}`,
              section: this.section,
              onComplete: (t, e) => {
                const s = e.container,
                  i = s.querySelector(pu),
                  o = s.querySelector(mu),
                  n = t.querySelectorAll(vu),
                  r = i.hasAttribute(yu) ? parseInt(i.getAttribute(yu)) : 4,
                  a = !o && n.length > 0,
                  l = o && n.length >= r;
                (a || l) &&
                  (l && o.classList.remove(wu),
                  Zt(i),
                  i.dispatchEvent(
                    new CustomEvent("theme:tab:check", { bubbles: !0 })
                  ),
                  n.length > 4 && i.querySelector(gu) && new yo(i));
              },
            });
          }
          constructor(t) {
            (this.section = t),
              (this.sectionId = t.id),
              (this.container = t.container),
              this.related(),
              this.recent();
          }
        })(this);
      },
    },
    Tl,
  ]),
    Pi("reviews", [bo, oa]);
  const Su = {},
    Lu = "[data-slider-logos]",
    ku = "[data-slider-text]",
    Au = "[data-slide]",
    Tu = "[data-slide-index]",
    Cu = "is-selected",
    qu = "flickity-enabled",
    xu = "data-slide",
    Pu = "data-slide-index";
  Pi("logos", [
    {
      onLoad() {
        Su[this.id] = new (class {
          initSlideshowText() {
            if (!this.slideshowText) return;
            this.flkty = new n(this.slideshowText, {
              fade: !0,
              autoPlay: !1,
              prevNextButtons: !1,
              cellAlign: "left",
              contain: !0,
              pageDots: !1,
              wrapAround: !1,
              selectedAttraction: 0.2,
              friction: 0.6,
              draggable: !1,
              accessibility: !1,
              on: {
                ready: () => this.sliderAccessibility(),
                change: () => this.sliderAccessibility(),
              },
            });
            const t = this.slideshowText.querySelectorAll(Au);
            if (t.length) {
              let e = -1;
              t.forEach((t) => {
                const s = parseFloat(
                  getComputedStyle(t, null).height.replace("px", "")
                );
                s > e && (e = s);
              }),
                t.forEach((t) => {
                  const s = parseFloat(
                    getComputedStyle(t, null).height.replace("px", "")
                  );
                  if (s < e) {
                    const i = Math.ceil((e - s) / 2);
                    t.style.margin = `${i}px 0`;
                  }
                });
            }
          }
          sliderAccessibility() {
            const t = this.slideshowText.querySelectorAll(
              `${Au} a, ${Au} button`
            );
            t.length &&
              t.forEach((t) => {
                const e = t.closest(Au);
                if (e) {
                  const s = e.classList.contains(Cu) ? 0 : -1;
                  t.setAttribute("tabindex", s);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              ((this.logoSlides = this.slideshowNav.querySelectorAll(Tu)),
              this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    e.preventDefault();
                    const s = parseInt(t.getAttribute(Pu)),
                      i = this.slideshowNav.classList.contains(qu);
                    if ((this.flkty && this.flkty.select(s), i))
                      this.flktyNav.select(s),
                        this.slideshowNav.classList.contains(Cu) ||
                          this.flktyNav.playPlayer();
                    else {
                      const e = this.slideshowNav.querySelector(`.${Cu}`);
                      e && e.classList.remove(Cu), t.classList.add(Cu);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            const t = this.slideshowNav.querySelectorAll(Au),
              e = 200 * t.length,
              s = this.slideshowNav.classList.contains(qu);
            if (e > b()) {
              if (!s) {
                const e = this.slideshowNav.querySelector(`.${Cu}`);
                e && e.classList.remove(Cu),
                  t[0].classList.add(Cu),
                  (this.flktyNav = new o(this.slideshowNav, {
                    autoPlay: 4e3,
                    prevNextButtons: !1,
                    contain: !1,
                    pageDots: !1,
                    wrapAround: !0,
                    watchCSS: !0,
                    selectedAttraction: 0.05,
                    friction: 0.8,
                    initialIndex: 0,
                  })),
                  this.flkty &&
                    (this.flkty.select(0),
                    this.flktyNav.on("change", (t) => this.flkty.select(t)));
              }
            } else
              s &&
                (this.flktyNav.destroy(),
                t[0].classList.add(Cu),
                this.flkty && this.flkty.select(0));
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            const e = this.slideshowNav.querySelector(
                `[${xu}="${t.detail.blockId}"]`
              ),
              s = parseInt(e.getAttribute(Pu));
            this.slideshowNav.classList.contains(qu)
              ? (this.flktyNav.select(s),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(Cu))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(qu) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(Cu));
          }
          onUnload() {
            this.slideshowNav &&
              (this.slideshowNav.classList.contains(qu) &&
                this.flktyNav.destroy(),
              this.flkty && this.flkty.destroy(),
              document.removeEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(Lu)),
              (this.slideshowText = this.container.querySelector(ku)),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        Su[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        Su[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        Su[this.id].onBlockDeselect(t);
      },
    },
    oa,
  ]);
  const Hu = "data-video-play";
  let Mu = class extends HTMLElement {
    connectedCallback() {
      var t;
      (this.videoPlay = this.querySelectorAll(`[${Hu}]`)),
        null === (t = this.videoPlay) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("click", (t) => {
              const e = t.currentTarget;
              if ("" !== e.getAttribute(Hu).trim()) {
                t.preventDefault();
                const s = [{ html: e.getAttribute(Hu) }];
                new Cd(s), (window.accessibility.lastElement = e);
              }
            });
          });
    }
    constructor() {
      super();
    }
  };
  const Iu = "[data-video-template]",
    Bu = "is-loading",
    Fu = "data-video-id";
  let Du = class extends HTMLElement {
    connectedCallback() {
      (this.videoId = this.getAttribute(Fu)),
        (this.videoTemplate = this.querySelector(Iu)),
        (this.video = null),
        this.videoId &&
          (this.addEventListener(
            "touchstart",
            () => {
              var t;
              null === (t = this.video) || void 0 === t || t.play();
            },
            { passive: !0 }
          ),
          this.renderVideo());
    }
    renderVideo() {
      (this.videoTemplateObserver = new IntersectionObserver(
        (t, e) => {
          t.forEach((t) => {
            if (t.isIntersecting) {
              const s = this.videoTemplate.innerHTML;
              (this.innerHTML = s),
                this.classList.remove(Bu),
                (this.video = this.querySelector("video")),
                this.observeVideoPlayToggle(),
                e.unobserve(t.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      )),
        this.videoTemplateObserver.observe(this);
    }
    observeVideoPlayToggle() {
      if (!this.video) return;
      (this.videoPlayObserver = new IntersectionObserver(
        (t) => {
          t.forEach((t) => {
            const e = t.isIntersecting;
            e && "function" == typeof this.video.play && this.video.play(),
              e || "function" != typeof this.video.pause || this.video.pause();
          });
        },
        { rootMargin: "0px", threshold: [0, 1] }
      )),
        this.videoPlayObserver.observe(this.video);
    }
    disconnectedCallback() {
      this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
        this.videoPlayObserver && this.videoPlayObserver.disconnect();
    }
    constructor() {
      super();
    }
  };
  Pi("featured-video", [Vi]),
    customElements.get("video-background") ||
      customElements.define("video-background", Du),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Mu),
    Pi("slideshow", [bo, Vi]);
  const Ou = "[data-images-holder]",
    $u = "[data-image-holder]",
    _u = "[data-image-element]",
    Ru = "[data-images-button]",
    Nu = "data-start-position",
    zu = {};
  const Uu = {
    onLoad() {
      zu[this.id] = [];
      this.container.querySelectorAll(Ou).forEach((t) => {
        zu[this.id].push(
          new (class {
            init() {
              this.changeValues(),
                this.imagesButton.addEventListener(
                  "mousedown",
                  this.onStartEvent
                ),
                this.imagesButton.addEventListener(
                  "touchstart",
                  this.onStartEvent,
                  { passive: !0 }
                );
            }
            changeValues(t) {
              const e = this.imagesHolder.offsetWidth,
                s = this.imagesButton.offsetWidth;
              if (
                (!t ||
                  (t && "touchmove" !== t.type && "mousemove" !== t.type)) &&
                ((this.imageElement.style.width = `${e}px`),
                (this.imageHolder.style.width =
                  100 - parseInt(this.startPosition) + "%"),
                0 !== this.startPosition)
              ) {
                const t = (e * parseInt(this.startPosition)) / 100;
                this.x = t - s / 2;
              }
              this.x > e - s ? (this.x = e - s) : this.x < 0 && (this.x = 0),
                (this.imagesButton.style.left = (this.x / e) * 100 + "%"),
                (this.imageHolder.style.width =
                  100 - ((this.x + s / 2) / e) * 100 + "%");
            }
            onStart(t) {
              t.preventDefault();
              let e = t;
              t.touches && (e = t.touches[0]),
                (this.x = this.imagesButton.offsetLeft),
                (this.startX = e.pageX - this.x),
                this.imagesHolder.addEventListener(
                  "mousemove",
                  this.onMoveEvent
                ),
                this.imagesHolder.addEventListener("mouseup", this.onStopEvent),
                this.imagesHolder.addEventListener(
                  "touchmove",
                  this.onMoveEvent
                ),
                this.imagesHolder.addEventListener(
                  "touchend",
                  this.onStopEvent
                );
            }
            onMove(t) {
              let e = t;
              t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.changeValues(t);
            }
            onStop(t) {
              this.imagesHolder.removeEventListener(
                "mousemove",
                this.onMoveEvent
              ),
                this.imagesHolder.removeEventListener(
                  "mouseup",
                  this.onStopEvent
                ),
                this.imagesHolder.removeEventListener(
                  "touchmove",
                  this.onMoveEvent
                ),
                this.imagesHolder.removeEventListener(
                  "touchend",
                  this.onStopEvent
                );
            }
            onUnload() {
              this.changeValuesEvent &&
                document.removeEventListener(
                  "theme:resize",
                  this.changeValuesEvent
                );
            }
            constructor(t) {
              (this.imagesHolder = t),
                this.imagesHolder &&
                  ((this.imageHolder = this.imagesHolder.querySelector($u)),
                  (this.imageElement = this.imagesHolder.querySelector(_u)),
                  (this.imagesButton = this.imagesHolder.querySelector(Ru)),
                  (this.startPosition = this.imagesHolder.hasAttribute(Nu)
                    ? this.imagesHolder.getAttribute(Nu)
                    : 0),
                  (this.startX = 0),
                  (this.x = 0),
                  (this.changeValuesEvent = (t) => this.changeValues(t)),
                  (this.onMoveEvent = (t) => this.onMove(t)),
                  (this.onStopEvent = (t) => this.onStop(t)),
                  (this.onStartEvent = (t) => this.onStart(t)),
                  this.init(),
                  document.addEventListener(
                    "theme:resize",
                    this.changeValuesEvent
                  ));
            }
          })(t)
        );
      });
    },
    onUnload() {
      zu[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  Pi("custom-content", [bo, Vi, Uu, Po]),
    customElements.get("video-background") ||
      customElements.define("video-background", Du),
    customElements.get("video-popup") ||
      customElements.define("video-popup", Mu);
  var Wu = {};
  function Vu(t) {
    return Wu[t];
  }
  (Wu.basic = []),
    (Wu.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (Wu.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (Wu.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let ju = window.theme.allMaps;
  window.theme.mapAPI = window.theme.mapAPI || null;
  Pi("map", {
    onLoad() {
      ju[this.id] = new (class {
        initMaps() {
          (function (t) {
            if (null === window.theme.mapAPI) {
              const e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
              window.theme.mapAPI = md({ url: e });
            }
            return window.theme.mapAPI;
          })(this.key)
            .then(() => {
              return "true" === this.enableCorrection &&
                "" !== this.lat &&
                "" !== this.long
                ? new google.maps.LatLng(this.lat, this.long)
                : ((t = this.address),
                  new Promise((e, s) => {
                    new google.maps.Geocoder().geocode(
                      { address: t },
                      function (t, i) {
                        if ("OK" == i) {
                          var o = {
                            lat: t[0].geometry.location.lat(),
                            lng: t[0].geometry.location.lng(),
                          };
                          e(o);
                        } else s(i);
                      }
                    );
                  }));
              var t;
            })
            .then((t) => {
              const e = {
                  zoom: parseInt(this.zoomString, 10),
                  styles: Vu(this.styleString),
                  center: t,
                  draggable: !0,
                  clickableIcons: !1,
                  scrollwheel: !1,
                  zoomControl: !1,
                  disableDefaultUI: !0,
                },
                s = (function (t, e) {
                  var s = new google.maps.Map(t, e),
                    i = s.getCenter();
                  return (
                    new google.maps.Marker({ map: s, position: i }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(s, "resize"), s.setCenter(i);
                      }
                    ),
                    s
                  );
                })(this.mapContainer, e);
              return s;
            })
            .then((t) => {
              (this.map = t), (ju[this.id] = t);
            })
            .catch((t) => {
              console.log("Failed to load Google Map"), console.log(t);
            });
        }
        unload() {
          void 0 !== window.google &&
            google.maps.event.clearListeners(this.map, "resize");
        }
        constructor(t) {
          (this.container = t.container),
            (this.mapContainer = this.container.querySelector(
              "[data-map-container]"
            )),
            (this.key = this.container.getAttribute("data-api-key")),
            (this.styleString =
              this.container.getAttribute("data-style") || ""),
            (this.zoomString = this.container.getAttribute("data-zoom") || 14),
            (this.address = this.container.getAttribute("data-address")),
            (this.enableCorrection = this.container.getAttribute(
              "data-latlong-correction"
            )),
            (this.lat = this.container.getAttribute("data-lat")),
            (this.long = this.container.getAttribute("data-long")),
            this.key && this.initMaps();
        }
      })(this);
    },
    onUnload() {
      "function" == typeof ju[this.id].unload && ju[this.id].unload();
    },
  });
  const Xu = (t, e = null) => {
      (t.style.opacity = 1),
        (function s() {
          (t.style.opacity -= 0.1) < 0
            ? (t.style.display = "none")
            : requestAnimationFrame(s),
            0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
        })();
    },
    Ju = "[data-large-promo]",
    Qu = "[data-large-promo-inner]",
    Gu = "[data-tracking-consent]",
    Yu = "[data-confirm-cookies]",
    Ku = "cart-bar",
    Zu = "[data-close-modal]",
    tp = "[data-modal-underlay]",
    ep = "[data-newsletter]",
    sp = "[data-newsletter-holder]",
    ip = "[data-newsletter-close]",
    op = "[data-newsletter-heading]",
    np = "[data-newsletter-field]",
    rp = "[data-promo-text]",
    ap = "[data-newsletter-form]",
    lp = "data-popup-delay",
    cp = "data-cookie-name",
    hp = "data-target-referrer",
    dp = "hidden",
    up = "has-value",
    pp = "cart-bar-visible",
    mp = "is-visible",
    vp = "has-success",
    gp = "selected",
    fp = "has-block-selected",
    yp = "mobile",
    bp = "desktop",
    wp = "bottom",
    Ep = "data-enable";
  let Sp = {},
    Lp = class {
      always() {
        Zt(this.element, null, this.callback);
      }
      delayed(t = 10) {
        setTimeout(() => {
          Zt(this.element, null, this.callback);
        }, 1e3 * t);
      }
      idle() {
        let t = 0;
        const e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          s = ["load", "resize", "scroll"],
          i = () => {
            (t = setTimeout(() => {
              (t = 0), Zt(this.element, null, this.callback);
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, o);
              }),
              s.forEach((t) => {
                window.addEventListener(t, o);
              });
          },
          o = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, o);
              }),
              s.forEach((t) => {
                window.removeEventListener(t, o);
              }),
              i();
          };
        i();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (Zt(this.element, null, this.callback),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, s = null) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute(lp)),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.callback = s),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          const t = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(t);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    kp = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(hp)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(hp))
        )
          return !1;
        this.init();
      }
    };
  const Ap = {
    onLoad() {
      Sp[this.id] = [];
      this.container.querySelectorAll(Ju).forEach((t) => {
        Sp[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e = this.popup.classList.contains(yp),
                s = this.popup.classList.contains(bp),
                i = !E();
              let o = !0;
              ((e && !i) || (s && i)) && (o = !1),
                o
                  ? (t && !window.Shopify.designMode) ||
                    (window.Shopify.designMode ||
                      new Lp(this.popup, this.modal, () => this.scrollLock()),
                    this.form &&
                      this.form.classList.contains(vp) &&
                      this.checkForSuccess(),
                    this.initClosers())
                  : this.scrollUnlock();
            }
            checkForSuccess() {
              Zt(this.modal, null, () => this.scrollLock()),
                this.cookie.write();
            }
            initClosers() {
              this.close.addEventListener("click", this.closeModal.bind(this)),
                this.underlay.addEventListener(
                  "click",
                  this.closeModal.bind(this)
                );
            }
            closeModal(t) {
              t.preventDefault(),
                Xu(this.modal),
                this.cookie.write(),
                this.scrollUnlock();
            }
            scrollLock() {
              "none" !== window.getComputedStyle(this.popup).display &&
                (this.a11y.trapFocus(this.modal),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
            }
            scrollUnlock() {
              this.a11y.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (Zt(this.modal, null, () => this.scrollLock()),
                this.popup.classList.add(gp),
                this.popup.parentNode.classList.add(fp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (Xu(this.modal),
                this.scrollUnlock(),
                this.popup.classList.remove(gp),
                this.popup.parentNode.classList.remove(fp));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = this.popup.querySelector(Qu)),
                (this.close = this.popup.querySelector(Zu)),
                (this.underlay = this.popup.querySelector(tp)),
                (this.form = this.popup.querySelector(ap)),
                (this.cookie = new Eo(
                  this.popup.getAttribute(cp),
                  "user_has_closed"
                )),
                (this.isTargeted = new kp(this.popup)),
                (this.a11y = U),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(Gu).forEach((t) => {
        Sp[this.id].push(
          new (class {
            init() {
              this.showPopup && Zt(this.modal), this.clickEvents();
            }
            clickEvents() {
              this.acceptButton.addEventListener("click", (t) => {
                t.preventDefault(),
                  window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
                    Xu(this.modal)
                  ),
                  document.documentElement.style.setProperty(
                    "--cookie-bar-height",
                    "0px"
                  );
              }),
                document.addEventListener("trackingConsentAccepted", () => {});
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                this.showPopup &&
                (Zt(this.modal),
                this.popup.classList.add(gp),
                this.popup.parentNode.classList.add(fp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (Xu(this.modal),
                this.popup.classList.remove(gp),
                this.popup.parentNode.classList.remove(fp));
            }
            constructor(t) {
              (this.popup = t),
                (this.modal = document.querySelector(Gu)),
                (this.acceptButton = this.modal.querySelector(Yu)),
                (this.enable = "true" === this.modal.getAttribute(Ep)),
                (this.showPopup = !1),
                window.Shopify.loadFeatures(
                  [{ name: "consent-tracking-api", version: "0.1" }],
                  (t) => {
                    if (t) throw t;
                    const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                      s = window.Shopify.customerPrivacy.getTrackingConsent();
                    (this.showPopup =
                      !e && "no_interaction" === s && this.enable),
                      window.Shopify.designMode && (this.showPopup = !0),
                      this.init();
                  }
                );
            }
          })(t)
        );
      });
      this.container.querySelectorAll(ep).forEach((t) => {
        Sp[this.id].push(
          new (class {
            init() {
              const t = !1 !== this.cookie.read(),
                e =
                  -1 !==
                  window.location.search.indexOf("?customer_posted=true"),
                s = [...this.holder.classList].toString().includes(wp);
              e && (this.delay = 0),
                (t && !window.Shopify.designMode) ||
                  (this.show(),
                  this.form.classList.contains(vp) && this.checkForSuccess()),
                s && this.observeCartBar();
            }
            show() {
              window.Shopify.designMode
                ? Zt(this.holder)
                : new Lp(this.popup, this.holder),
                this.showForm(),
                this.inputField(),
                this.closePopup();
            }
            checkForSuccess() {
              Zt(this.holder), this.cookie.write();
            }
            observeCartBar() {
              if (((this.cartBar = document.getElementById(Ku)), !this.cartBar))
                return;
              let t = this.cartBar.classList.contains(mp);
              document.body.classList.toggle(pp, t),
                (this.observer = new MutationObserver((e) => {
                  for (const s of e)
                    "attributes" === s.type &&
                      ((t = s.target.classList.contains(mp)),
                      document.body.classList.toggle(pp, t));
                })),
                this.observer.observe(this.cartBar, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                });
            }
            showForm() {
              this.heading.addEventListener("click", (t) => {
                t.preventDefault(),
                  this.heading.classList.add(dp),
                  this.form.classList.remove(dp),
                  this.newsletterField.focus();
              }),
                this.heading.addEventListener("keyup", (t) => {
                  "Enter" === t.code &&
                    this.heading.dispatchEvent(new Event("click"));
                });
            }
            closePopup() {
              this.close.addEventListener("click", (t) => {
                t.preventDefault(), Xu(this.holder), this.cookie.write();
              });
            }
            inputField() {
              const t = () => {
                this.resetClassTimer && clearTimeout(this.resetClassTimer),
                  "" !== this.newsletterField.value &&
                    this.holder.classList.add(up);
              };
              this.newsletterField.addEventListener("input", t),
                this.newsletterField.addEventListener("focus", t),
                this.newsletterField.addEventListener("focusout", () => {
                  this.resetClassTimer && clearTimeout(this.resetClassTimer),
                    (this.resetClassTimer = setTimeout(() => {
                      this.holder.classList.remove(up);
                    }, 2e3));
                });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (Zt(this.holder),
                this.popup.classList.add(gp),
                this.popup.parentNode.classList.add(fp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (Xu(this.holder),
                this.popup.classList.remove(gp),
                this.popup.parentNode.classList.remove(fp));
            }
            onUnload() {
              this.observer && this.observer.disconnect();
            }
            constructor(t) {
              (this.popup = t),
                (this.holder = this.popup.querySelector(sp)),
                (this.close = this.popup.querySelector(ip)),
                (this.heading = this.popup.querySelector(op)),
                (this.newsletterField = this.popup.querySelector(np)),
                (this.cookie = new Eo(
                  this.popup.getAttribute(cp),
                  "newsletter_is_closed"
                )),
                (this.form = this.popup.querySelector(ap)),
                (this.isTargeted = new kp(this.popup)),
                (this.resetClassTimer = 0),
                this.init();
            }
          })(t)
        );
      });
      this.container.querySelectorAll(rp).forEach((t) => {
        Sp[this.id].push(
          new (class {
            init() {
              (!1 !== this.cookie.read() && !window.Shopify.designMode) ||
                (window.Shopify.designMode
                  ? Zt(this.popup)
                  : new Lp(this.popup, this.popup),
                this.clickEvents());
            }
            clickEvents() {
              this.close.addEventListener("click", (t) => {
                t.preventDefault(), Xu(this.popup), this.cookie.write();
              });
            }
            onBlockSelect(t) {
              this.popup.contains(t.target) &&
                (Zt(this.popup),
                this.popup.classList.add(gp),
                this.popup.parentNode.classList.add(fp));
            }
            onBlockDeselect(t) {
              this.popup.contains(t.target) &&
                (Xu(this.popup),
                this.popup.classList.remove(gp),
                this.popup.parentNode.classList.remove(fp));
            }
            constructor(t) {
              (this.popup = t),
                (this.close = this.popup.querySelector(Zu)),
                (this.cookie = new Eo(
                  this.popup.getAttribute(cp),
                  "user_has_closed"
                )),
                (this.isTargeted = new kp(this.popup)),
                this.init();
            }
          })(t)
        );
      });
    },
    onBlockSelect(t) {
      Sp[this.id].forEach((e) => {
        "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
      });
    },
    onBlockDeselect(t) {
      Sp[this.id].forEach((e) => {
        "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
      });
    },
    onUnload() {
      Sp[this.id].forEach((t) => {
        "function" == typeof t.onUnload && t.onUnload();
      });
    },
  };
  Pi("popups", [Ap, Po]);
  const Tp = "[data-password-login]",
    Cp = "[data-password-modal]",
    qp = "[data-modal-body]",
    xp = "[data-modal-close]",
    Pp = "#login_form .errors",
    Hp = "is-open";
  Pi("password-template", {
    onLoad() {
      new (class {
        init() {
          this.passwordLogin.length &&
            this.modal &&
            this.modalBody &&
            (this.passwordLogin.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(), this.openModal();
              });
            }),
            this.closeButtons.length &&
              this.closeButtons.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(), this.closeModal();
                });
              }),
            this.loginErrors && this.openModal());
        }
        openModal() {
          Zt(this.modal, "block", () => {
            this.modal.classList.add(Hp);
          }),
            this.scrollLock();
        }
        closeModal() {
          Xu(this.modal), this.modal.classList.remove(Hp), this.scrollUnlock();
        }
        scrollLock() {
          "none" !== window.getComputedStyle(this.modal).display &&
            (this.a11y.trapFocus(this.modal),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            ));
        }
        scrollUnlock() {
          this.a11y.removeTrapFocus(),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
        }
        constructor(t) {
          (this.container = t.container),
            (this.passwordLogin = this.container.querySelectorAll(Tp)),
            (this.modal = this.container.querySelector(Cp)),
            (this.modalBody = this.container.querySelector(qp)),
            (this.closeButtons = this.container.querySelectorAll(xp)),
            (this.a11y = U),
            (this.loginErrors = this.container.querySelector(Pp)),
            this.init();
        }
      })(this);
    },
  }),
    Pi("list-collections", [bo, oa]),
    Pi("columns", [oa, bo]),
    Pi("newsletter", Po),
    Pi("before-after", [Uu]);
  const Mp = "[data-scroll-to]",
    Ip = "[data-tooltip]",
    Bp = "[data-collapsible-trigger]",
    Fp = "open",
    Dp = "data-scroll-to",
    Op = "data-tooltip-stop-mouseenter",
    $p = {};
  const _p = {
      onLoad() {
        $p[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                const e = this.container.querySelector(t.getAttribute(Dp));
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            wo(t.getBoundingClientRect().top + 1);
            const e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              const t = null == e ? void 0 : e.querySelector(Bp);
              e.hasAttribute(Fp) ||
                null == t ||
                t.dispatchEvent(new Event("click"));
            }
            const s = document.querySelectorAll(`${Ip}:not([${Op}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(Op, ""),
                  setTimeout(() => {
                    t.removeAttribute(Op);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons = this.container.querySelectorAll(Mp)),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    Rp = "[data-scroll-spy]",
    Np = "is-selected",
    zp = "data-scroll-spy",
    Up = "data-scroll-spy-mobile",
    Wp = "data-scroll-spy-desktop",
    Vp = {};
  const jp = {
    onLoad() {
      Vp[this.id] = new (class {
        init() {
          this.loopAnchors(),
            document.addEventListener("theme:resize:width", this.loopAnchors);
        }
        loopAnchors() {
          this.scrollSpyAnchors.length &&
            this.scrollSpyAnchors.forEach((t) => {
              this.toggleObserver(t);
            });
        }
        toggleObserver(t) {
          const e = this.container.querySelector(t.getAttribute(zp));
          if (!e) return;
          this.observers[e.id] && this.observers[e.id].unobserve(e);
          const s = E();
          ((!s && t.hasAttribute(Up)) ||
            (s && t.hasAttribute(Wp)) ||
            (!t.hasAttribute(Wp) && !t.hasAttribute(Up))) &&
            this.runObserver(e);
        }
        runObserver(t) {
          let { stickyHeaderHeight: e } = c();
          const s = {
            rootMargin: -1 * e + "px 0px 0px 0px",
            threshold: [0.5, 1],
          };
          (this.observers[t.id] = new IntersectionObserver((t) => {
            t.forEach((t) => {
              const s = this.container.querySelector(`[${zp}].${Np}`),
                i = this.container.querySelector(`[${zp}="#${t.target.id}"]`);
              t.intersectionRatio > 0.5 &&
                t.boundingClientRect.top - e <= t.boundingClientRect.height &&
                (null == s || s.classList.remove(Np),
                null == i || i.classList.add(Np));
            });
          }, s)),
            this.observers[t.id].observe(t);
        }
        onUnload() {
          document.removeEventListener("theme:resize:width", this.loopAnchors),
            this.observers.length &&
              this.observers.forEach((t) => {
                t.disconnect();
              });
        }
        constructor(t) {
          (this.section = t),
            (this.container = t.container),
            (this.scrollSpyAnchors = this.container.querySelectorAll(Rp)),
            (this.loopAnchors = this.loopAnchors.bind(this)),
            (this.observers = []),
            this.init();
        }
      })(this);
    },
    onUnload() {
      Vp[this.id].onUnload();
    },
  };
  Pi("sidebar", [_p, jp]);
  const Xp = "[data-hover-target]",
    Jp = "[data-collection-image]",
    Qp = "data-hover-target",
    Gp = "is-visible",
    Yp = "is-selected";
  let Kp = {};
  Pi("collections-hover", [
    {
      onLoad() {
        Kp[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  const e = t.currentTarget.getAttribute(Qp);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            const e = this.container.querySelector(`[${Qp}="${t}"]`),
              s = this.container.querySelector(`#${t}:not(.${Gp})`),
              i = this.container.querySelector(`${Xp}.${Yp}`),
              o = this.container.querySelector(`${Jp}.${Gp}`);
            s &&
              E() &&
              (null == o || o.classList.remove(Gp),
              null == i || i.classList.remove(Yp),
              s.classList.add(Gp),
              e.classList.add(Yp));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(Xp)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        Kp[this.id].onBlockSelect(t);
      },
    },
    jp,
  ]);
  const Zp = "[data-featured-image]",
    tm = "[data-featured-aside]",
    em = "[data-featured-content]",
    sm = "[data-featured-wrapper]",
    im = "data-horizontal-scroll",
    om = "data-horizontal-scroll-reversed",
    nm = {};
  Pi("featured-product", [
    {
      onLoad() {
        nm[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              ((this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              )),
              document.addEventListener("theme:scroll", this.scrollEvent)),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          scrollEvents() {
            this.requestAnimationSticky ||
              (this.requestAnimationSticky = requestAnimationFrame(
                this.calculateHorizontalPositionEvent
              ));
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null));
          }
          calculateHorizontalPosition() {
            let t = window.pageYOffset + this.headerHeight;
            const e = t + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              i = this.imagesHolder.offsetHeight,
              o = s + i + this.headerHeight,
              n = i - (window.innerHeight - this.headerHeight),
              r = this.horizontalScrollReversed ? 1 : -1;
            let a = 0;
            (a = t >= s && e <= o ? ((t - s) / n) * 100 : t < s ? 0 : 100),
              (a *= this.images.length - 1),
              this.container.style.setProperty("--translateX", a * r + "%"),
              this.lastPercent !== a
                ? (this.requestAnimationSticky = requestAnimationFrame(
                    this.calculateHorizontalPositionEvent
                  ))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.lastPercent = a);
          }
          calculateHeight() {
            let { stickyHeaderHeight: t } = c();
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = t);
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(im)),
              (this.horizontalScrollReversed = this.container.hasAttribute(om)),
              (this.images = this.container.querySelectorAll(Zp)),
              (this.imagesHolder = this.container.querySelector(tm)),
              (this.contentHolder = this.container.querySelector(em)),
              (this.wrapper = this.container.querySelector(sm)),
              (this.requestAnimationSticky = null),
              (this.lastPercent = 0),
              (this.scrollEvent = () => this.scrollEvents()),
              (this.calculateHorizontalPositionEvent = () =>
                this.calculateHorizontalPosition()),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        nm[this.id].onUnload(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      Hi("*");
      const t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle(
            "is-visible",
            window.pageYOffset > window.innerHeight
          );
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          md({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
);
